// Load upsell data from JSON for cart popup logic
const upsellDataElement = document.getElementById('upsell-data');
window.upsellData = upsellDataElement ? JSON.parse(upsellDataElement.textContent) : [];

// which gift wrapping system to use
const useNewGiftWrapping = document.body.getAttribute('data-use-new-gift-wrapping-system') === 'true';

// CART DRAWER'S SUPPORTING MODULES

// ======================================================================
// CART DATA MODULE
// Centralizes all cart reads, subtotal calculation and add-on detection
// ======================================================================
window.CartData = {
  cart: null,
  lastUpdated: 0,
  ttl: 2000, // ms — increased to 2s to support initialization burst without duplicate fetches

  async getCart(force = false) {
    const now = Date.now();

    if (!force && this.cart && now - this.lastUpdated < this.ttl) {
      return this.cart;
    }

    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });

    if (!res.ok) {
      console.error('[CartData] fetch failed:', res.status);
      return this.cart || { items: [], total_price: 0 };
    }

    this.cart = await res.json();
    this.lastUpdated = now;
    return this.cart;
  },

  // Invalidate cache - we call this after cart mutations (add/remove/change)
  // so that next getCart() fetches fresh data
  invalidate() {
    this.lastUpdated = 0;
    // console.log('[CartData] Cache invalidated');
  },

  // ----------------------------------------------------
  // "Base subtotal": excludes add-ons, free gifts, deferred payments.
  // To unify subtotal calculations across different modules.
  // ----------------------------------------------------
  async getBaseSubtotal(force = false) {
    const cart = await this.getCart(force);
    let subtotal = 0;

    cart.items.forEach(item => {
      const p = item.properties || {};

      const isAddon =
        p._addOn === true ||
        p._addOn === 'true';

      const isFreeGift = p._freeGift === 'true';
      const isDeferred = p._deferredPayment === true || p._deferredPayment === 'true';

      if (!isAddon && !isFreeGift && !isDeferred) {
        subtotal += item.line_price;
      }
    });

    return subtotal;
  },

  isVariantInCart(cart, variantId) {
    return cart.items.find(item =>
      item.variant_id.toString() === variantId.toString()
    );
  },

  findAddonVariant(cart, variantId) {
    return cart.items.find(item =>
      item.variant_id.toString() === variantId.toString() &&
      (item.properties?._addOn === true || item.properties?._addOn === 'true')
    );
  }
};


// ======================================================================
// CART INITIALIZATION - SINGLE SOURCE OF TRUTH
// Preloads cart data once before any modules initialize to prevent
// duplicate /cart.js requests on page load
// ======================================================================
(async function initializeCart() {
  // Only run on pages where cart drawer exists
  if (!document.querySelector('#CartDrawer')) {
    window.__cartInitialized = true;
    return;
  }
  
  try {
    // Fetch cart ONCE before any modules initialize
    await CartData.getCart(true);
    console.log('[CartInit] ✓ Cart data preloaded for page initialization');
  } catch (error) {
    console.error('[CartInit] ✗ Failed to preload cart:', error);
  } finally {
    // Always set flag to prevent blocking
    window.__cartInitialized = true;
    document.dispatchEvent(new CustomEvent('cart:initialized'));
  }
})();



// ======================================================================
// CONDITION REGISTRY
// Centralizes all cart condition rules for modular evaluation
// ======================================================================
window.CartConditions = {
  rules: [],

  register(ruleFn) {
    this.rules.push(ruleFn);
  },

  async evaluateAll() {
    const cart = await CartData.getCart();
    const baseSubtotal = await CartData.getBaseSubtotal();

    const results = [];

    for (const ruleFn of this.rules) {
      const result = await ruleFn({ cart, baseSubtotal });
      if (result) results.push(result);
    }

    return results;
  }
};


// ======================================================================
// MONEY HELPERS (shared across all special product logic)
// ======================================================================
window.Money = {
  format(cents) {
    return Shopify.formatMoney(cents, theme.moneyFormat);
  },

  parseLocalizedToCents(raw) {
    if (!raw) return null;

    let t = raw.toString().trim().replace(/\s|\u00A0/g, '');

    const hasDot = t.includes('.');
    const hasComma = t.includes(',');

    if (hasDot && hasComma) {
      const lastDot = t.lastIndexOf('.');
      const lastComma = t.lastIndexOf(',');
      const decimal = lastDot > lastComma ? '.' : ',';

      if (decimal === '.') t = t.replace(/,/g, '');
      else {
        t = t.replace(/\./g, '');
        t = t.replace(',', '.');
      }
    } else if (hasComma && !hasDot) {
      const parts = t.split(',');
      if (parts[1] && parts[1].length === 3) t = t.replace(/,/g, '');
      else t = t.replace(',', '.');
    }

    const units = parseFloat(t);
    if (isNaN(units)) return null;

    return Math.round(units * 100);
  }
};

// ======================================================================
// size name tabs for the quick add sheet. Delegated, because the sheet is injected after page load.
// ======================================================================
(function () {
  if (window.quickAddSizeTabsInit) return;
  window.quickAddSizeTabsInit = true;

  function currentMode(content) {
    return content.getAttribute('data-size-mode') || 'eu';
  }

  // put the label of the chosen size (in the active tab) into the field
  function syncField(content) {
    var row = content._quickAddLastRow;
    var field = content.querySelector('[data-quick-add-dd-label]');
    if (!row || !field) return;
    var eu = row.getAttribute('data-label-eu');
    var producer = row.getAttribute('data-label-producer');
    var current = field.textContent.trim();
    // only touch the field when it shows this size, not the "Vælg størrelse" placeholder
    if (current !== eu && current !== producer) return;
    var label = row.getAttribute('data-label-' + currentMode(content));
    if (label && current !== label) {
      content._quickAddWriting = true;
      field.textContent = label;
      content._quickAddWriting = false;
    }
  }

  function watchField(content) {
    if (content._quickAddObserver) return;
    var field = content.querySelector('[data-quick-add-dd-label]');
    if (!field) return;
    content._quickAddObserver = new MutationObserver(function () {
      if (!content._quickAddWriting) syncField(content);
    });
    content._quickAddObserver.observe(field, { childList: true, characterData: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-quick-add-size-tab]');
    if (tab) {
      var content = tab.closest('[data-quick-add-content]');
      if (!content) return;
      var mode = tab.getAttribute('data-quick-add-size-tab');
      content.setAttribute('data-size-mode', mode);

      content.querySelectorAll('[data-quick-add-size-tab]').forEach(function (b) {
        var on = b.getAttribute('data-quick-add-size-tab') === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on);
      });
      content.querySelectorAll('.quick-add__opt[data-label-' + mode + ']').forEach(function (opt) {
        var name = opt.querySelector('.quick-add__opt-name');
        if (name) name.textContent = opt.getAttribute('data-label-' + mode);
      });
      syncField(content);
      return;
    }

    // remember which size was picked
    var row = e.target.closest('.quick-add__size[data-label-eu]');
    if (row) {
      var box = row.closest('[data-quick-add-content]');
      if (!box) return;
      box._quickAddLastRow = row;
      watchField(box);
      setTimeout(function () { syncField(box); }, 0);
    }
  });
})();

// =======================================================
// GIFT WRAP MANAGER - CONSOLIDATED VARIANT SYSTEM
// =======================================================
(function () {
  if (window.GiftWrapManager) return;

  let syncTimeout = null;

  function debouncedSync() {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(() => {
      syncConsolidatedGiftWrap();
    }, 300); // Wait 300ms before syncing
  }

  // Escape special characters in CSS selectors
  // useful for forms with colons in IDs
  function escapeSelector(str) {
    return str.replace(/[:]/g, '\\$&');
  }

  const selectors = {
    openButton: '.js-open-gift-wrap-modal',
    modal: '#GiftWrapModal',
    modalItemsContainer: '#GiftWrapModal [data-giftwrap-modal-items]',
    container: '.cart-gift-wrap-container'
  };

  const t = {
    addForThisProduct:
      window.theme?.strings?.giftWrap?.addGiftWrapping ||
      'Add gift wrapping to this product',
  
    editForThisProduct:
      window.theme?.strings?.giftWrap?.edit_gift_wrapping ||
      'Edit gift wrapping',
  
    addedBadge:
      window.theme?.strings?.giftWrap?.addedBadge ||
      'Gift wrapping added',
  
    addButtonLabel:
      window.theme?.strings?.giftWrap?.add ||
      'Add',
  
    updateButtonLabel:
      window.theme?.strings?.giftWrap?.edit_gift_wrapping ||
      'Update gift wrapping',
    
    editButtonLabel:
      window.theme?.strings?.giftWrap?.edit ||
      'Edit',

    totalPriceSpan:
      window.theme?.strings?.giftWrap?.total_price ||
      'Total price',

    noProductsP:
    window.theme?.strings?.cart?.empty ||
    'No products in the cart.',

    giftWrap:
    window.theme?.strings?.giftWrap?.giftWrap ||
    'Gift Wrapping',

    removeWrapForThisProduct:
    window.theme?.strings?.giftWrap?.remove_wrap_for_this_product ||
    'Remove gift wrapping for this product'
  };
  

  const state = {
    cart: null,
    basicVariantId: null,
    messageVariantId: null,
    enableMessage: false,
    isOpening: false
  };

  // -------------- Helpers --------------

  async function fetchCart(force = false) {
    if (window.CartData && typeof CartData.getCart === 'function') {
      return await CartData.getCart(force); // Respect force parameter
    }
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    return await res.json();
  }

  function isLuxuryItem(item) {
    const p = item.properties || {};
    return p._is_luxury === true || p._is_luxury === 'true';
  }

  function getVariantIds() {
    const container = document.querySelector(selectors.container);
    if (!container) return { basic: null, message: null, enableMessage: false };
    
    const enableMessage = container.getAttribute('data-enable-message') === 'true';
    
    return {
      basic: container.getAttribute('data-basic-variant-id'),
      message: enableMessage ? container.getAttribute('data-message-variant-id') : null,
      enableMessage: enableMessage
    };
  }

  function isGiftWrapLine(item) {
    const variantId = String(item.variant_id);
    if (variantId === state.basicVariantId) return true;
    if (state.messageVariantId && variantId === state.messageVariantId) return true;
    return false;
  }

  function isAddonLike(item) {
    const p = item.properties || {};
    const isAddOn = p._addOn === 'true' || p._addOn === true;
    const isDeferred = p._deferredPayment === 'true' || p._deferredPayment === true;
    const isWarranty = p._is_warranty === 'true' || p._is_warranty === true;
    const isFreeGift = p._freeGift === 'true' || p._freeGift === true;
    const isGift = isGiftWrapLine(item);

    return isAddOn || isDeferred || isWarranty || isFreeGift || isGift;
  }

  function openModalEl(el) {
    if (!el) return;
    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    el.classList.add('modal--is-active');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  }

  function closeModalEl(el) {
    if (!el) return;
    el.classList.remove('modal--is-active');
    el.setAttribute('aria-hidden', 'true');
    
    // Check if the main cart drawer is still open
    const cartDrawerOpen = document.querySelector('#CartDrawer.drawer--is-open');
    // Check if any other gift wrap modals are still open
    const anyModalOpen = document.querySelector('.modal.modal--cart.modal--is-active');
    
    // Only remove modal-open if BOTH conditions are false:
    // 1. No other modals are open
    // 2. Main cart drawer is NOT open
    if (!anyModalOpen && !cartDrawerOpen) {
      document.body.classList.remove('modal-open');
    }
  }

  // -------------- Badge Management --------------

  function updateBadgeForItem(itemKey, hasGiftwrap, attempt = 0) {
    const itemEl = document.querySelector(`.cart__item[data-line-key="${itemKey}"]`);
  
    if (!itemEl) {
      // DOM not ready yet – retry a few times before giving up
      if (attempt < 10) {
        setTimeout(() => {
          updateBadgeForItem(itemKey, hasGiftwrap, attempt + 1);
        }, 200);
      } 
      return;
    }
  
    // The wrapper is the parent of the cart item
    const wrapper = itemEl.parentElement;
    if (!wrapper || !wrapper.classList.contains('cart__item-outer-wrapper')) {
      console.warn('[GiftWrap] Item not inside a wrapper:', itemKey);
      return;
    }
  
    // Badge wrapper is inside the wrapper (sibling of cart__item)
    const badgeWrapper = wrapper.querySelector('[data-giftwrap-badge]');
    if (!badgeWrapper) {
      // Badge wrapper doesn't exist - retry
      if (attempt < 10) { // Also retry if badge wrapper missing
        setTimeout(() => {
          updateBadgeForItem(itemKey, hasGiftwrap, attempt + 1);
        }, 200);
      } else {
        console.warn('[GiftWrap] Could not find badge wrapper after 10 attempts:', itemKey);
      }
      return;
    }
  
    if (hasGiftwrap) {
      badgeWrapper.style.display = 'flex';
      const textSpan = badgeWrapper.querySelector('.cart__badge--giftwrap');
      if (textSpan) {
        textSpan.textContent = t.addedBadge;
      }
      itemEl.style.borderBottom = 'none';
    } else {
      badgeWrapper.style.display = 'none';
      itemEl.style.borderBottom = '1px solid #E3E3E3';
    }
  }

  function syncAllBadges() {
    if (!state.cart) {
      console.warn('[GiftWrap] No cart in state, cannot sync badges');
      return;
    }

    // console.log('[GiftWrap] Syncing all badges from cart:', state.cart);

    state.cart.items.forEach(item => {
      // Skip gift wrap product lines themselves
      if (isGiftWrapLine(item)) {
        // console.log('[GiftWrap] Skipping gift wrap line:', item.key);
        return;
      }
      
      // Skip other add-ons
      if (isAddonLike(item)) {
        // console.log('[GiftWrap] Skipping addon line:', item.key);
        return;
      }
      
      const props = item.properties || {};
      const giftwrapType = props._giftwrap_type;
      const hasGiftwrap = giftwrapType && giftwrapType !== 'none';
      
      // console.log('[GiftWrap] Item:', item.key, 'Type:', giftwrapType, 'Has giftwrap:', hasGiftwrap);
      
      updateBadgeForItem(item.key, hasGiftwrap);
    });
  }

  // -------------- Update Price the user sees in cart drawer based on how many gift wrap products they added --------------
  // -------------- Update "(From [gift_wrap.price]) to be visible/hidden based on whether there are more than 0 gift wrap products in cart --------------
  function updateGiftWrapContainerPrice() {
    const container = document.querySelector('.cart-gift-wrap-container');
    if (!container || !state.cart) return;

    const basicPrice = parseInt(container.getAttribute('data-basic-price')) || 0;
    const messagePrice = state.enableMessage ? (parseInt(container.getAttribute('data-message-price')) || 0) : basicPrice;

    // text next to "gaveindpakning" button
    const showFromPriceText = container.querySelector('.from__gift__wrap__price');

    let totalCount = 0;
    let totalPrice = 0;

    state.cart.items.forEach(item => {
      if (isGiftWrapLine(item) || isAddonLike(item)) return;
      
      const props = item.properties || {};
      const giftwrapType = props._giftwrap_type;
      
      if (giftwrapType && giftwrapType !== 'none') {
        totalCount++;
        totalPrice += giftwrapType === 'message' ? messagePrice : basicPrice;
      }
    });

    // Find or create the price span container
    const priceButton = container.querySelector('.cart-gift-wrap-price-and-button');
    if (!priceButton) return;

    // Remove existing price span if it exists
    let priceSpan = priceButton.querySelector('.giftwrap-total-price, .giftwrap-base-price');
    if (priceSpan) {
      priceSpan.remove();
    }

    // Only add price span if there are gift wraps
    if (totalCount > 0) {

      // Hide "from [price]" text when there are gift wraps
      if (showFromPriceText) {
        showFromPriceText.style.display = 'none';
      }

      const formattedPrice = Money.format(totalPrice);
      
      priceSpan = document.createElement('span');
      priceSpan.className = 'giftwrap-total-price';
      priceSpan.innerHTML = `${formattedPrice} <small class="giftwrap-count">(${totalCount})</small>`;
      
      // Insert before the button
      const button = priceButton.querySelector('.btn');
      if (button) {
        priceButton.insertBefore(priceSpan, button);
        button.textContent = t.editButtonLabel;
      }
    } else {

      // Show "from [price]" text when there are no gift wraps
      if (showFromPriceText) {
        showFromPriceText.style.display = 'inline';
      }

      // If no gift wraps, bring button's text content back to "Tilføj"
      const button = priceButton.querySelector('.btn');
      if (button) {
        button.textContent = t.addButtonLabel;
      }
    }

    // Update data attribute
    container.setAttribute('data-giftwrap-count', totalCount);
  }

  // -------------- Update Price the user sees in the second cart drawer based on how many gift wrap products they added --------------

  function updateModalTotalPrice() {
    if (!state.cart) return;
  
    const basicPrice = parseInt(document.querySelector('.cart-gift-wrap-container')?.getAttribute('data-basic-price')) || 0;
    const messagePrice = state.enableMessage ? (parseInt(document.querySelector('.cart-gift-wrap-container')?.getAttribute('data-message-price')) || 0) : basicPrice;
  
    let totalPrice = 0;
    let totalCount = 0;
  
    state.cart.items.forEach(item => {
      if (isGiftWrapLine(item) || isAddonLike(item)) return;
      
      const props = item.properties || {};
      const giftwrapType = props._giftwrap_type;
      
      if (giftwrapType === 'message') {
        totalPrice += messagePrice;
        totalCount++;
      } else if (giftwrapType === 'basic') {
        totalPrice += basicPrice;
        totalCount++;
      }
    });
  
    // Find the price container
    const priceContainer = document.querySelector('.giftwrap-modal__footer__price');
    
    if (totalCount > 0) {
      // Show price container and update amount
      if (priceContainer) {
        priceContainer.style.display = 'flex';
        
        const totalSpan = priceContainer.querySelector('[data-giftwrap-modal-total]');
        if (totalSpan) {
          totalSpan.innerHTML = Money.format(totalPrice);
        }
      }
    } else {
      // Hide price container
      if (priceContainer) {
        priceContainer.style.display = 'none';
      }
    }
  }


  // -------------- Modal UI --------------

  function buildModalItemsUI() {
    const container = document.querySelector(selectors.modalItemsContainer);
    if (!container || !state.cart) return;
  
    const items = state.cart.items || [];
    
    let parents = items.filter(item =>
      !isAddonLike(item) &&
      !isGiftWrapLine(item) &&
      !isLuxuryItem(item)
    );
  
    if (!parents.length) {
      parents = items.filter(item => !isGiftWrapLine(item));
    }
  
    if (!parents.length) {
      container.innerHTML = `<p class="giftwrap-modal__empty">${t.noProductsP}</p>`;
      return;
    }
  
    let html = '';
  
    parents.forEach(item => {
      const key = item.key;
      const props = item.properties || {};
      const hasGift = props._giftwrap_type && props._giftwrap_type !== 'none';
  
      const title = item.product_title || item.title || '';
      const variantTitle = 
        item.variant_title && item.variant_title !== 'Default Title' 
          ? item.variant_title 
          : '';
  
      const btnLabel = hasGift ? t.editForThisProduct : t.addForThisProduct;
      const giftBtnBg = hasGift ? 'greenBg' : 'defaultBg';
  
      const imageUrl =
        (item.image && (typeof item.image === 'string' ? item.image : item.image.src)) ||
        (item.featured_image && (item.featured_image.url || item.featured_image.src)) ||
        null;
  
      // Generate unique IDs for this item's form
      const enableCardId = `giftwrap-enable-card-${key}`;
      const toInputId = `giftwrap-to-${key}`;
      const fromInputId = `giftwrap-from-${key}`;
      const messageInputId = `giftwrap-message-${key}`;
  
      html += `
        <div class="giftwrap-modal__cart_item" data-parent-key="${key}">
          <div class="giftwrap-modal__cart_item-inner">
            <div class="giftwrap-modal__media">
              ${imageUrl ? `<img src="${imageUrl}" loading="lazy" alt="${title.replace(/"/g, '&quot;')}"/>` : ''}
            </div>
            <div class="giftwrap-modal__info">
              <p class="giftwrap-modal__item-title">${title}</p>
              <p class="giftwrap-modal__item-variant">${variantTitle}</p>
            </div>
          </div>
          <button type="button" class="giftwrap-modal__item-btn btn btn--secondary ${giftBtnBg} js-toggle-inline-form" data-parent-key="${key}">
            <span class="giftwrap-modal__item-cta-text">${btnLabel}</span>
            <span class="giftwrap-modal__item-cta-btn">+</span>
          </button>
  
          <!-- Inline form container (hidden by default) -->
          <div class="giftwrap-form-container" data-form-container="${key}" style="display:none;">
            <div class="giftwrap-drawer__pre-form">
              ${state.enableMessage ? `
              <div class="giftwrap-drawer__instructions">
                <label for="${enableCardId}">
                  <span>${t.addToFromCard || 'Tilføj til/fra kort'}</span>
                  <input type="checkbox" 
                        id="${enableCardId}"
                        name="enable_card"
                        data-giftwrap-enable-card
                        data-parent-key="${key}">
                </label>
              </div>
  
              <form class="giftwrap-drawer__form" data-giftwrap-form="${key}" style="display:none;">
                <input type="hidden" name="parent_line_key" value="${key}">
  
                <div class="giftwrap-drawer__field giftwrap-to">
                  <label for="${toInputId}">${t.to || 'Til'}</label>
                  <div class="giftwrap-drawer__input-wrapper">
                    <input id="${toInputId}"
                          name="to"
                          type="text"
                          data-giftwrap-input-to
                          data-parent-key="${key}">
                    <span class="giftwrap-drawer__counter" data-counter-to="${key}">0/25</span>
                  </div>
                </div>
  
                <div class="giftwrap-drawer__field giftwrap-from">
                  <label for="${fromInputId}">${t.from || 'Fra'}</label>
                  <div class="giftwrap-drawer__input-wrapper">
                    <input id="${fromInputId}"
                          name="from"
                          type="text"
                          data-giftwrap-input-from
                          data-parent-key="${key}">
                    <span class="giftwrap-drawer__counter" data-counter-from="${key}">0/25</span>
                  </div>
                </div>
  
                <div class="giftwrap-drawer__field giftwrap-drawer__message-field" 
                    id="giftwrap-message-field-${key}"
                    style="display:none;">
                  <label for="${messageInputId}">${t.message || 'Besked'}</label>
                  <div class="giftwrap-drawer__textarea-wrapper">
                    <textarea id="${messageInputId}"
                              name="message"
                              rows="3"
                              data-giftwrap-input-message
                              data-parent-key="${key}"></textarea>
                    <span class="giftwrap-drawer__counter" data-counter-message="${key}">0/90</span>
                  </div>
                </div>
              </form>
              ` : ''}

              <div class="giftwrap-drawer__product-preview">
                <span class="giftwrap-drawer__product-label">${t.giftWrap}</span>
                <div class="giftwrap-drawer__product-image">
                  ${getGiftWrapProductImage(t.giftWrap || 'Gift wrapping')}
                </div>
              </div>
            </div>
  
            <div class="giftwrap-drawer__actions">
              <button type="button"
                      class="btn btn--secondary giftwrap-drawer__remove js-inline-form-remove"
                      data-parent-key="${key}">
                ${t.removeWrapForThisProduct || 'Fjern indpakning'}
              </button>
              <button type="button"
                      class="btn giftwrap-drawer__submit js-inline-form-save"
                      data-parent-key="${key}">
                ${hasGift ? t.updateButtonLabel : t.addButtonLabel}
              </button>
            </div>
          </div>
        </div>
      `;
    });
  
    container.innerHTML = html;
  }
  
  // Helper to get gift wrap product image
  function getGiftWrapProductImage(giftWrapTranslation) {
    const container = document.querySelector('.cart-gift-wrap-container');
    if (!container) return '';
    
    const imageUrl = container.getAttribute('data-giftwrap-image');
    
    if (imageUrl) {
      return `<img src="${imageUrl}" alt="${giftWrapTranslation}" loading="lazy">`;
    }
    return '';
  }

  // -------------- Consolidated Line Management --------------

  let isSyncing = false;
  let checkoutSafetyTimer = null;

  function setCheckoutBlocked(blocked) {
    const checkoutBtn = document.querySelector('.cart__checkout');
    if (!checkoutBtn) return;
    
    if (blocked) {
      checkoutBtn.setAttribute('data-giftwrap-syncing', 'true');
      checkoutBtn.style.pointerEvents = 'none';
      checkoutBtn.style.opacity = '0.6';
      
      // Safety net: always unblock after 5 seconds no matter what
      clearTimeout(checkoutSafetyTimer);
      checkoutSafetyTimer = setTimeout(() => {
        isSyncing = false;
        setCheckoutBlocked(false);
      }, 5000);
    } else {
      clearTimeout(checkoutSafetyTimer);
      checkoutBtn.removeAttribute('data-giftwrap-syncing');
      checkoutBtn.style.pointerEvents = '';
      checkoutBtn.style.opacity = '';
    }
  }

async function syncConsolidatedGiftWrap() {
  isSyncing = true;
  setCheckoutBlocked(true);
  
  try {
    const cart = await fetchCart(true);
    if (!cart || !Array.isArray(cart.items)) {
      return;
    }
  
    let basicCount = 0;
    let messageCount = 0;
  
    cart.items.forEach(item => {
      // Skip gift wrap products themselves
      if (isGiftWrapLine(item)) {
        return;
      }
      
      // Skip other add-ons
      if (isAddonLike(item)) {
        return;
      }
  
      const props = item.properties || {};
      const giftwrapType = props._giftwrap_type;
      
      if (giftwrapType === 'basic') {
        basicCount++;
      } else if (giftwrapType === 'message') {
        // If message is disabled, count message types as basic instead
        if (state.enableMessage) {
          messageCount++;
        } else {
          basicCount++;
        }
      }
    });
  
    await updateGiftWrapLine(state.basicVariantId, basicCount);
    // Only sync message variant line if message functionality is enabled
    if (state.enableMessage) {
      await updateGiftWrapLine(state.messageVariantId, messageCount);
    }
    
  } catch (error) {
    console.error('[GiftWrap] Error in syncConsolidatedGiftWrap:', error);
  } finally {
    isSyncing = false;
    setCheckoutBlocked(false);
  }
}

  async function updateGiftWrapLine(variantId, targetQuantity) {
    if (!variantId) {
      return;
    }
  
    // console.log(`[GiftWrap] updateGiftWrapLine called: variant=${variantId}, targetQty=${targetQuantity}`);
  
    // Force fresh cart fetch to avoid stale data
    const cart = await fetch('/cart.js').then(r => r.json());
    const existing = cart.items.find(item => String(item.variant_id) === String(variantId));
  
  
    if (targetQuantity === 0) {
      if (existing) {
        
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existing.key, quantity: 0 })
          });
          
          if (!response.ok) {
            const errorText = await response.text();
            console.error('[GiftWrap] Failed to remove gift wrap line:', response.status, errorText);
            return;
          }
          
          await response.json();
        } catch (err) {
          console.error('[GiftWrap] Error removing gift wrap line:', err);
        }
      } else {
       // console.log(`[GiftWrap] No gift wrap line to remove (doesn't exist)`);
      }
      return;
    }
  
    if (existing) {
      if (existing.quantity !== targetQuantity) {
        
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existing.key, quantity: targetQuantity })
          });
          
          if (!response.ok) {
            const errorText = await response.text();
            console.error('[GiftWrap] Failed to update quantity:', response.status, errorText);
            return;
          }
          
          await response.json();
        } catch (err) {
          console.error('[GiftWrap] Error updating quantity:', err);
        }
      } else {
       // console.log(`[GiftWrap] Quantity already correct (${targetQuantity}), no update needed`);
      }
    } else {
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: targetQuantity,
            properties: { _is_giftwrap: 'true', _addOn: 'true' }
          })
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('[GiftWrap] Failed to add gift wrap line:', response.status, errorText);
          return;
        }
        
        await response.json();
      } catch (err) {
        console.error('[GiftWrap] Error adding gift wrap line:', err);
      }
    }
  }

  function initFormValidationForItem(parentKey) {

    const escapedKey = escapeSelector(parentKey);

    const form = document.querySelector(`[data-giftwrap-form="${escapedKey}"]`);
    if (!form) return;
  
    const toInput = form.querySelector(`[data-giftwrap-input-to][data-parent-key="${escapedKey}"]`);
    const fromInput = form.querySelector(`[data-giftwrap-input-from][data-parent-key="${escapedKey}"]`);
    const messageTextarea = form.querySelector(`[data-giftwrap-input-message][data-parent-key="${escapedKey}"]`);
    
    const toCounter = form.querySelector(`[data-counter-to="${escapedKey}"]`);
    const fromCounter = form.querySelector(`[data-counter-from="${escapedKey}"]`);
    const messageCounter = form.querySelector(`[data-counter-message="${escapedKey}"]`);
  
    function updateCounter(element, counter, current, max) {
      if (!counter) return;
      counter.textContent = `${current}/${max}`;
    }
  
    function validateTextInput(input, counter) {
      if (input.value.length > 25) {
        input.value = input.value.substring(0, 25);
      }
      updateCounter(input, counter, input.value.length, 25);
    }
  
    function validateMessage(textarea, counter) {
      const MAX_LINES = 3;
      const MAX_PER_LINE = 30;
  
      let lines = textarea.value.replace(/\r\n/g, '\n').split('\n');
  
      if (lines.length > MAX_LINES) {
        lines = lines.slice(0, MAX_LINES);
      }
  
      lines = lines.map(line => line.length > MAX_PER_LINE ? line.slice(0, MAX_PER_LINE) : line);
  
      const nextValue = lines.join('\n');
  
      if (textarea.value !== nextValue) {
        textarea.value = nextValue;
      }
  
      const totalChars = textarea.value.length;
      if (counter) counter.textContent = `${totalChars}/90`;
    }
  
    function handleMessageKeydown(e) {
      if (e.key !== 'Enter') return;
  
      const value = e.currentTarget.value.replace(/\r\n/g, '\n');
      const lines = value.split('\n');
  
      if (lines.length >= 3) {
        e.preventDefault();
      }
    }
  
    if (toInput) {
      toInput.setAttribute('maxlength', '25');
      toInput.addEventListener('input', () => validateTextInput(toInput, toCounter));
      updateCounter(toInput, toCounter, toInput.value.length, 25);
    }
  
    if (fromInput) {
      fromInput.setAttribute('maxlength', '25');
      fromInput.addEventListener('input', () => validateTextInput(fromInput, fromCounter));
      updateCounter(fromInput, fromCounter, fromInput.value.length, 25);
    }
  
    if (messageTextarea) {
      messageTextarea.setAttribute('maxlength', '90');
      messageTextarea.addEventListener('input', () => validateMessage(messageTextarea, messageCounter));
      messageTextarea.addEventListener('keydown', handleMessageKeydown);
      updateCounter(messageTextarea, messageCounter, messageTextarea.value.length, 90);
    }
  }

  // Show inline form for specific item
  function showInlineFormForItem(parentKey) {
    // Hide all other forms first
    hideAllInlineForms();

    const escapedKey = escapeSelector(parentKey);
    
    const formContainer = document.querySelector(`[data-form-container="${escapedKey}"]`);
    if (!formContainer) return;
    
    // Show container
    formContainer.style.display = 'block';
    
    // Populate form with existing data
    populateInlineForm(parentKey);
    
    // Initialize validation for this form
    initFormValidationForItem(parentKey);
    
    // Scroll into view
    setTimeout(() => {
      formContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  }

  // Hide all inline forms
  function hideAllInlineForms() {
    document.querySelectorAll('.giftwrap-form-container').forEach(container => {
      container.style.display = 'none';
    });
  }

  // Populate form with existing gift wrap data
  function populateInlineForm(parentKey) {
    if (!state.cart) return;
    
    const parentItem = state.cart.items.find(i => i.key === parentKey);
    if (!parentItem) return;
    
    const props = parentItem.properties || {};
    const escapedKey = escapeSelector(parentKey);
    
    const removeBtn = document.querySelector(`[data-parent-key="${escapedKey}"].js-inline-form-remove`);
    const submitBtn = document.querySelector(`[data-parent-key="${escapedKey}"].js-inline-form-save`);

    // Message-related elements (may not exist when enableMessage is false)
    const enableCardCheckbox = document.querySelector(`[data-giftwrap-enable-card][data-parent-key="${escapedKey}"]`);
    const toInput = document.querySelector(`[data-giftwrap-input-to][data-parent-key="${escapedKey}"]`);
    const fromInput = document.querySelector(`[data-giftwrap-input-from][data-parent-key="${escapedKey}"]`);
    const msgInput = document.querySelector(`[data-giftwrap-input-message][data-parent-key="${escapedKey}"]`);
    const form = document.querySelector(`[data-giftwrap-form="${escapedKey}"]`);
    const msgField = document.querySelector(`#giftwrap-message-field-${escapedKey}`);
    
    if (props._giftwrap_type && props._giftwrap_type !== 'none') {
      // Has existing gift wrap
      if (removeBtn) removeBtn.style.display = 'inline-block';
      if (submitBtn) submitBtn.textContent = t.updateButtonLabel;

      // Only populate message fields if message functionality is enabled
      if (state.enableMessage) {
        if (enableCardCheckbox) enableCardCheckbox.checked = true;
        if (form) form.style.display = 'block';
        if (msgField) msgField.style.display = 'block';
        
        [toInput, fromInput, msgInput].forEach((input) => {
          if (!input) return;
          input.setAttribute('required', 'required');
        });
        
        if (toInput) toInput.value = props._giftwrap_to || '';
        if (fromInput) fromInput.value = props._giftwrap_from || '';
        if (msgInput) msgInput.value = props._giftwrap_message || '';

        initFormValidationForItem(parentKey);
      }

    } else {
      // No gift wrap - clear form
      if (removeBtn) removeBtn.style.display = 'none';
      if (submitBtn) submitBtn.textContent = t.addButtonLabel;

      // Only clear message fields if message functionality is enabled
      if (state.enableMessage) {
        if (enableCardCheckbox) enableCardCheckbox.checked = false;
        if (form) form.style.display = 'none';
        if (msgField) msgField.style.display = 'none';
        
        [toInput, fromInput, msgInput].forEach((input) => {
          if (!input) return;
          input.removeAttribute('required');
        });
        
        if (toInput) toInput.value = '';
        if (fromInput) fromInput.value = '';
        if (msgInput) msgInput.value = '';
      }      if (removeBtn) removeBtn.style.display = 'none';
      if (submitBtn) submitBtn.textContent = t.addButtonLabel;
    }
  }

  // Toggle inline form visibility
  function toggleInlineFormForItem(parentKey) {
    const escapedKey = escapeSelector(parentKey);
    const formContainer = document.querySelector(`[data-form-container="${escapedKey}"]`);
    if (!formContainer) return;
    
    if (formContainer.style.display === 'none' || !formContainer.style.display) {
      showInlineFormForItem(parentKey);
    } else {
      formContainer.style.display = 'none';
    }
  }

  // -------------- Form Submission --------------

  async function submitInlineForm(event, parentKey) {
    event.preventDefault();
    
    const escapedKey = escapeSelector(parentKey);
    
    const form = document.querySelector(`[data-giftwrap-form="${escapedKey}"]`);
    const enableCardCheckbox = document.querySelector(`[data-giftwrap-enable-card][data-parent-key="${escapedKey}"]`);
  
    // Only validate if message is enabled and card mode is enabled
    if (state.enableMessage && enableCardCheckbox && enableCardCheckbox.checked) {
      if (form && !form.checkValidity()) {
        form.reportValidity();
        return;
      }
    }
  
    const toInput = document.querySelector(`[data-giftwrap-input-to][data-parent-key="${escapedKey}"]`);
    const fromInput = document.querySelector(`[data-giftwrap-input-from][data-parent-key="${escapedKey}"]`);
    const msgInput = document.querySelector(`[data-giftwrap-input-message][data-parent-key="${escapedKey}"]`);
    const submitBtn = document.querySelector(`[data-parent-key="${escapedKey}"].js-inline-form-save`);
  
    if (!submitBtn) return;
  
    const cart = state.cart || (await fetchCart(true));
    const parentItem = cart.items.find((i) => i.key === parentKey);
    if (!parentItem) {
      console.error('[GiftWrap] Parent item not found:', parentKey);
      return;
    }
  
    // Check if checkbox is checked and if there's a message
    const to = toInput ? toInput.value.trim() : '';
    const from = fromInput ? fromInput.value.trim() : '';
    const message = msgInput ? msgInput.value.trim() : '';
    
    // Only consider it a "message" variant if message is enabled, checkbox is checked, and message has content
    const isCardEnabled = state.enableMessage && enableCardCheckbox && enableCardCheckbox.checked;
    const hasMessage = isCardEnabled && message.length > 0;
  
    submitBtn.disabled = true;
  
    try {
      const newProps = {
        ...parentItem.properties,
        _giftwrap_type: hasMessage ? 'message' : 'basic',
        _giftwrap_to: isCardEnabled ? to : '',      // only save if card enabled
        _giftwrap_from: isCardEnabled ? from : ''    // only save if card enabled
      };
  
      if (hasMessage) {
        newProps._giftwrap_message = message;
      } else {
        delete newProps._giftwrap_message;
      }
  
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parentItem.key,
          quantity: parentItem.quantity,
          properties: newProps
        })
      });
  
      await syncConsolidatedGiftWrap();
  
      await loadCartIntoState();
      // updateBadgeForItem(parentKey, true);
      updateModalTotalPrice();
  
      // Hide the form after saving
      const formContainer = document.querySelector(`[data-form-container="${escapedKey}"]`);
      if (formContainer) formContainer.style.display = 'none';
  
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: { cart: state.cart } })
      );
    } catch (err) {
      console.error('[GiftWrap] Error saving:', err);
    } finally {
      submitBtn.disabled = false;
    }
  }

  async function removeGiftForItem(parentKey) {
    const cart = state.cart || (await fetchCart(true));
    const parentItem = cart.items.find(i => i.key === parentKey);
    if (!parentItem) return;

    const escapedKey = escapeSelector(parentKey);
  
    const removeBtn = document.querySelector(`[data-parent-key="${escapedKey}"].js-inline-form-remove`);
    if (removeBtn) removeBtn.disabled = true;
  
    try {
      const newProps = { ...(parentItem.properties || {}) };
      
      newProps._giftwrap_type = 'none';
      newProps._giftwrap_to = '';
      newProps._giftwrap_from = '';
      newProps._giftwrap_message = '';
    
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parentItem.key,
          quantity: parentItem.quantity,
          properties: newProps
        })
      });
    
      await syncConsolidatedGiftWrap();
    
      await loadCartIntoState();
      // updateBadgeForItem(parentKey, false);
      updateModalTotalPrice();
    
      // Hide the form after removing
      const formContainer = document.querySelector(`[data-form-container="${escapedKey}"]`);
      if (formContainer) formContainer.style.display = 'none';
    
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state.cart } }));
    
    } catch (err) {
      console.error('[GiftWrap] Error removing:', err);
    } finally {
      if (removeBtn) removeBtn.disabled = false;
    }
  }

  // -------------- State Management --------------

  async function loadCartIntoState() {
    const cart = await fetchCart(false); // Don't force refresh, use cache
    state.cart = cart;
    buildModalItemsUI();
    syncAllBadges();
    updateGiftWrapContainerPrice();
    updateModalTotalPrice();
  }

  // -------------- Modal Open/Close --------------

  async function openGiftWrapModal() {
    if (state.isOpening) return;
    state.isOpening = true;

    try {
      // if (window.__luxuryModeActive) {
      //   console.warn('[GiftWrap] Luxury mode active');
      //   state.isOpening = false;
      //   return;
      // }

      await loadCartIntoState();

      const modal = document.querySelector(selectors.modal);
      if (modal) {
        openModalEl(modal);
        updateModalTotalPrice();
      }
    } catch (err) {
      console.error('[GiftWrap] Failed to open modal:', err);
    } finally {
      state.isOpening = false;
    }
  }

  function closeGiftWrapModal() {
    const modal = document.querySelector(selectors.modal);
    if (!modal) return;
    
    modal.classList.remove('modal--is-active');
    modal.setAttribute('aria-hidden', 'true');
    
    // After closing, check if we should remove modal-open
    // Only remove if NO gift wrap modals are open AND cart drawer is NOT open
    setTimeout(() => {
      const anyModalOpen = document.querySelector('.modal.modal--cart.modal--is-active');
      const cartDrawerOpen = document.querySelector('#CartDrawer.drawer--is-open');
      
      if (!anyModalOpen && !cartDrawerOpen) {
        document.body.classList.remove('modal-open');
      }

      syncAllBadges();
    }, 50);
  }

  // -------------- Event Bindings --------------

  function bindStaticEvents() {
    document.addEventListener('click', function (e) {
      // Open modal
      if (e.target.closest(selectors.openButton)) {
        e.preventDefault();
        openGiftWrapModal();
      }
  
      // Close modal
      if (e.target.closest('.js-giftwrap-close') || 
          e.target.matches('.giftwrap-modal__overlay')) {
        e.preventDefault();
        e.stopPropagation();
        closeGiftWrapModal();
      }
  
      // Toggle inline form
      const toggleBtn = e.target.closest('.js-toggle-inline-form');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        const parentKey = toggleBtn.getAttribute('data-parent-key');
        if (parentKey) toggleInlineFormForItem(parentKey);
      }
  
      // Save inline form
      const saveBtn = e.target.closest('.js-inline-form-save');
      if (saveBtn) {
        e.preventDefault();
        e.stopPropagation();
        const parentKey = saveBtn.getAttribute('data-parent-key');
        if (parentKey) submitInlineForm(e, parentKey);
      }
  
      // Remove gift wrap
      const removeBtn = e.target.closest('.js-inline-form-remove');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const parentKey = removeBtn.getAttribute('data-parent-key');
        if (parentKey) removeGiftForItem(parentKey);
      }
  
      // Handle checkbox and label clicks (only when message functionality is enabled)
      const checkbox = e.target.closest('[data-giftwrap-enable-card]');
      const label = e.target.closest('label');
      
      if (state.enableMessage && (checkbox || (label && label.querySelector('[data-giftwrap-enable-card]')))) {
        e.stopPropagation();
        
        const actualCheckbox = checkbox || label.querySelector('[data-giftwrap-enable-card]');
        
        setTimeout(() => {
          const parentKey = actualCheckbox.getAttribute('data-parent-key');
          if (!parentKey) return;
  
          const escapedKey = escapeSelector(parentKey);
          
          const form = document.querySelector(`[data-giftwrap-form="${escapedKey}"]`);
          const msgField = document.querySelector(`#giftwrap-message-field-${escapedKey}`);
          
          if (!form || !msgField) return;
          
          const toInput = document.querySelector(`[data-giftwrap-input-to][data-parent-key="${escapedKey}"]`);
          const fromInput = document.querySelector(`[data-giftwrap-input-from][data-parent-key="${escapedKey}"]`);
          const msgInput = document.querySelector(`[data-giftwrap-input-message][data-parent-key="${escapedKey}"]`);
          
          const enabled = actualCheckbox.checked;
          
          form.style.display = enabled ? 'block' : 'none';
          msgField.style.display = enabled ? 'block' : 'none';
          
          [toInput, fromInput, msgInput].forEach((input) => {
            if (!input) return;
            if (enabled) {
              input.setAttribute('required', 'required');
            } else {
              input.removeAttribute('required');
            }
          });
        }, 0);
      }

      // Stop propagation on clicks inside inline forms
      const formContainer = e.target.closest('.giftwrap-form-container');
      if (formContainer) {
        e.stopPropagation();
      }
    });

  }

  // -------------- INIT --------------


  async function init() {
    if (!document.getElementById('CartDrawer')) return;

    // Wait for cart initialization
    if (!window.__cartInitialized) {
      await new Promise(resolve => {
        document.addEventListener('cart:initialized', resolve, { once: true });
      });
    }

    const variantIds = getVariantIds();
    state.basicVariantId = variantIds.basic;
    state.messageVariantId = variantIds.message;
    state.enableMessage = variantIds.enableMessage;

    if (!state.basicVariantId) {
      console.warn('[GiftWrap] Missing basic variant ID in schema settings');
      return;
    }

    if (state.enableMessage && !state.messageVariantId) {
      console.warn('[GiftWrap] Message enabled but missing message variant ID');
    }

    bindStaticEvents();

    // Block checkout submission while gift wrap sync is in progress
    // this prevents a checkout with more gift wrap lines than expected due to timing issues
    const cartForm = document.querySelector('#CartDrawerForm');
    if (cartForm) {
      cartForm.addEventListener('submit', async function (e) {
        if (isSyncing) {
          e.preventDefault();
          const maxWait = 5000; // Never block checkout for more than 5 seconds
          const start = Date.now();
          const checkInterval = setInterval(() => {
            if (!isSyncing || Date.now() - start > maxWait) {
              clearInterval(checkInterval);
              setCheckoutBlocked(false);
              cartForm.submit();
            }
          }, 100);
        }
      });
    }

    document.addEventListener('cart:build', function () {
      setTimeout(async () => {
        await loadCartIntoState();
        await syncConsolidatedGiftWrap();
      }, 100);
    });

    document.addEventListener('cart:updated', function () {
      setTimeout(async () => {
        await loadCartIntoState();
        await syncConsolidatedGiftWrap();
      }, 100);
    });

    setTimeout(loadCartIntoState, 200);
  }

  window.GiftWrapManager = { init, reload: loadCartIntoState };

  document.addEventListener('DOMContentLoaded', init);
}());



// =======================================================
// GIFT WRAP MANAGER END
// =======================================================
// =======================================================
// GIFT WRAP MANAGER END
// =======================================================
// =======================================================
// GIFT WRAP MANAGER END
// =======================================================




const log = console.log;

// Cart redirect functionality
function handleCartRedirect() {
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');
  if (isDesignMode) {
    return;
  }

  // Check if we're on the cart page
  if (window.location.pathname === '/cart') {
    // Redirect to homepage with cart query parameter
    window.location.href = '/?open_cart=true';
    return;
  }
  
  // Check if we should open the cart drawer based on query parameter
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === 'true') {
    // Remove the query parameter from URL without reloading
    const newUrl = window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
    
    // Open cart drawer after a short delay to ensure page is loaded
    setTimeout(() => {
      const cartDrawerTrigger = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
      if (cartDrawerTrigger) {
        cartDrawerTrigger.click();
      }
    }, 100);
  }
}

// Run cart redirect check immediately
handleCartRedirect();

function emSetCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function emGetCookie(sKey) {
  if (!sKey) {
    return null;
  }
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1").replace('%', '')) || null;
}

/* Logbuy tracking */
if (
  document.referrer === 'https://www.mylogbuy.com/WebPages/Terms/DealTerms.aspx?dealId=32049&discountId=593301'
  ||
  document.referrer === 'https://www.mylogbuy.com/WebPages/ShowDeal/default.aspx?SupplierInfoId=18209'
  ||
  document.referrer.substring(0, 24).toLowerCase() === 'https://www.mylogbuy.com'
) {
  emSetCookie('em-mylogbuy', true, 1);
}

// Write _allowLogbuyDiscount only once a cart exists, so it never creates a
// competing cart against apps that write cart attributes on page load (ABConvert).
// Runs on every page while the em-mylogbuy cookie is set, and re-adds the
// attribute if it is missing.
(async function ensureLogbuyAttribute() {
  if (!emGetCookie('em-mylogbuy')) return;

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const hasCartCookie = () => document.cookie.split('; ').some((c) => c.startsWith('cart='));

  const start = Date.now();
  while (!hasCartCookie() && Date.now() - start < 3000) {
    await wait(100);
  }

  try {
    for (let attempt = 0; attempt < 3; attempt++) {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (cart.attributes && cart.attributes._allowLogbuyDiscount === 'true') return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            _allowLogbuyDiscount: 'true'
          }
        })
      });
      await wait(300);
    }
  } catch (e) {
    console.error('[Logbuy] failed to set cart attribute', e);
  }
})();

function DOMready(callback) {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
}

DOMready(function () {
  /* newsletter form fix scroll to form */
  if (document.querySelector('.shopify-challenge__container form')) {
    const challengeForm = document.querySelector('.shopify-challenge__container form');
    challengeForm.setAttribute('action', challengeForm.getAttribute('action') + '#newsletter_footer_form');
  }

  /* scroll-to-top */
  if (document.querySelector('.scroll-to-top')) {
    document.querySelector('.scroll-to-top').addEventListener('click', function () {
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    });
  }

  // theme - ajax add to cart
  if (document.querySelector('[action="/cart/add"]')) {
    document.querySelectorAll('[action="/cart/add"]').forEach(function ($form) {
      eventAddToCart($form);   
    });
  }
  function eventAddToCart($form) {
    // prevent attaching twice to the same form
    if ($form.dataset.warrantyHandlerBound === 'true') return;
    $form.dataset.warrantyHandlerBound = 'true';
    
    // Mark form to prevent theme.js handler from attaching
    $form.dataset.customAtcHandler = 'true';
  
    // block theme click handlers from also firing (capture phase)
    const submitEl = $form.querySelector('[type="submit"]');
    if (submitEl) {
      submitEl.addEventListener(
        'click',
        (ev) => {
          ev.stopPropagation();
          ev.stopImmediatePropagation();
        },
        true
      );
    }
  
    // prevent double posting with a flag
    let atcInFlight = false;
  
    // Use capture phase to intercept before theme.js handler
    $form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
  
      if (atcInFlight) return;
      atcInFlight = true;
  
      const submitBtn = $form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
  
      const cleanup = () => {
        atcInFlight = false;
        if (submitBtn) submitBtn.disabled = false;
      };
  
      (async () => {
        // Skip warranty check for the entire add-to-cart process
        if (typeof window.skipNextWarrantyCheck === 'function') {
          // console.log("Skipping warranty check for add to cart, as if it is added before parent product, it thinks it is an orphan and removes it before cart is updated");
          window.skipNextWarrantyCheck();
        }
  
        let input = $form.getAttribute('action') + '.js';
        let init = {
          method: 'POST',
          body: {},
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          }
        }
  
        // get product form data
        let formData = new FormData($form);
        let product = {};
        for (const pair of formData.entries()) {
          product[pair[0]] = pair[1];
        }
        //  console.log("Add to cart")
  
        if ($form.getAttribute('action') === '/cart/change') {
          init.body = JSON.stringify({
            'id': $form.querySelector('[name="id"]').value,
            'quantity': $form.querySelector('[name="quantity"]').value
          });
        } else {
          let items = [];
  
          // Convert any properties[key] format into properties object format
          if (Object.keys(product).some(key => key.startsWith('properties['))) {
            const properties = {};
          
            // Extract all properties into object
            Object.keys(product).forEach(key => {
              if (key.startsWith('properties[')) {
                // Extract property name between brackets and remove any quotes
                const propName = key.match(/properties\[(.*?)\]/)[1].replace(/["']/g, '');
                properties[propName] = product[key];
                delete product[key];
              }
            });
  
            // Add properties object to product
            product.properties = properties;
          }
        
          items.push(product);
  
          // EXTENDED WARRANTY LOGIC - Adds warranty with relationship properties
          const warrantyInput = document.getElementById('warranty-input');
  
          if (warrantyInput && warrantyInput.value && warrantyInput.value !== 'none') {
          //  console.log('Adding warranty with relationship properties:', warrantyInput.value);
          
            // Generate unique key for this specific add-to-cart action
            const uniqueKey = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
          
            // Add the unique key to the main product's properties
            if (!product.properties) {
              product.properties = {};
            }
            product.properties._warranty_key = uniqueKey;
          
            // Remove the "Extended Warranty" property since we're adding it as separate line item
            delete product.properties['Extended Warranty'];
          
            // Get the selected warranty option element to read the calculated price
            const selectedWarrantyOption = document.querySelector(`.warranty-option[data-variant-id="${warrantyInput.value}"]`);
            const priceElement = selectedWarrantyOption ? selectedWarrantyOption.querySelector('.option-percentage') : null;
          
            const rawPrice = priceElement && priceElement.dataset.rawPrice
            ? parseFloat(priceElement.dataset.rawPrice)
            : null;
  
            // Validation check
            if (!rawPrice) {
                console.error('Warranty price not calculated yet');
                return; // cleanup will still run in finally
            }
  
            // Convert cents to currency value
            const calculatedPrice = (rawPrice / 100).toFixed(2);
          
            // Get the warranty option text (e.g., "1 Year", "2 Years")
            const warrantyOptionText = selectedWarrantyOption ? selectedWarrantyOption.querySelector('strong').textContent.trim() : '';
          
            // Get the parent product name from the warranty parent div
            const warrantyParent = document.querySelector('.warranty__parent');
            const parentVariantId = warrantyParent ? warrantyParent.dataset.productVariantId : product.id;
  
            // Get the product title from the page if not available in the warranty parent div
            const productTitle = warrantyParent ? warrantyParent.dataset.productTitle : document.querySelector('.product-single__title-name')?.textContent?.trim() || 'Product';
  
            // Clean parent item (keep only Cart API compatible fields)
            const cleanedParent = {
              id: parseInt(product.id),
              quantity: parseInt(product.quantity) || 1
            };
          
            if (product.properties && Object.keys(product.properties).length > 0) {
              cleanedParent.properties = product.properties;
            }
          
            if (product.selling_plan) {
              cleanedParent.selling_plan = product.selling_plan;
            }
          
            items[0] = cleanedParent;
  
            const productSize = product?.Size;
  
            // Add warranty as SEPARATE line item with relationship properties
            items.push({
              'id': parseInt(warrantyInput.value),
              'quantity': 1,
              'properties': {
                '_parent_key': uniqueKey,  // Links to parent via unique key
                '_parent_variant_id': parentVariantId,  // Also store variant ID for reference
                '_fixedPrice': calculatedPrice,
                '_warranty_for': warrantyOptionText,  // Human-readable label
                '_is_warranty': 'true',  // hide quantity buttons with this,
                'Info': `${productTitle} ${productSize ? `- ${productSize}` : ''}`
              }
            });
          
          //  console.log('Final items with relationship properties:', JSON.stringify(items, null, 2));
          }
  
          // add upsells
          document.querySelectorAll('.product-inline-upsells .product-inline-upsell-item').forEach(function ($el) {
            if (
              $el.querySelector('input[type=checkbox]').checked
              &&
              $el.querySelector('select option:checked')
              &&
              document.querySelector('.product-section').getAttribute('data-product-id')
              &&
              document.querySelector('.product-section').getAttribute('data-product-handle')
            ) {
              let productId = document.querySelector('.product-section').getAttribute('data-product-id');
              let productHandle = document.querySelector('.product-section').getAttribute('data-product-handle');
  
              try {
                const form = document.querySelector('.product-single__form[data-klaviyo-name]');
                if (form && form.dataset.klaviyoName) {
                  productId = form.dataset.productid;
                  productHandle = form.dataset.klaviyoUrl;
                }
              } catch (error) {
                console.error(error);
              }
  
              items.push({
                'id': $el.querySelector('select option:checked').value,
                'quantity': 1,
                'properties': {
                  '_product_inline_upsell_handle': productHandle,
                  '_product_inline_upsell_id': productId,
                }
              });
            }
          });
  
          init.body = JSON.stringify({
            'items': items
          });
        }
  
        // add to cart
        const res = await fetch(input, init);
        const data = await res.json();
  
        log(data.status);
  
        if (data.status) {
          console.error('Cart API Error Response:', data);
          let $msg = $form.querySelector('.product-added-to-cart');
          if ($msg && $msg.length !== 0) {
            $msg.innerHTML = theme.strings.cannotAddCart;
  
            setTimeout(function () {
              $msg.innerHTML = '';
            }, 3000);
          }
  
          return;
        }
  
        let $msg = $form.querySelector('.product-added-to-cart');
        if ($msg && $msg.length !== 0) {
          // add msg under add to cart
          $msg.innerHTML = theme.strings.addedToCart;
  
          setTimeout(function () {
            $msg.innerHTML = '';
          }, 3000);
        }

        // CUSTOM (A/B test PR.7): on the product page the offer popup comes first and opens the cart itself
        // (assets/pdp-information.js), instead of the cart drawer and the old cart popup below
        const pdpOfferPopup = window.pdpOfferPopup && window.pdpOfferPopup.wants($form) ? window.pdpOfferPopup : null;

        // rebuild cart
        setTimeout(function () {
          document.dispatchEvent(new Event('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated'));

          if (pdpOfferPopup) {
            pdpOfferPopup.open();
            return;
          }


          setTimeout(function() {
            // cart popup
            if (!document.querySelector('.template-cart') && document.querySelector('.cart-popup')) {
              // Get product collection handles from last cart line item added
              fetch('/cart.js').then(function (response) {
                return response.json();
              }).then(function (data) {
                const lastCartItem = data.items[0];
  
                // Find the corresponding cart item element in the DOM
                const cartItemElement = document.querySelector(`[data-key="${lastCartItem.key}"]`) ||
                                        document.querySelector(`[data-variant-id="${lastCartItem.variant_id}"]`);
  
                const collectionHandles = cartItemElement?.dataset.collections || null;
  
                const matchingUpsell = findMatchingUpsell(collectionHandles);
              
                if (matchingUpsell) {
                  const upsellId = matchingUpsell.id || matchingUpsell.label || matchingUpsell.collection_handle || 'fallback-id';
                  // store the discount in the cart popup as an attribute to be used in the product cards
                  document.querySelector('.cart-popup').setAttribute('data-upsell-id', upsellId);
                  document.querySelector('.cart-popup').setAttribute('data-discount', matchingUpsell.discount);
                  // We need to get the cart and check if a product already has a upsell source, as we dont want to show any other upsells
                  fetch('/cart.js').then(function (response) {
                    return response.json();
                  }).then(function (data) {
                    const cartItems = data.items;
                    const cartItemsWithUpsell = cartItems.filter(item => item.properties && item.properties._source === upsellId);
                    //  console.log('Cart items with upsell', cartItemsWithUpsell);
                    if (cartItemsWithUpsell.length > 0) {
                      // console.log('Cart items with upsell already exist');
                      return;
                    }
                    // fetch cart popup content
                    fetch(klaviyoItem.URL + '?t=' + Date.now() + '&view=ajax-cart-popup-products').then(function (response) {
                      return response.text();
                    }).then(function (html) {
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(html, 'text/html');
                      const fetchedCartPopupProduct = doc.querySelector('.ajax-cart-popup-product');
                      const fetchedCartPopupProducts = doc.querySelector('.ajax-cart-popup-products');
                      const fetchedProductsHasContent = fetchedCartPopupProducts && fetchedCartPopupProducts.innerHTML.trim() !== '';
                      if (fetchedProductsHasContent) {
                        document.querySelector('.cart-popup-title').innerHTML = matchingUpsell.label;
                        // add product info
                        if (fetchedCartPopupProduct) {
                          document.querySelector('.cart-popup-product').innerHTML = fetchedCartPopupProduct.innerHTML;
                          const $cartPopupProduct = document.querySelector('.cart-popup-product');
                          // add qty event
                          new theme.QtySelector($cartPopupProduct.querySelector('.js-qty__wrapper'));
                          // event add to cart
                          eventAddToCart($cartPopupProduct.querySelector('[action="/cart/change"]'));
                          $cartPopupProduct.querySelector('.js-qty__num').addEventListener('change', function () {
                            $cartPopupProduct.querySelector('[action="/cart/change"]').dispatchEvent(new Event('submit'));
                          });
                          let adjustTimeout;
                          $cartPopupProduct.querySelectorAll('.js-qty__adjust').forEach(function ($adjust) {
                            $adjust.addEventListener('click', function () {
                              clearTimeout(adjustTimeout);
                              adjustTimeout = setTimeout(function () {
                                $cartPopupProduct.querySelector('[action="/cart/change"]').dispatchEvent(new Event('submit'));
                              }, 200);
                            });
                          })
                          // add event
                          if (document.querySelector('.cart-popup').querySelector('.js-cart-popup-close')) {
                            document.querySelector('.cart-popup').querySelectorAll('.js-cart-popup-close').forEach(function ($close) {
                              $close.addEventListener('click', function () {
                                document.querySelector('.cart-popup').classList.remove('cart-popup--is-open');
                                if (document.querySelector('#CartDrawer')) {
                                  document.querySelector('#CartDrawer').classList.remove('drawer--is-open');
                                }
                                document.documentElement.classList.remove('js-drawer-open', 'lock-scroll');
                              });
                            });
                          }
                        }
                        // add products
                        if (fetchedCartPopupProducts) {
                          document.querySelector('.cart-popup-products').innerHTML = fetchedCartPopupProducts.innerHTML;
                          if (document.querySelector('.cart-popup-products [data-aos="overflow__animation"]')) {
                            document.querySelector('.cart-popup-products [data-aos="overflow__animation"]').classList.add('aos-init', 'aos-animate');
                          }
                          // add event new products
                          if (document.querySelector('.cart-popup-products [action="/cart/add"]')) {
                            document.querySelectorAll('.cart-popup-products [action="/cart/add"]').forEach(function ($form) {
                              eventAddToCart($form);
                            });
                          }
                          addSourceToUpsellForms(matchingUpsell.id);
                          const discountPercentage = matchingUpsell.discount / 100;
                        
                          document.querySelectorAll('.cart-popup-products .grid-product__price .money').forEach(function (originalPriceEl) {
                            const priceContainer = originalPriceEl.closest('.grid-product__price');
                            const discountedPriceEl = originalPriceEl.cloneNode(true);
                            originalPriceEl.classList.add('cart__price--strikethrough');
                            discountedPriceEl.classList.add('cart__discount');
                            function getStructuredPrice(parts) {
                              const currency = parts.find(part => part.length < 3);
                              const value = parts.find(part => part != currency);
                              const currencyIndex = parts.indexOf(currency);
                              const valueIndex = parts.indexOf(value);
                              const currencyIsBeforeValue = valueIndex > currencyIndex;
                              let valueFormatted = parseFloat(value) * discountPercentage;
                              switch (currency) {
                                case 'kr':
                                case '€':
                                case 'zł':
                                  valueFormatted = valueFormatted.toFixed(2).replace('.', ',');
                                  break;
                                case '$':
                                case '£':
                                  valueFormatted = valueFormatted.toFixed(2);
                                  break;
                                default:
                                  valueFormatted = valueFormatted.toFixed(2).replace('.', ',');
                                  break;
                              }
                              return {
                                value: valueFormatted,
                                currency: currency,
                                currencyIsBeforeValue: currencyIsBeforeValue
                              }
                            }
                            const discountedPriceParts = originalPriceEl.innerText.split(' ');
                            const structuredPrice = getStructuredPrice(discountedPriceParts);
                            discountedPriceEl.innerText = structuredPrice.currencyIsBeforeValue
                              ? `${structuredPrice.currency} ${structuredPrice.value}`
                              : `${structuredPrice.value} ${structuredPrice.currency}`;
                            priceContainer.appendChild(discountedPriceEl);
                          });
                        }
                        // open cart popup + add background
                        document.querySelector('.cart-popup').classList.add('cart-popup--is-open');
                        document.documentElement.classList.add('js-drawer-open', 'lock-scroll');
                      }
                    });
                    // if no collection matches, do not add the class that shows the popup, as there is no "upsell" to show
                  });
                }
              })
            } else if ($form.querySelector('.product-flying-cart')) {
              const flying = $form.querySelector('.product-flying-cart');
  
              flying.style.top = -flying.getBoundingClientRect().top + document.querySelector('.cart-link').getBoundingClientRect().top + 'px';
              flying.style.left = -flying.getBoundingClientRect().left + document.querySelector('.cart-link').getBoundingClientRect().left + 'px';
              flying.style.opacity = 1;
  
              setTimeout(function () {
                flying.style.transition = 'none';
                flying.style.opacity = 0;
                flying.style.top = '0px';
                flying.style.left = '0px';
  
                setTimeout(function () {
                  flying.style.transition = 'all 1s ease-in-out';
                }, 100);
              }, 1100);
  
              // Check if cart page
              if (document.querySelector('.template-cart')) {
                window.location.reload();
              }
            }
          }, 200);
  
          // OPEN CART DRAWER AFTER CART IS UPDATED
          setTimeout(function () {
            const cartDrawer = document.querySelector('#CartDrawer');
          
            if (cartDrawer && !cartDrawer.classList.contains('drawer--is-open')) {
            
              // Trigger the cart
              const cartTriggers = [
                '.js-drawer-open-cart',
                '[aria-controls="CartDrawer"]',
                '.site-header__cart',
                '.cart-link'
              ];
            
              let opened = false;
              for (let selector of cartTriggers) {
                const trigger = document.querySelector(selector);
                if (trigger && !opened) {
                  trigger.click();
                  opened = true;
                  break;
                }
              }
    
            }
          }, 100); // Small delay after cart:updated to ensure drawer is ready
  
        }, 400);
  
        // send klaviyo add to cart tracking
        const form = e.target;
        if (form.dataset.klaviyoName && window._learnq) {
          const klaviyoItem = {
            Name: form.dataset.klaviyoName,
            ProductID: form.dataset.productid,
            Categories: form.dataset.klaviyoCategories ? form.dataset.klaviyoCategories.split(',') : [],
            ImageURL: `https:${form.dataset.klaviyoImage}`,
            URL: `${window.location.origin}/products/${form.dataset.klaviyoUrl}`,
            Brand: form.dataset.klaviyoVendor,
            Price: parseFloat(form.dataset.klaviyoPrice),
            CompareAtPrice: parseFloat(form.dataset.klaviyoComparePrice)
          };
          
          window._learnq.push(['track', 'Added to Cart', klaviyoItem]);
          log('klaviyoItem', klaviyoItem);
        }
  
        // add discount if found
        if ($form.parentElement.querySelector('[data-campaign-discount-code]')) {
          fetch('/discount/' + $form.parentElement.querySelector('[data-campaign-discount-code]').innerText.trim()).then(() => {
            log('discount:added');
          });
        } else if ($form.parentElement.parentElement.parentElement.querySelector('[data-campaign-discount-code]')) {
          fetch('/discount/' + $form.parentElement.parentElement.parentElement.querySelector('[data-campaign-discount-code]').innerText.trim()).then(() => {
            log('discount:added');
          });
        }
      })()
        .catch(function (err) {
          log(err);
  
          let $msg = $form.querySelector('.product-added-to-cart');
          if ($msg && $msg.length !== 0) {
            $msg.innerHTML = theme.strings.errorCart;
  
            setTimeout(function () {
              $msg.innerHTML = '';
            }, 3000);
          }
        })
        .finally(cleanup);
    }, true); // Use capture phase to intercept before theme.js handler
  }
 

  function addSourceToUpsellForms(upsellId) {
    setTimeout(() => {
      document.querySelectorAll('.cart-popup-products form[action*="/cart/add"]').forEach(form => {
        if (!form.querySelector('input[name="properties[_source]"]')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_source]';
          input.value = upsellId;
          form.appendChild(input);
        }
      });
    }, 200);
  }

// Function to check if upsell should be shown based on collection handles
function findMatchingUpsell(collectionHandlesString) {
  
  if (!collectionHandlesString || !window.upsellData) return null;
  
  const productCollections = collectionHandlesString.split(',').map(handle => handle.trim());
  
  const matchingUpsell = window.upsellData.find(upsell => {
    
    if (!isUpsellActive(upsell)) {
      return false;
    }
    
    const matches = productCollections.includes(upsell.collection_handle);
    return matches;
  });
  
  return matchingUpsell;
}

// Simplified function that just checks true/false
function shouldShowUpsellForCollections(collectionHandlesString) {
  return findMatchingUpsell(collectionHandlesString) !== null;
}

// Function to check if current date is within upsell date range
function isUpsellActive(upsell) {
  if (!upsell.start_date && !upsell.end_date) {
    return true; 
  }
  
  const now = new Date();
  const startDate = upsell.start_date ? new Date(upsell.start_date) : null;
  const endDate = upsell.end_date ? new Date(upsell.end_date) : null;
  
  if (startDate && now < startDate) return false;
  if (endDate && now > endDate) return false;
  
  return true;
}

  /* cart change return shipping label to 1 */
async function checkCartItems(forceCartBuild = false) {
  const useNewGiftWrapping =
    document.body.getAttribute('data-use-new-gift-wrapping-system') === 'true';

  const updateData = { updates: {} };
  const changeDatas = []; // for /cart/change.js (line item properties)
  let creditAmount = 0;
  let giftWrappingAmount = 0;
  let responseJson;

  document.querySelectorAll('.cart__item').forEach(function ($item) {
    const nameEl = $item.querySelector('.cart__item-name');
    const itemInput = $item.querySelector('[name="updates[]"]');
    if (!nameEl || !itemInput) return;

    const itemName = nameEl.innerHTML.toLowerCase();
    const variantId = itemInput.getAttribute('data-id');

    // Skip insurance and pricematch products - they manage themselves
    const insuranceCheckbox = document.getElementById('extended-shipping-insurance');
    const pricematchCheckbox = document.getElementById('pricematch-insurance');

    if (
      (insuranceCheckbox && variantId === insuranceCheckbox.value) ||
      (pricematchCheckbox && variantId === pricematchCheckbox.value)
    ) {
      return;
    }

    // ------------------------------------------------------------
    // CREDIT PRODUCTS (Løn / Børnepenge)
    // ------------------------------------------------------------
    if (
      itemName.includes('løn ') ||       // da
      itemName.includes('børnepenge ')   // da
    ) {
      creditAmount += 1;

      if (creditAmount === 1) {
        // First credit item → force quantity = 1
        if (itemInput.value !== '1') {
          updateData.updates[variantId] = 1;
        }
      } else {
        // Any extra credit items → remove
        updateData.updates[variantId] = 0;
      }
    }

    // ------------------------------------------------------------
    // OLD GIFT-WRAPPING SYSTEM (uses #gift-wrapping checkbox)
    // Only when the new system is DISABLED
    // ------------------------------------------------------------
    if (!useNewGiftWrapping) {
      const changeTmp = {};

      const itemProperties = JSON.parse(
        $item.getAttribute('data-properties') || '[]'
      );
      const itemQuantity = $item.getAttribute('data-quantity') || 1;

      // Special gift-wrap product line, title includes "gaveindpakning"
      if (itemName.includes('gaveindpakning')) {
        // Make the gift-wrapping line read-only
        itemInput.readOnly = true;
        const minusBtn = itemInput.parentElement.querySelector('.js-qty__adjust--minus');
        const plusBtn = itemInput.parentElement.querySelector('.js-qty__adjust--plus');
        if (minusBtn) minusBtn.disabled = true;
        if (plusBtn) plusBtn.disabled = true;

        // OLD behavior: single checkbox controls quantity 0/1
        let giftWraippingAmount = 0;
        const giftWrappingInput = document.querySelector('#gift-wrapping:checked');
        if (giftWrappingInput) {
          giftWraippingAmount = 1;
        }

        if (itemInput.value !== giftWraippingAmount.toString()) {
          updateData.updates[variantId] = giftWraippingAmount;
        }
      }

      // -----------------------------
      // Line item properties (_gift_wrapping etc.)
      // -----------------------------
      const giftWrappingInput = document.querySelector('#gift-wrapping:checked');
      const giftWrappingExist = document.querySelector('.cart-product-type-gift-wrapping');

      // Prepare properties object from itemProperties array, skipping "null" keys
      const propertiesObj = {};
      if (Array.isArray(itemProperties)) {
        itemProperties.forEach(function (pair) {
          if (
            Array.isArray(pair) &&
            pair.length === 2 &&
            pair[0] !== null &&
            pair[0] !== 'null'
          ) {
            propertiesObj[pair[0]] = pair[1];
          }
        });
      }

      if (!giftWrappingExist && giftWrappingInput) {
        // Set or replace _gift_wrapping and add the extra property
        propertiesObj['_gift_wrapping'] = 'Yes';
        propertiesObj[giftWrappingInput.getAttribute('data-name')] =
          giftWrappingInput.getAttribute('value');
        changeTmp.properties = propertiesObj;
        changeTmp.quantity = itemQuantity;
      }

      if (giftWrappingExist && !giftWrappingInput) {
        // Set or replace _gift_wrapping to 'No'
        propertiesObj['_gift_wrapping'] = 'No';
        changeTmp.properties = propertiesObj;
        changeTmp.quantity = itemQuantity;
      }

      delete propertiesObj['null'];

      if (Object.keys(changeTmp).length !== 0) {
        changeTmp.id = itemInput.getAttribute('data-id');
        changeDatas.push(changeTmp);
      }
    }
    // (When useNewGiftWrapping === true we do NOTHING here;
    // GiftWrapManager handles all gift-wrap logic.)
  });

  // ------------------------------------------------------------
  // apply /cart/change.js for line-item property changes
  // (only relevant for OLD system)
  // ------------------------------------------------------------
  if (changeDatas.length !== 0) {
    for (const changeData of changeDatas) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify(changeData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        }
      });

      responseJson = await response.json();
    }
  }

  // ------------------------------------------------------------
  // apply /cart/update.js (quantities)  [CREDITS + OLD GIFT-WRAP]
  // ------------------------------------------------------------
  if (Object.keys(updateData.updates).length !== 0) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify(updateData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        }
      });

      responseJson = await response.json();
    } catch (err) {
      log(err);
    }
  }

  // ------------------------------------------------------------
  // DISPATCH CART EVENTS
  // ------------------------------------------------------------
  if (changeDatas.length !== 0 || Object.keys(updateData.updates).length !== 0) {
    setTimeout(() => {
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: responseJson }
      }));
    }, 400);
  } else if (forceCartBuild) {
    setTimeout(function () {
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }, 400);
  }
}
  

function cartProductEventListeners() {
  const useNewGiftWrapping =
    document.body.getAttribute('data-use-new-gift-wrapping-system') === 'true';

  // ------------------------------------------------------------------
  // Old gift wrap UI hooks (product__gift_wrapping-selector)
  // Only relevant when not using the new GiftWrapManager system.
  // ------------------------------------------------------------------
  if (!useNewGiftWrapping) {
    if (document.querySelector('.js-product-gift-wrapping')) {
      document
        .querySelectorAll('.product__gift_wrapping-selector input')
        .forEach(($giftWrappingSelector) => {
          $giftWrappingSelector.addEventListener('click', function () {
            log('product__gift_wrapping-selector', this.checked);
            if (this.checked === true) {
              if (Shopify.Cart && Shopify.Cart.GiftWrap && Shopify.Cart.GiftWrap.set) {
                Shopify.Cart.GiftWrap.set();
              }
            } else {
              if (Shopify.Cart && Shopify.Cart.GiftWrap && Shopify.Cart.GiftWrap.remove) {
                Shopify.Cart.GiftWrap.remove();
              }
            }
          });
        });
    } else {
      log('WARNING - Gift Wrapping Missing!');
    }
  }

  // ------------------------------------------------------------------
  // Remove buttons for cart items (works for both systems)
  // ------------------------------------------------------------------
  document.querySelectorAll('.cart__item').forEach(function ($item) {
    const removeButtons = $item.querySelectorAll('.cart__remove a');

    removeButtons.forEach(function ($removeBtn) {
      $removeBtn.addEventListener('click', function (e) {
        e.preventDefault();

        // Custom product credit
        if ($item.classList.contains('cart-product-type-credit')) {
          const key = $item.getAttribute('data-key');
          if (
            key &&
            Shopify.Cart &&
            Shopify.Cart.Credit &&
            typeof Shopify.Cart.Credit.remove === 'function'
          ) {
            Shopify.Cart.Credit.remove(key.split(':')[0]);
          }
          return;
        }

        // old gift-wrapping product row
        if (!useNewGiftWrapping && $item.classList.contains('cart-product-type-gift-wrapping')) {
          if (Shopify.Cart && Shopify.Cart.GiftWrap && Shopify.Cart.GiftWrap.remove) {
            Shopify.Cart.GiftWrap.remove();
          }
          return;
        }

        // All other items (including new-system gift-wrap add-on lines)
        const href = $removeBtn.getAttribute('href');
        if (!href) return;

        fetch(href.replace('/cart/change', '/cart/change.js'))
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            setTimeout(function () {
              document.dispatchEvent(new Event('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: data }
              }));
            }, 400);
          })
          .catch(function (err) {
            console.error('Error removing cart item:', err);
          });
      });
    });
  });
}
  

  cartProductEventListeners();
  checkCartItems();

  /* cart cross sells */
  function cartCrossSells() {
    if (document.querySelector('.cart-product-cross-sells-top') || document.querySelector('.cart-product-cross-sells-bottom')) {
      fetch('/cart?t=' + Date.now() + '&view=ajax-cross-sells').then(function (response) {
        return response.text();
      }).then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const cartProductCrossCellClassNames = [
          'cart-product-cross-sells-top',
          'cart-product-cross-sells-bottom'
        ];

        cartProductCrossCellClassNames.forEach(function ($className) {
          if (doc.querySelector('.ajax-' + $className)) {
            if (document.querySelector('.' + $className)) {
              document.querySelector('.' + $className).innerHTML = doc.querySelector('.ajax-' + $className).innerHTML;
            }

            if (document.querySelector('.' + $className + ' [data-aos="overflow__animation"]')) {
              document.querySelector('.' + $className + ' [data-aos="overflow__animation"]').classList.add('aos-init', 'aos-animate');
            }

            document.querySelectorAll('.' + $className + ' [action="/cart/add"]').forEach(function ($form) {
              eventAddToCart($form);
            });
          }
        });
      });
    }
  }

  (function () {
    let cartFetchInFlight = false;
  
    function handleCartUpdate(cart) {
      if (!cart) return;
  
      // Update bubble
      const bubble = document.querySelector('.cart-link__bubble');
      if (bubble) {
        bubble.classList.add('cart-link__bubble--visible');
        bubble.innerHTML = cart.item_count || 0;
      }
  
      // If cart empty, we’re done
      if (!cart.item_count) return;
  
      // Rebuild cross-sells
      if (typeof cartCrossSells === 'function') {
        cartCrossSells();
      }
  
      // Shipping bar + other cart UI
      setTimeout(function () {
        if (typeof checkCartItems === 'function') {
          checkCartItems();
        }
        if (typeof cartProductEventListeners === 'function') {
          cartProductEventListeners();
        }
      }, 500);
    }
  
    document.addEventListener('cart:updated', function (evt) {
      // we prefer cart from event detail if present
      if (evt.detail && evt.detail.cart) {
        handleCartUpdate(evt.detail.cart);
        return;
      }
  
      // Fallback: we fetch /cart.js once
      if (cartFetchInFlight) return;
      cartFetchInFlight = true;
  
      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          cartFetchInFlight = false;
          handleCartUpdate(cart);
        })
        .catch(function (err) {
          cartFetchInFlight = false;
          console.error('cart:updated fallback /cart.js failed', err);
        });
    });
  })();

  /* cart gift wraps */
  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.GiftWrap = {};

  // Disabled by Mercive
  /* Cart gift wrapping - NEW */
  // Shopify.Cart.GiftWrap.set = function () {
  //   checkCartItems(true);
  // }

  Shopify.Cart.GiftWrap.remove = function () {
    checkCartItems(true);
  }

  /* Cart gift wrapping - OLD */
  Shopify.Cart.GiftWrap.set = function () {
    const giftWrappingId = document.querySelector('.js-product-gift-wrapping').getAttribute('data-variant-id');

    // Add gift wrapping with _addOn property
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: giftWrappingId,
        quantity: 1,
        properties: {
          '_addOn': true
        }
      }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(function (response) {
      return response.json();
    }).then(function () {
      // Set cart attribute
      return fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({
          attributes: {
            'gift-wrapping': 1
          }
        }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        }
      });
    }).then(function () {
      checkCartItems(true);
    }).catch(function (err) {
      log(err);
    });
  }

  /* Cart gift wrapping - OLD */
  Shopify.Cart.GiftWrap.remove = function () {
    const giftWrappingId = document.querySelector('.js-product-gift-wrapping').getAttribute('data-variant-id');

    var data = {};
    data['updates'] = {};
    data['updates'][giftWrappingId] = 0;
    data['attributes'] = {
      'gift-wrapping': 0
    };

    // update cart
    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(function (response) {
      return response.json();
    }).then(function () {
      let gift = document.querySelector('[name="attributes[gift-wrapping]"][value="' + giftWrappingId + '"]');
      if (gift) {
        gift.checked = false
      }
      checkCartItems(true);
    }).catch(function (err) {
      log(err);
    });
  }

  if (document.querySelector('[name="attributes[gift-wrapping]"]')) {
    document.querySelector('[name="attributes[gift-wrapping]"]').addEventListener('click', function () {
      if (this.checked === true) {
        Shopify.Cart.GiftWrap.set();
      } else {
        Shopify.Cart.GiftWrap.remove();
      }
    });
  }

/* cart credit */
Shopify.Cart = Shopify.Cart || {};
Shopify.Cart.Credit = {};

Shopify.Cart.Credit.set = function (id) {
  // First, remove any existing credit options
  var creditSelected = document.querySelectorAll('[name="attributes[credit]"]:checked');
  if (creditSelected.length >= 2) {
    var removePromises = [];
    creditSelected.forEach(function ($credit) {
      if (id !== $credit.value) {
        $credit.checked = false;
        
        // Remove old credit
        removePromises.push(
          fetch('/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({
              id: $credit.value,
              quantity: 0
            }),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            }
          })
        );
      }
    });
    
    // Wait for removals to complete
    Promise.all(removePromises).then(function() {
      addNewCredit(id);
    });
  } else {
    addNewCredit(id);
  }
  
  function addNewCredit(id) {
    // Add new credit with _deferredPayment property
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: id,
        quantity: 1,
        properties: {
          '_deferredPayment': true
        }
      }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(function (response) {
      return response.json();
    }).then(function () {
      // Set cart attribute
      return fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({
          attributes: {
            'credit': parseInt(id)
          }
        }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        }
      });
    }).then(function () {
      checkCartItems(true);
    }).catch(function (err) {
      log(err);
    });
  }
}

Shopify.Cart.Credit.remove = function (id) {
  // Remove credit using cart/change.js
  fetch('/cart/change.js', {
    method: 'POST',
    body: JSON.stringify({
      id: id,
      quantity: 0
    }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    }
  }).then(function (response) {
    return response.json();
  }).then(function () {
    // Remove cart attribute
    return fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({
        attributes: {
          'credit': ''
        }
      }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    });
  }).then(function () {
    let credit = document.querySelector('[name="attributes[credit]"][value="' + id + '"]');
    if (credit) {
      credit.checked = false;
    }
    checkCartItems(true);
  }).catch(function (err) {
    log(err);
  });
}

document.querySelectorAll('[name="attributes[credit]"]').forEach(function ($credit) {
  $credit.addEventListener('click', function () {
    if (this.checked) {
      Shopify.Cart.Credit.set(this.value);
    } else {
      Shopify.Cart.Credit.remove(this.value);
    }
  });
});

  // cart return freight add discount code
  const cartReturnFreight = document.querySelector('.cart__item--properties[data-rf-code]');
  // console.log(cartReturnFreight);
  if (cartReturnFreight) {
    fetch('/discount/' + cartReturnFreight.getAttribute('data-rf-code'))
  }

  // mobile menu: a drawer with tabs (the top-level menu items), panels that slide in for the second level
  // and dropdowns inside the panels for the levels below
  const $mobileMenu = document.querySelector('#MobileMenu');
  if ($mobileMenu) {
    const $mobileMenuBody = $mobileMenu.querySelector('.mobile-menu__body');
    const $mobileMenuOpeners = document.querySelectorAll('.js-drawer-open-nav');

    const closeMobileMenuPanel = function () {
      $mobileMenu.querySelectorAll('.mobile-menu__panel.is-active').forEach(function ($panel) {
        $panel.classList.remove('is-active');
      });
      $mobileMenu.classList.remove('has-panel');
    };

    // dropdowns close again when their panel or the dropdown around them is left
    const closeMobileMenuDropdowns = function ($scope) {
      $scope.querySelectorAll('.mobile-menu__dropdown.is-open').forEach(function ($dropdown) {
        $dropdown.classList.remove('is-open');
        $dropdown.querySelector('.js-mobile-menu-toggle').setAttribute('aria-expanded', false);
      });
    };

    const setMobileMenuTab = function (tab) {
      // a panel covers the tabs' content, so a tab tapped from inside a panel has to leave it
      closeMobileMenuPanel();
      $mobileMenu.querySelectorAll('[data-mobile-menu-tab]').forEach(function ($t) {
        const active = $t.getAttribute('data-mobile-menu-tab') === tab;
        $t.classList.toggle('is-active', active);
        $t.setAttribute('aria-selected', active);
      });
      $mobileMenu.querySelectorAll('[data-mobile-menu-pane]').forEach(function ($pane) {
        $pane.classList.toggle('is-active', $pane.getAttribute('data-mobile-menu-pane') === tab);
      });
      $mobileMenuBody.scrollTop = 0;
    };

    const setMobileMenuOpen = function (open) {
      document.documentElement.classList.toggle('mobile-menu-open', open);
      $mobileMenu.classList.toggle('is-open', open);
      $mobileMenu.setAttribute('aria-hidden', !open);
      $mobileMenuOpeners.forEach(function ($opener) {
        $opener.setAttribute('aria-expanded', open);
      });
    };

    // the menu opens where it was left, also on the next page of the visit: the tab, the panel, its open dropdowns
    // and how far each list was scrolled, kept in sessionStorage. A panel that is no longer there (the menu has
    // changed) is forgotten
    const mobileMenuStateKey = 'mobile-menu-state';
    const saveMobileMenuState = function () {
      const $tab = $mobileMenu.querySelector('[data-mobile-menu-tab].is-active');
      const $panel = $mobileMenu.querySelector('.mobile-menu__panel.is-active');
      const state = {
        tab: $tab ? $tab.getAttribute('data-mobile-menu-tab') : null,
        panel: $panel ? $panel.id : null,
        dropdowns: [],
        panelScroll: $panel ? $panel.scrollTop : 0,
        bodyScroll: $mobileMenuBody.scrollTop
      };
      if ($panel) {
        $panel.querySelectorAll('.mobile-menu__dropdown').forEach(function ($dropdown, i) {
          if ($dropdown.classList.contains('is-open')) state.dropdowns.push(i);
        });
      }
      try {
        sessionStorage.setItem(mobileMenuStateKey, JSON.stringify(state));
      } catch (e) {}
    };
    const readMobileMenuState = function () {
      try {
        return JSON.parse(sessionStorage.getItem(mobileMenuStateKey));
      } catch (e) {
        return null;
      }
    };

    const openMobileMenu = function () {
      // where it was left, or as new: first tab, first level, top of the list, dropdowns closed. Panels and arrows
      // don't animate while the menu is closed, and the reflow keeps this from animating once it is open
      const state = readMobileMenuState();
      const $savedTab = state && state.tab ? Array.prototype.find.call($mobileMenu.querySelectorAll('[data-mobile-menu-tab]'), function ($t) {
        return $t.getAttribute('data-mobile-menu-tab') === state.tab;
      }) : null;
      const $tab = $savedTab || $mobileMenu.querySelector('[data-mobile-menu-tab]');
      closeMobileMenuPanel();
      closeMobileMenuDropdowns($mobileMenu);
      if ($tab) setMobileMenuTab($tab.getAttribute('data-mobile-menu-tab'));
      const $panel = $savedTab && state.panel ? document.getElementById(state.panel) : null;
      if ($panel && $mobileMenu.contains($panel) && $panel.classList.contains('mobile-menu__panel')) {
        const $dropdowns = $panel.querySelectorAll('.mobile-menu__dropdown');
        (state.dropdowns || []).forEach(function (i) {
          if (!$dropdowns[i]) return;
          $dropdowns[i].classList.add('is-open');
          $dropdowns[i].querySelector('.js-mobile-menu-toggle').setAttribute('aria-expanded', true);
        });
        $panel.classList.add('is-active');
        $mobileMenu.classList.add('has-panel');
      }
      void $mobileMenu.offsetWidth;
      setMobileMenuOpen(true);
      if ($savedTab) {
        $mobileMenuBody.scrollTop = state.bodyScroll || 0;
        if ($panel) $panel.scrollTop = state.panelScroll || 0;
      }
    };

    const closeMobileMenu = function () {
      saveMobileMenuState();
      setMobileMenuOpen(false);
    };

    // capture + stopImmediatePropagation keep theme.js from opening its own NavDrawer
    $mobileMenuOpeners.forEach(function ($opener) {
      $opener.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openMobileMenu();
      }, true);
    });

    document.querySelectorAll('.js-mobile-menu-close').forEach(function ($close) {
      $close.addEventListener('click', closeMobileMenu);
    });

    $mobileMenu.addEventListener('click', function (e) {
      const $tab = e.target.closest('[data-mobile-menu-tab]');
      if ($tab) {
        setMobileMenuTab($tab.getAttribute('data-mobile-menu-tab'));
        return;
      }

      // a card opens its panel; a campaign pill opens the panel of the card in its tab with the same link, if there is one
      const $panelOpener = e.target.closest('[data-mobile-menu-open]');
      const $campaign = e.target.closest('.mobile-menu__campaign');
      let $panel = null;
      if ($panelOpener) {
        $panel = document.getElementById($panelOpener.getAttribute('data-mobile-menu-open'));
      } else if ($campaign) {
        const tab = $campaign.closest('[data-mobile-menu-pane]').getAttribute('data-mobile-menu-pane');
        $panel = Array.prototype.find.call($mobileMenu.querySelectorAll('.mobile-menu__panel'), function ($p) {
          return $p.getAttribute('data-mobile-menu-panel-tab') === tab && $p.getAttribute('data-mobile-menu-panel-url') === $campaign.getAttribute('href');
        });
      }
      if ($panel) {
        e.preventDefault();
        closeMobileMenuDropdowns($panel);
        $panel.scrollTop = 0;
        $panel.classList.add('is-active');
        $mobileMenu.classList.add('has-panel');
        return;
      }

      // dropdowns inside a panel
      const $toggle = e.target.closest('.js-mobile-menu-toggle');
      if ($toggle) {
        const open = $toggle.parentNode.classList.toggle('is-open');
        $toggle.setAttribute('aria-expanded', open);
        if (!open) closeMobileMenuDropdowns($toggle.parentNode);
        return;
      }

      // the panel header and the floating button: one level back, or close the menu on the first level
      if (e.target.closest('.js-mobile-menu-back')) {
        if ($mobileMenu.classList.contains('has-panel')) closeMobileMenuPanel();
        else closeMobileMenu();
        return;
      }

      // the search field is a button: close the menu and open the header search (which focuses its input)
      if (e.target.closest('.js-mobile-menu-search')) {
        closeMobileMenu();
        const $search = document.querySelector('.header-search-mobile .js-search-header') || document.querySelector('.js-search-header');
        if ($search) $search.click();
        return;
      }

      // the country selector popup would open underneath the menu
      if (e.target.closest('a[href="#country-selector-popup"]')) closeMobileMenu();
    });

    // after every tap in the menu (a tab, a panel, a dropdown, back, or a link to the next page): where it is now
    $mobileMenu.addEventListener('click', function () {
      if ($mobileMenu.classList.contains('is-open')) saveMobileMenuState();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !$mobileMenu.classList.contains('is-open')) return;
      if ($mobileMenu.classList.contains('has-panel')) {
        closeMobileMenuPanel();
        saveMobileMenuState();
      } else closeMobileMenu();
    });

    // the hamburger is hidden from 768px, so don't leave the menu open above that
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768 && $mobileMenu.classList.contains('is-open')) closeMobileMenu();
    });
  }

  /* youtube lazyload */
  var youtube = document.querySelectorAll(".youtube-embedded");
  for (var i = 0; i < youtube.length; i++) {
    var image = new Image();

    // thumbnail image source
    var source = '';
    var className = '';
    if (youtube[i].dataset.source && youtube[i].dataset.source !== "") {
      source = youtube[i].dataset.source;
      image.className = 'lazyload';
      className = 'image-fit';
    } else {
      source = 'https://img.youtube.com/vi/' + youtube[i].dataset.embed + '/sddefault.jpg';
      image.className = 'lazyload';
      className = 'image-box';
    }

    // Load the image asynchronously
    image.src = source;
    if (youtube[i].dataset.alt) {
      image.alt = youtube[i].dataset.alt;
    }

    image.addEventListener('load', function () {
      youtube[i].querySelector('.youtube-image').classList.add(className);
      youtube[i].querySelector('.youtube-image').appendChild(image);
    }(i));

    youtube[i].addEventListener('click', function () {
      var iframe = document.createElement('iframe');

      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + this.dataset.embed + '?rel=0&showinfo=0&autoplay=1');

      this.innerHTML = '';
      this.appendChild(iframe);
    });
  }

  // employee open popup
  var employees = document.querySelectorAll('.section-employee');
  for (var i = 0; i < employees.length; i++) {
    employees[i].addEventListener('click', function () {
      var modal = this.nextElementSibling;
      modal.classList.add('employee-active');
    });

    employees[i].nextElementSibling.querySelector('.section-employee-modal-close').addEventListener('click', function () {
      document.querySelector('.section-employee-modal.employee-active').classList.remove('employee-active');
    });
    employees[i].nextElementSibling.querySelector('.section-employee-modal-bg').addEventListener('click', function () {
      document.querySelector('.section-employee-modal.employee-active').classList.remove('employee-active');
    });
  }

  // auto open klaviyo popup on variant change
  document.addEventListener('variant:change', function (e) {
    if (
      (
        document.querySelector('.product-single__meta .variant-wrapper--dropdown select option:checked')
        &&
        document.querySelector('.product-single__meta .variant-wrapper--dropdown select option:checked').classList.contains('disabled')
      )
      ||
      (
        document.querySelector('.product-single__meta .variant-wrapper input:checked')
        &&
        document.querySelector('.product-single__meta .variant-wrapper input:checked').classList.contains('disabled')
      )
    ) {
      setTimeout(function () {
        document.querySelector('.btn.klaviyo-bis-trigger').click();
      }, 300);
    }
  });

  // auto open klaviyo popup on load if not in stock
  if (document.querySelector('.product-add-to-cart .add-to-cart:is(.disabled)')) {
    setTimeout(function () {
      document.querySelector('.btn.klaviyo-bis-trigger').click();
    }, 500);
  }

  /* product inline upsells */
  document.addEventListener('variant:change', function (e) {
    productInlineUpsellsAutoSelector(e.detail);
  });

  // change on load
  const variantSelected = document.querySelector('.variant-input input:checked');
  if (variantSelected) {
    productInlineUpsellsAutoSelector(variantSelected);
  }

  function productInlineUpsellsAutoSelector(variantSelected) {
    document.querySelectorAll('.product-inline-upsells .product-inline-upsell-item').forEach(function ($el) {
      let hasSelection = false;
      $el.querySelectorAll('select option').forEach(function (option) {
        if (!option.getAttribute('data-name')) {
          return;
        }

        if (hasSelection) {
          return;
        }

        const variantName = variantSelected.value.split('/')[0]; // fix L/XL -> L
        if (
          option.getAttribute('data-name') === variantSelected.value ||
          option.getAttribute('data-name') === variantName ||
          option.getAttribute('data-name').includes(variantName + '/') ||
          option.getAttribute('data-name').includes('/' + variantName)
        ) {
          $el.querySelectorAll('select option').forEach(function (op) {
            op.selected = false;
          });

          option.selected = true;
          hasSelection = true;
        }
      });
    });
  }

  /* filter drawer mod */
  function filterDrawerRedefine() {
    if (typeof theme.FilterDrawer.closeNow !== 'undefined') {
      return;
    }

    theme.FilterDrawer.isOpen = document.querySelector('#FilterDrawer').classList.contains('drawer--is-open');
    theme.FilterDrawer.closeNow = theme.FilterDrawer.close;
    theme.FilterDrawer.close = filterDrawerClose;
  }

  function filterDrawerClose(evt) {
    // log('filterDrawerClose', this.isOpen);

    if (!this.isOpen) {
      return;
    }
    // log('filterDrawerClose2');

    // Do not close if click event came from inside drawer
    if (!evt) {
      return;
    }

    if (evt.target.closest('.js-drawer-close')) {
      // Do not close if using the drawer close button
    } else if (evt.target.closest('.drawer')) {
      return;
    }

    if (evt.target.parentElement?.classList.contains('tag')) {
      initFilterDrawer();
      return;
    }

    // log('filterDrawerClose3');
    // log(evt);

    theme.FilterDrawer.closeNow();
  }

  document.addEventListener('drawerOpen.FilterDrawer', function () {
    log('drawerOpen.FilterDrawer');

    filterDrawerRedefine();

    // only fetch drawer content if empty
    if (document.querySelector('#CollectionGridFiltersFormAjax').childNodes.length !== 0) {
      return;
    }

    initFilterDrawer();
  });

  document.addEventListener('collection:reloaded', function () {
    log('collection:reloaded');

    filterDrawerRedefine();

    if ($collectionReload) {
      // hide price slider
      // document.querySelector('#FilterDrawer .price-range__display-wrapper').style.visibility = 'hidden';
      document.querySelector('#FilterDrawer .price-range__slider-wrapper').style.visibility = 'hidden';
    } else {
      // fetch on price slider change
      const $slider = document.querySelector('#FilterDrawer .price-range__slider');
      if ($slider && $slider.noUiSlider && typeof $slider.noUiSlider.destroy === 'function') {
        $slider.noUiSlider.on('change', function () {
          $collectionReload = true;
          initFilterDrawer();
        });
      }
    }

    // add events to product cards
    document.querySelectorAll('#CollectionAjaxContent [action="/cart/add"]').forEach(function ($form) {
      eventAddToCart($form);
    });
  });

  $collectionReload = false;

  function initFilterDrawer() {
    fetch(window.location.pathname + window.location.search + (window.location.search ? '&' : '?') + 'view=ajax-filter').then(function (response) {
      return response.text();
    }).then(function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      if (doc.querySelector('#CollectionGridFiltersFormAjax')) {
        // replace sidebar html
        document.querySelector('#CollectionGridFiltersFormAjax').innerHTML = doc.querySelector('#CollectionGridFiltersFormAjax').innerHTML;

        // sort xxxs xxs  xs s m l xl xxl xxxl
        const sizeList = [
          'XXXL',
          'XXL',
          'XL',
          'L',
          'M',
          'S',
          'XS',
          'XXS',
          'XXXS',
          'ONE-SIZE',
        ];

        sizeList.forEach(function (size) {
          document.querySelectorAll('#CollectionGridFiltersFormAjax .collection-sidebar__group').forEach(function ($group) {
            if ($group.querySelector('.collapsible-trigger-btn').innerHTML.trim().includes('Størrelse')) {
              const $tagList = $group.querySelector('.tag-list');

              $group.querySelectorAll('.tag-list .tag').forEach(function ($tag) {
                if ($tag.querySelector('.tag__text').innerHTML.trim() === size) {
                  $tagList.firstChild.after($tag);
                  return true;
                }
              });
            }
          });
        });

        // replace lang tags
        if (typeof replaceLanguageDefault !== 'undefined' && typeof replaceLanguageCurrent !== 'undefined' && replaceLanguageDefault.length !== 0 && replaceLanguageCurrent.length !== 0) {
          document.querySelectorAll('#CollectionGridFiltersFormAjax .tag-list .tag').forEach(function ($tag) {
            $tagText = $tag.querySelector('.tag__text').innerHTML.trim();
            if (replaceLanguageDefault.includes($tagText)) {
              replaceLanguageDefault.forEach(function ($default, $index) {
                if ($tagText === $default) {
                  // log($tagText, $default, replaceLanguageCurrent[$index]);
                  if (replaceLanguageCurrent[$index]) {
                    $tag.querySelector('.tag__text').innerHTML = replaceLanguageCurrent[$index];
                    return true;
                  }
                }
              });
            }
          });

          // replace lang tag headers
          document.querySelectorAll('#CollectionGridFiltersFormAjax .collection-sidebar__group').forEach(function ($group) {
            $groupHtml = $group.querySelector('.collapsible-trigger-btn').innerHTML;
            replaceLanguageDefault.some(function ($default, $index) {
              if ($groupHtml.includes($default)) {
                // log($groupHtml, $default, replaceLanguageCurrent[$index]);
                $group.querySelector('.collapsible-trigger-btn').innerHTML = $groupHtml.replace($default, replaceLanguageCurrent[$index]);
                return true;
              }
            });
          });
        }

        // check if collection reload
        $collectionReload = false;

        // reinit sidebar
        theme.sections.reinit('collection-grid');

        // reinit collection products
        // theme.reinitProductGridItem();
        theme.collapsibles.init();

        // fetch on input change
        document.querySelectorAll('#CollectionGridFiltersFormAjax .tag__input').forEach(function ($input) {
          $input.addEventListener('change', function () {
            $collectionReload = true;
            initFilterDrawer();
          });
        });

        // fetch on price slider change
        const $slider = document.querySelector('#FilterDrawer .price-range__slider');
        if ($slider && $slider.noUiSlider && typeof $slider.noUiSlider.destroy === 'function') {
          $slider.noUiSlider.on('change', function () {
            $collectionReload = true;
            initFilterDrawer();
          });

          document.querySelectorAll('.price-range-selector input').forEach(function ($input, $handle) {
            $input.addEventListener('change', function () {
              $slider.noUiSlider.setHandle($handle, this.value);
            });

            $input.addEventListener('keyup', function (e) {
              if (e.keyCode !== 13) {
                return false;
              }

              $slider.noUiSlider.setHandle($handle, this.value);
            });
          });
        }

        filterDrawerRedefine();
      }
    }).catch(function (error) {
      log(error);
    });
  }

  // footer "Cookieindstillinger" link reopens the Cookiebot consent dialog (the floating widget is hidden)
  document.querySelectorAll('.js-cookie-settings').forEach(function ($link) {
    $link.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
        window.Cookiebot.renew();
      }
    });
  });

  // quick add: "+" on a product card opens a sheet with the product's images, colours and sizes. The content is
  // sections/quick-add.liquid and carries the regular card form, so adding to the cart runs the same code as the cards.
  let $quickAdd = null;
  let $quickAddScrim = null;
  let $quickAddOpener = null;
  let quickAddRequest = 0;

  const quickAddForm = function () {
    return $quickAdd.querySelector('.quick-add__form form');
  };

  const closeQuickAdd = function () {
    if (!$quickAdd || !$quickAdd.classList.contains('is-open')) return;
    $quickAdd.classList.remove('is-open');
    $quickAddScrim.classList.remove('is-open');
    document.documentElement.classList.remove('quick-add-open');
    if ($quickAddOpener) $quickAddOpener.focus();
  };

  // the same line item properties the card's size picker sets for preorder sizes (.variant-wrapper--button change)
  const syncQuickAddPreorder = function ($form, $option) {
    const preorder = $option.dataset.preorder === 'true' && $option.dataset.warehouseGoods !== 'true';
    let $input = $form.querySelector('#preorder-input');
    let $delivery = $form.querySelector('#preorder-expected-delivery');

    if (!preorder) {
      if ($input) $input.remove();
      if ($delivery) $delivery.remove();
      return;
    }

    if (!$input) {
      $input = document.createElement('input');
      $input.type = 'hidden';
      $input.id = 'preorder-input';
      $input.name = 'properties[' + theme.strings.preorderTitle + ']';
      $input.value = '✓';
      $form.appendChild($input);
    }

    if ($option.dataset.preorderEta) {
      if (!$delivery) {
        $delivery = document.createElement('input');
        $delivery.type = 'hidden';
        $delivery.id = 'preorder-expected-delivery';
        $delivery.name = 'properties[' + theme.strings.preorderExpectedDelivery + ']';
        $form.appendChild($delivery);
      }
      $delivery.value = $option.dataset.preorderEta.trim();
    }
  };

  // KO.1: "Vælg størrelse" unfolds the sizes; the sheet scrolls so the whole list is in view
  const toggleQuickAddSizes = function (open) {
    const $dd = $quickAdd.querySelector('[data-quick-add-dd]');
    const $list = $quickAdd.querySelector('[data-quick-add-sizes]');
    if (!$dd || !$list) return;
    $list.hidden = !open;
    $dd.setAttribute('aria-expanded', open);
    if (!open) return;
    const sheet = $quickAdd.getBoundingClientRect();
    const overflow = Math.min($list.getBoundingClientRect().bottom - sheet.bottom + 18, $dd.getBoundingClientRect().top - sheet.top - 12);
    if (overflow > 0) $quickAdd.scrollBy({ top: overflow, behavior: 'smooth' });
  };

  // a size is picked: mark it, show it with its status in the field and unlock the button
  const selectQuickAddSize = function ($size) {
    const $content = $quickAdd.querySelector('[data-quick-add-content]');
    const $go = $quickAdd.querySelector('[data-quick-add-go]');
    const $form = quickAddForm();
    const $option = $form ? $form.querySelector('select[name="id"] option[value="' + $size.dataset.variantId + '"]') : null;
    const preorder = !!$option && $option.dataset.preorder === 'true' && $option.dataset.warehouseGoods !== 'true';

    $quickAdd.querySelectorAll('.quick-add__size').forEach(function ($el) {
      $el.classList.toggle('is-active', $el === $size);
      $el.setAttribute('aria-pressed', $el === $size);
    });

    const $label = $quickAdd.querySelector('[data-quick-add-dd-label]');
    const $state = $quickAdd.querySelector('[data-quick-add-dd-state]');
    const $sizeState = $size.querySelector('.quick-add__state');
    if ($label) $label.textContent = $size.querySelector('.quick-add__opt-name').textContent;
    if ($state && $sizeState) {
      $state.className = $sizeState.className;
      $state.innerHTML = $sizeState.innerHTML;
    }
    toggleQuickAddSizes(false);

    if ($go) {
      $go.disabled = false;
      $go.removeAttribute('data-waiting');
      $go.dataset.variantId = $size.dataset.variantId;
      $go.textContent = preorder ? $content.dataset.labelPreorder : $content.dataset.labelAdd;
    }
  };

  // picks the size in the card form and submits it, so the regular add-to-cart code does the rest
  const submitQuickAdd = function ($go) {
    // no size chosen yet: open the list instead
    if (!$go.dataset.variantId) {
      toggleQuickAddSizes(true);
      return;
    }
    const $form = quickAddForm();
    const $select = $form ? $form.querySelector('select[name="id"]') : null;
    const $submit = $form ? $form.querySelector('[type="submit"]') : null;
    if (!$select || !$submit) return;

    $select.value = $go.dataset.variantId;
    const $option = $select.querySelector('option:checked');
    if (!$option || $option.value !== $go.dataset.variantId) return;
    syncQuickAddPreorder($form, $option);

    if ($form.requestSubmit) {
      $form.requestSubmit($submit);
    } else {
      $submit.click();
    }
    closeQuickAdd();
  };

  const openQuickAdd = function (url, $opener) {
    if (!$quickAdd) {
      $quickAddScrim = document.createElement('div');
      $quickAddScrim.className = 'quick-add-scrim';
      $quickAdd = document.createElement('div');
      $quickAdd.className = 'quick-add';
      $quickAdd.setAttribute('role', 'dialog');
      $quickAdd.setAttribute('aria-modal', 'true');
      $quickAdd.tabIndex = -1;
      document.body.appendChild($quickAddScrim);
      document.body.appendChild($quickAdd);

      $quickAddScrim.addEventListener('click', closeQuickAdd);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeQuickAdd();
      });

      $quickAdd.addEventListener('click', function (e) {
        const $target = e.target.closest('[data-quick-add-close], [data-quick-add-url], [data-quick-add-dot], [data-quick-add-dd], .quick-add__size, button[data-quick-add-go]');
        if (!$target) return;

        if ($target.hasAttribute('data-quick-add-dd')) {
          toggleQuickAddSizes($target.getAttribute('aria-expanded') !== 'true');
        } else if ($target.hasAttribute('data-quick-add-close')) {
          closeQuickAdd();
        } else if ($target.hasAttribute('data-quick-add-url')) {
          // another colour is another product: load it into the sheet
          openQuickAdd($target.getAttribute('data-quick-add-url'));
        } else if ($target.hasAttribute('data-quick-add-dot')) {
          const $track = $quickAdd.querySelector('[data-quick-add-track]');
          const $image = $track.children[parseInt($target.getAttribute('data-quick-add-dot'), 10)];
          if ($image) $track.scrollTo({ left: $image.offsetLeft - $track.firstElementChild.offsetLeft, behavior: 'smooth' });
        } else if ($target.classList.contains('quick-add__size')) {
          selectQuickAddSize($target);
        } else {
          submitQuickAdd($target);
        }
      });

      // the dot follows the image in view (scroll does not bubble, so listen in the capture phase)
      $quickAdd.addEventListener('scroll', function (e) {
        if (!e.target.hasAttribute || !e.target.hasAttribute('data-quick-add-track')) return;
        const $first = e.target.firstElementChild;
        if (!$first) return;
        const index = Math.round(e.target.scrollLeft / ($first.offsetWidth + 8));
        $quickAdd.querySelectorAll('.quick-add__dot').forEach(function ($dot, i) {
          $dot.classList.toggle('is-active', i === index);
        });
      }, true);

      window.addEventListener('resize', syncQuickAddDots);
    }

    if ($opener) $quickAddOpener = $opener;
    const request = ++quickAddRequest;
    $quickAdd.classList.add('is-loading');
    document.documentElement.classList.add('quick-add-open');
    // a frame later, so the slide-in also runs the first time
    requestAnimationFrame(function () {
      $quickAddScrim.classList.add('is-open');
      $quickAdd.classList.add('is-open');
    });

    fetch(url.split('?')[0] + '?section_id=quick-add')
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        if (request !== quickAddRequest) return;
        const $content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-quick-add-content]');
        if (!$content) throw new Error('quick add content missing');

        $quickAdd.innerHTML = $content.outerHTML;
        $quickAdd.classList.remove('is-loading');
        $quickAdd.scrollTop = 0;
        syncQuickAddDots();

        const $form = quickAddForm();
        if ($form && typeof eventAddToCart === 'function') eventAddToCart($form);
        $quickAdd.focus();
      })
      .catch(function () {
        // the sheet could not load: the product page has everything
        window.location.href = url;
      });
  };

  // no dots under the images when every image is in view at once (e.g. two images)
  function syncQuickAddDots() {
    if (!$quickAdd) return;
    const $track = $quickAdd.querySelector('[data-quick-add-track]');
    const $dots = $quickAdd.querySelector('.quick-add__dots');
    if ($track && $dots) $dots.hidden = $track.scrollWidth <= $track.clientWidth + 1;
  }

  document.addEventListener('click', function (e) {
    const $plus = e.target.closest('.product-card__plus[data-quick-add-url]');
    if (!$plus) return;
    e.preventDefault();
    openQuickAdd($plus.getAttribute('data-quick-add-url'), $plus);
  });

  // product card heart. The wishlist app's own script only loads where its block is placed (product pages) and
  // takes over every heart it finds (data-initialized). Elsewhere the heart is kept working here, on the same
  // local list the app reads, flagged so the app saves it to the customer's account the next time it runs.
  const wishlistKey = 'custom_wishlist';

  const readWishlist = function () {
    try {
      const list = JSON.parse(localStorage.getItem(wishlistKey)) || [];
      // older entries are plain product ids
      return list.map(function (item) { return typeof item === 'object' && item ? item : { productId: String(item), addedAt: new Date().toISOString() }; });
    } catch (e) {
      return [];
    }
  };

  const inWishlist = function (list, productId) {
    return list.some(function (item) { return String(item.productId) === productId; });
  };

  const syncCardHearts = function (root) {
    const list = readWishlist();
    (root || document).querySelectorAll('.product-card__heart').forEach(function ($heart) {
      if ($heart.dataset.initialized) return;
      const productId = $heart.closest('[data-wishlist-btn]').getAttribute('data-product-id');
      $heart.setAttribute('data-state', inWishlist(list, productId) ? 'bookmarked' : 'unbookmarked');
    });
  };
  syncCardHearts();

  // KO.1: cards that arrive later (collection filters and sorting, infinite scroll) get their hearts set too
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        for (let j = 0; j < mutations[i].addedNodes.length; j++) {
          const $node = mutations[i].addedNodes[j];
          if ($node.nodeType === 1 && ($node.matches('.product-card') || $node.querySelector('.product-card__heart'))) {
            syncCardHearts($node.parentNode || document);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // KO.1: the card's image track. The thin lines under the images follow the swipe (one per image, the current one
  // filled), a tapped line jumps to its image, and a full-width line shows where you are while swiping. On a computer
  // the arrows on the image change it.
  const cardTrackIndex = function ($track) {
    return Math.round($track.scrollLeft / Math.max(1, $track.clientWidth));
  };

  // images 2-5 wait with their addresses in data-src and data-srcset (snippets/product-card.liquid) until they are
  // about to be seen: the pointer on the card, a touch, a swipe, an arrow or a line
  const loadCardImages = function ($card) {
    if (!$card || $card.hasAttribute('data-card-loaded')) return;
    $card.setAttribute('data-card-loaded', '');
    $card.querySelectorAll('img[data-src]').forEach(function ($img) {
      if ($img.dataset.srcset) $img.srcset = $img.dataset.srcset;
      $img.src = $img.dataset.src;
      $img.removeAttribute('data-srcset');
      $img.removeAttribute('data-src');
    });
  };
  ['mouseover', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      loadCardImages(e.target.closest && e.target.closest('.product-card'));
    }, { passive: true });
  });

  document.addEventListener('scroll', function (e) {
    const $track = e.target;
    if (!$track.hasAttribute || !$track.hasAttribute('data-card-track')) return;
    const $card = $track.closest('.product-card');
    loadCardImages($card);
    const index = cardTrackIndex($track);
    $card.querySelectorAll('[data-card-line]').forEach(function ($line, i) {
      $line.classList.toggle('is-active', i === index);
    });
    // no arrow towards an end
    const last = $track.children.length - 1;
    $card.querySelectorAll('[data-card-arrow]').forEach(function ($arrow) {
      const step = parseInt($arrow.dataset.cardArrow, 10);
      $arrow.toggleAttribute('data-off', (step < 0 && index <= 0) || (step > 0 && index >= last));
    });
    const $progress = $card.querySelector('[data-card-progress]');
    if ($progress) {
      const max = $track.scrollWidth - $track.clientWidth;
      const count = $track.children.length;
      $progress.style.width = (100 / count) + '%';
      $progress.style.transform = 'translateX(' + (max > 0 ? ($track.scrollLeft / max) * (count - 1) * 100 : 0) + '%)';
      $progress.parentNode.classList.add('is-visible');
      clearTimeout($progress._hide);
      $progress._hide = setTimeout(function () { $progress.parentNode.classList.remove('is-visible'); }, 700);
    }
  }, true);
  document.addEventListener('click', function (e) {
    const $line = e.target.closest && e.target.closest('[data-card-line]');
    if (!$line) return;
    e.preventDefault();
    loadCardImages($line.closest('.product-card'));
    const $track = $line.closest('.product-card').querySelector('[data-card-track]');
    if ($track) $track.scrollTo({ left: parseInt($line.dataset.cardLine, 10) * $track.clientWidth, behavior: 'smooth' });
  });
  document.addEventListener('click', function (e) {
    const $arrow = e.target.closest && e.target.closest('[data-card-arrow]');
    if (!$arrow) return;
    e.preventDefault();
    const $card = $arrow.closest('.product-card');
    const $track = $card.querySelector('[data-card-track]');
    if (!$track) return;
    loadCardImages($card);
    const index = cardTrackIndex($track) + parseInt($arrow.dataset.cardArrow, 10);
    $track.scrollTo({ left: index * $track.clientWidth, behavior: 'smooth' });
  });

  // KO.4: the collection row (sections/presentation-collections.liquid). On a computer its arrows scroll it on by the
  // visible width less one tile, and the one with nothing more on its side stays away
  const updateRowArrows = function ($row) {
    const $track = $row && $row.querySelector('[data-row-track]');
    if (!$track) return;
    const max = $track.scrollWidth - $track.clientWidth;
    $row.querySelectorAll('[data-row-arrow]').forEach(function ($arrow) {
      const step = parseInt($arrow.dataset.rowArrow, 10);
      $arrow.toggleAttribute('data-off', max <= 1 || (step < 0 ? $track.scrollLeft <= 1 : $track.scrollLeft >= max - 1));
    });
  };
  const updateAllRowArrows = function () {
    document.querySelectorAll('[data-row]').forEach(updateRowArrows);
  };
  document.addEventListener('scroll', function (e) {
    const $track = e.target;
    if (!$track.hasAttribute || !$track.hasAttribute('data-row-track')) return;
    updateRowArrows($track.closest('[data-row]'));
  }, true);
  document.addEventListener('click', function (e) {
    const $arrow = e.target.closest && e.target.closest('[data-row-arrow]');
    if (!$arrow) return;
    e.preventDefault();
    const $track = $arrow.closest('[data-row]').querySelector('[data-row-track]');
    if (!$track) return;
    const tile = $track.firstElementChild ? $track.firstElementChild.offsetWidth : 0;
    const distance = Math.max($track.clientWidth - tile, tile, 100);
    $track.scrollBy({ left: parseInt($arrow.dataset.rowArrow, 10) * distance, behavior: 'smooth' });
  });
  window.addEventListener('resize', updateAllRowArrows);
  document.addEventListener('shopify:section:load', updateAllRowArrows);
  updateAllRowArrows();

  // the colour row on the product page (snippets/product-colour-row.liquid): one row that scrolls sideways. The right
  // arrow shows while colours are still to the right, with how many ("+3"), and scrolls on; the left one scrolls back
  const updateColourRow = function ($row) {
    const $track = $row && $row.querySelector('[data-colour-track]');
    if (!$track) return;
    const max = $track.scrollWidth - $track.clientWidth;
    const right = $track.scrollLeft + $track.clientWidth;
    let more = 0;
    Array.prototype.forEach.call($track.children, function ($colour) {
      if ($colour.offsetLeft + $colour.offsetWidth > right + 1) more++;
    });
    $row.querySelectorAll('[data-colour-arrow]').forEach(function ($arrow) {
      const step = parseInt($arrow.dataset.colourArrow, 10);
      $arrow.hidden = max <= 1 || (step < 0 ? $track.scrollLeft <= 1 : $track.scrollLeft >= max - 1);
    });
    const $more = $row.querySelector('[data-colour-more]');
    if ($more) $more.textContent = more > 0 ? '+' + more : '';
  };
  const updateAllColourRows = function () {
    document.querySelectorAll('[data-colour-row]').forEach(updateColourRow);
  };
  document.addEventListener('scroll', function (e) {
    const $track = e.target;
    if (!$track.hasAttribute || !$track.hasAttribute('data-colour-track')) return;
    updateColourRow($track.closest('[data-colour-row]'));
  }, true);
  document.addEventListener('click', function (e) {
    const $arrow = e.target.closest && e.target.closest('[data-colour-arrow]');
    if (!$arrow) return;
    e.preventDefault();
    const $track = $arrow.closest('[data-colour-row]').querySelector('[data-colour-track]');
    if (!$track) return;
    const colour = $track.firstElementChild ? $track.firstElementChild.offsetWidth : 0;
    const distance = Math.max($track.clientWidth - colour, colour, 60);
    $track.scrollBy({ left: parseInt($arrow.dataset.colourArrow, 10) * distance, behavior: 'smooth' });
  });
  // the names' font and the images can change the widths after the first count
  window.addEventListener('resize', updateAllColourRows);
  window.addEventListener('load', updateAllColourRows);
  updateAllColourRows();

  // FO.5: the heart in the header, an outline while the wishlist is empty, filled with the number when it isn't.
  // The number is the wishlist saved in this browser or, for a logged-in customer, the wishlist app's own number,
  // which the app writes into .js-wishlist-count (and shows or hides); the heart follows whichever number is there.
  const fillHeaderWishlist = function ($link) {
    const $count = $link.querySelector('.js-wishlist-count');
    const number = $count ? parseInt($count.textContent, 10) || 0 : 0;
    $link.classList.toggle('is-filled', number > 0);
    if ($count && number > 0) $count.style.display = '';
  };
  const syncHeaderWishlist = function () {
    const count = readWishlist().length;
    document.querySelectorAll('[data-header-wishlist]').forEach(function ($link) {
      const $count = $link.querySelector('.js-wishlist-count');
      // a higher number from the wishlist app (the customer's account) stays
      if ($count && count >= (parseInt($count.textContent, 10) || 0)) $count.textContent = count > 99 ? '99+' : count;
      fillHeaderWishlist($link);
    });
  };
  syncHeaderWishlist();
  if ('MutationObserver' in window) {
    document.querySelectorAll('[data-header-wishlist] .js-wishlist-count').forEach(function ($count) {
      new MutationObserver(function () {
        fillHeaderWishlist($count.closest('[data-header-wishlist]'));
      }).observe($count, { childList: true, characterData: true, subtree: true });
    });
  }
  window.addEventListener('storage', function (e) {
    if (e.key === wishlistKey) { syncCardHearts(); syncHeaderWishlist(); }
  });
  // the wishlist app's own button (product pages) saves after its click
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.app-wishlist-btn')) setTimeout(syncHeaderWishlist, 600);
  });

  document.addEventListener('click', function (e) {
    const $heart = e.target.closest('.product-card__heart');
    if (!$heart || $heart.dataset.initialized) return;
    e.preventDefault();

    const $box = $heart.closest('[data-wishlist-btn]');
    const productId = $box.getAttribute('data-product-id');
    let list = readWishlist();
    const add = !inWishlist(list, productId);

    if (add) {
      list.push({ productId: productId, variantId: $box.getAttribute('data-variant-id') || null, addedAt: new Date().toISOString() });
    } else {
      list = list.filter(function (item) { return String(item.productId) !== productId; });
    }

    try {
      localStorage.setItem(wishlistKey, JSON.stringify(list));
      if (list.length) localStorage.setItem('wishlist_has_guest_items', 'true');
    } catch (e) {}

    $heart.setAttribute('data-state', add ? 'bookmarked' : 'unbookmarked');
    syncHeaderWishlist();
  });

  // FO.2: the campaign bar on one line, the messages take turns (snippets/announcement-bar.liquid).
  // Paused while the pointer or keyboard focus is on it.
  document.querySelectorAll('[data-announcement-line]').forEach(function ($line) {
    const $items = $line.querySelectorAll('[data-announcement-item]');
    const $dots = $line.querySelectorAll('.announcement-line__dots i');

    // a message too long for the line first gets a little smaller; one that still does not fit glides slowly to its
    // end and back while it is shown (CSS .is-long), instead of being cut off
    const fit = function () {
      $line.querySelectorAll('.announcement-line__text').forEach(function ($text) {
        let $inner = $text.querySelector('.announcement-line__inner');
        if (!$inner) {
          $inner = document.createElement('span');
          $inner.className = 'announcement-line__inner';
          while ($text.firstChild) $inner.appendChild($text.firstChild);
          $text.appendChild($inner);
        }
        $text.style.fontSize = '';
        $text.classList.remove('is-long');
        let size = parseFloat(getComputedStyle($text).fontSize);
        while ($text.scrollWidth > $text.clientWidth && size > 11) {
          size -= 0.5;
          $text.style.fontSize = size + 'px';
        }
        const overflow = $text.scrollWidth - $text.clientWidth;
        if (overflow > 0) {
          $text.classList.add('is-long');
          $text.style.setProperty('--line-shift', -overflow + 'px');
          $text.style.setProperty('--line-glide', Math.max(2, overflow / 35).toFixed(1) + 's');
        }
      });
    };
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    if ($items.length < 2) return;
    let index = 0;
    let paused = false;
    const show = function (next) {
      $items[index].classList.remove('is-active');
      if ($dots[index]) $dots[index].classList.remove('is-active');
      index = next;
      $items[index].classList.add('is-active');
      if ($dots[index]) $dots[index].classList.add('is-active');
    };
    ['mouseenter', 'focusin'].forEach(function (type) { $line.addEventListener(type, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (type) { $line.addEventListener(type, function () { paused = false; }); });
    // each message stays the set number of seconds, a gliding one long enough to glide there and back
    const seconds = parseFloat($line.dataset.interval) || 4;
    const stay = function () {
      const $long = $items[index].querySelector('.announcement-line__text.is-long');
      const glide = $long ? parseFloat($long.style.getPropertyValue('--line-glide')) || 0 : 0;
      return Math.max(seconds, 1 + glide * 2 + 1) * 1000;
    };
    const next = function () {
      setTimeout(function () {
        if (!paused && !document.hidden) show((index + 1) % $items.length);
        next();
      }, stay());
    };
    next();
  });

  // shipping tracking section
  if (document.querySelector('.shipping-tracking-form')) {
    document.querySelectorAll('.shipping-tracking-form').forEach(function ($form) {
      $form.addEventListener('submit', async function (e) {
        e.preventDefault();

        $form.querySelector('.form-success').classList.add('hide');
        $form.querySelectorAll('.form-error').forEach(function ($error) {
          $error.classList.add('hide');
        });

        try {
          const response = await fetch('https://public.molly-tech.dk/api/order-tracking-info', {
            method: 'POST',
            body: JSON.stringify(Object.fromEntries(new FormData($form))),
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          // check for http error
          if (!response.ok) {
            $form.querySelector('.error').classList.remove('hide');
            return;
          }

          // format json
          const data = await response.json();
          log(data);

          // check for errors
          if (data.error) {
            log('.error-' + String(data.error_id).charAt(0) + '0');
            $form.querySelector('.error-' + String(data.error_id).charAt(0) + '0').classList.remove('hide');
            return;
          }

          // show button
          $form.querySelector('.form-success').classList.remove('hide');
          $form.querySelector('.form-success a').setAttribute('href', data.tracking_url);
        } catch (err) {
          log(err);
        }
      });
    });
  }

  // shipping refund section
  if (document.querySelector('.shipping-refund-form')) {
    function formReset($form) {
      $form.querySelector('.order-success').classList.remove('hide');

      $form.querySelector('.return-success-complaint-message a').removeAttribute('href');
      $form.querySelector('.return-success-complaint-message').classList.add('hide');

      $form.querySelector('.return-success-gift-card-message a').removeAttribute('href');
      $form.querySelector('.return-success-gift-card-message').classList.add('hide');

      $form.querySelector('.return-success-gift-card-only-message a').removeAttribute('href');
      $form.querySelector('.return-success-gift-card-only-message').classList.add('hide');

      $form.querySelector('.return-success-refund-message-button').removeAttribute('href');
      $form.querySelector('.return-success-refund-message').classList.add('hide');

      $form.querySelector('.return-success-benefit-message a').removeAttribute('href');
      $form.querySelector('.return-success-benefit-message').classList.add('hide');

      $form.querySelectorAll('.form-error').forEach(function ($error) {
        $error.classList.add('hide');
      });
    }

    document.querySelectorAll('.shipping-refund-form').forEach(function ($form) {
      $form.querySelectorAll('input').forEach(function ($input) {
          $input.addEventListener('blur', async function (e) {
            e.preventDefault();

            formReset($form);

            $input.value = $input.value.replaceAll(' ', '');

            // check if all inputs are filled
            let allFilled = true;
            $form.querySelectorAll('input').forEach(function ($inputCheck) {
              if ($inputCheck.value === '') {
                allFilled = false;
              }
            });

            if(!allFilled) {
              return;
            }

            try {
              const response = await fetch('https://public.molly-tech.dk/api/order-return-info?modeV2=1', {
                method: 'POST',
                body: JSON.stringify(Object.fromEntries(new FormData($form))),
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              });

              // check for http error
              if (!response.ok) {
                $form.querySelector('.error').classList.remove('hide');
                return;
              }

              // format json
              const data = await response.json();
              // log(data);

              // check for errors
              if (data.error) {
                log('.error-' + String(data.error_id).charAt(0) + '0');
                $form.querySelector('.error-' + String(data.error_id).charAt(0) + '0').classList.remove('hide');
                return;
              }

              if (data.return_allowed) {
                $form.querySelector('.return-success-refund-message-button').setAttribute('href', data.return_url);
                $form.querySelector('.return-success-refund-message').classList.remove('hide');
              }

              if (
                data.return_allowed ||
                data.return_allow_gift_card ||
                data.return_allow_gift_card_only ||
                data.return_benefit
              ) {
                $form.querySelector('.order-success').classList.add('hide');
              } else {
                $form.querySelector('.error-105').classList.remove('hide');
              }

              if (data.complaint_url) {
                $form.querySelector('.return-success-complaint-message a').setAttribute('href', data.complaint_url);
                $form.querySelector('.return-success-complaint-message').classList.remove('hide');

                if (data.return_allow_gift_card) {
                  if (data.return_allow_gift_card_only) {
                    $form.querySelector('.return-success-gift-card-only-message a').setAttribute('href', data.return_allow_gift_card_url);
                    $form.querySelector('.return-success-gift-card-only-message').classList.remove('hide');
                  } else {
                    $form.querySelector('.return-success-gift-card-message a').setAttribute('href', data.return_allow_gift_card_url);
                    $form.querySelector('.return-success-gift-card-message').classList.remove('hide');
                  }
                }

                if (data.return_benefit && data.return_benefit_url) {
                  $form.querySelector('.return-success-benefit a').setAttribute('href', data.return_benefit_url);

                  if (data.return_benefit_shipping) {
                    $form.querySelector('.return-success-benefit-shipping').innerHTML = $form.querySelector('.return-success-benefit-shipping').getAttribute('data-html').replace('{{ shipping }}', data.return_benefit_shipping + '%')
                  } else {
                    $form.querySelector('.return-success-benefit-shipping').innerHTML = '';
                  }

                  if (data.return_benefit_percentage) {
                    $form.querySelector('.return-success-benefit-percentage').innerHTML = $form.querySelector('.return-success-benefit-percentage').getAttribute('data-html').replace('{{ percentage }}', data.return_benefit_percentage + '%')
                  } else {
                    $form.querySelector('.return-success-benefit-percentage').innerHTML = '';
                  }

                  if (data.return_benefit_amount) {
                    $form.querySelector('.return-success-benefit-amount').innerHTML = $form.querySelector('.return-success-benefit-amount').getAttribute('data-html').replace('{{ amount }}', theme.Currency.formatMoney(data.return_benefit_amount * 100, theme.settings.moneyFormat));
                  } else {
                    $form.querySelector('.return-success-benefit-amount').innerHTML = '';
                  }

                  $form.querySelector('.return-success-benefit').classList.remove('hide');
                }
              } else {
                // $form.querySelector('.error-106').classList.remove('hide');
              }
            } catch (err) {
              log(err);
            }
          });
      });
    });
  }

  // page index / frontpage content
  if (document.querySelector('.page-index')) {
    document.querySelector('.page-index > a').addEventListener('click', () => {
      if (document.querySelector('.page-index').hasAttribute('data-read-more')) {
        document.querySelector('.page-index').removeAttribute('data-read-more');
      } else {
        document.querySelector('.page-index').setAttribute('data-read-more', '');
      }
    });
  }

  // youtube model
  const youtubeModal = document.querySelector('.youtube-modal');
  if (youtubeModal) {
    document.querySelector('.youtube-modal-btn').onclick = function () {
      youtubeModal.style.display = 'block';

      if (document.querySelector('.youtube-modal .youtube-play-button')) {
        document.querySelector('.youtube-modal .youtube-play-button').click();
      } else {
        document.querySelector('.youtube-modal .youtube-embedded iframe').setAttribute('src', 'https://www.youtube.com/embed/' + document.querySelector('.youtube-modal .youtube-embedded').getAttribute('data-embed') + '?rel=0&showinfo=0&autoplay=1');
      }
    }

    document.querySelector('.js-youtube-modal-close').onclick = function () {
      youtubeModal.style.display = 'none';

      document.querySelector('.youtube-modal .youtube-embedded iframe').setAttribute('src', '');
    }

    window.onclick = function (event) {
      if (event.target === youtubeModal) {
        youtubeModal.style.display = 'none';

        document.querySelector('.youtube-modal .youtube-embedded iframe').setAttribute('src', '');
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.variant-wrapper--button').forEach(function ($wrapper) {
    const $select = $wrapper.querySelector('select[name="id"]');
    $select.addEventListener('change', function () {
      // console.log('change');
      const $option = $select.querySelector('option:checked');
      const $button = $wrapper.parentElement.querySelector('button[type="submit"]');
      const $form = $wrapper.closest('form');
      const $preorderInput = $form.querySelector('#preorder-input');
      const $preorderExpectedDelivery = $form.querySelector('#preorder-expected-delivery');
      const $gridProductPreorderLabel = $wrapper.closest('.grid__item').querySelector('.grid-product-preorder');

      if ($option.dataset.preorder === 'true' && $option.dataset.warehouseGoods !== 'true') {
        $button.innerHTML = theme.strings.preorder;
        
        if (!$preorderInput) {
          const preorderInput = document.createElement('input');
          preorderInput.type = 'hidden';
          preorderInput.id = 'preorder-input';
          preorderInput.name = 'properties[' + theme.strings.preorderTitle + ']';
          preorderInput.value = '✓';
          $form.appendChild(preorderInput);
        }

        if (!$preorderExpectedDelivery && $option.dataset.preorderEta) {
          const preorderExpectedDelivery = document.createElement('input');
          preorderExpectedDelivery.type = 'hidden';
          preorderExpectedDelivery.id = 'preorder-expected-delivery';
          preorderExpectedDelivery.name = 'properties[' + theme.strings.preorderExpectedDelivery + ']';
          preorderExpectedDelivery.value = $option.dataset.preorderEta;
          $form.appendChild(preorderExpectedDelivery);
        } else if ($preorderExpectedDelivery && $option.dataset.preorderEta) {
          $preorderExpectedDelivery.value = $option.dataset.preorderEta;
        }

        if ($gridProductPreorderLabel) {
          $gridProductPreorderLabel.classList.remove('grid-product-preorder--hidden');
          $gridProductPreorderLabel.innerText = `${theme.strings.pre_ordering} (${$option.dataset.preorderEta})`.trim().replace(/[\r\n]+/g, "");
        }
      } else {
        $button.innerHTML = theme.strings.addToCart;
        if ($preorderInput) {
          $preorderInput.remove();
        }

        if ($preorderExpectedDelivery) {
          $preorderExpectedDelivery.remove();
        }

        if ($gridProductPreorderLabel) {
          $gridProductPreorderLabel.classList.add('grid-product-preorder--hidden');
        }
      }
    });
  });
});


/* upsell popup */
/* upsell popup */
/* upsell popup */
/* upsell popup */
/* upsell popup */
document.addEventListener('DOMContentLoaded', function () {

  // get translations from theme.liquid
  const translations = {
    yesThankYou: document.querySelector('.translation_yes_thank_you').innerText.trim(),
    product: document.querySelector('.translation_product').innerText.trim(),
    total: document.querySelector('.translation_total').innerText.trim(),
    addOfferToCart: document.querySelector('.translation_add_offer_to_cart').innerText.trim(),
    adding: document.querySelector('.translation_adding').innerText.trim(),
    productAdded: document.querySelector('.translation_product_added').innerText.trim(),
    added: document.querySelector('.translation_added').innerText.trim(),
    discount: document.querySelector('.translation_discount').innerText.trim(),
  };

  // Helper function to apply discount to price
  function applyDiscountToTotal(totalAmount) {
    
    const popupParent = document.querySelector('.cart-popup');
    const upsellDiscount = parseFloat(popupParent.getAttribute('data-discount') || '0');
    
    
    if (!upsellDiscount || upsellDiscount <= 0) {
      return totalAmount;
    }
    
    const discountDecimal = upsellDiscount / 100;
    const discountedAmount = totalAmount * (1 - discountDecimal);
    
    return discountedAmount;
  }

  function initAddToCartButtons() {
    // check if upsell popup exists
    if (!document.querySelector('.cart-popup--is-open')) {
      setTimeout(initAddToCartButtons, 100);
      return;
    }

    const addToCartBtns = document.querySelectorAll('.cart-popup.cart-popup--is-open .grid-product__content .product-single__form button.add-to-cart:not([data-intercepted])');
    
    if (addToCartBtns.length === 0) {
      setTimeout(initAddToCartButtons, 100);
      return;
    }

    // get upsell discount from the cart popup attributes
    const upsellDiscount = document.querySelector('.cart-popup').getAttribute('data-discount') || '0';

    // create element to show the discount above the product image if the discount is > 0
    if (upsellDiscount && parseFloat(upsellDiscount) > 0) {
      const discountLabel = document.createElement('div');
      discountLabel.classList.add('cart-popup-discount-label');
      discountLabel.innerText = `${upsellDiscount}% ${translations.discount}`;

      // grab parent container to insert the label into
      const productImageWrappers = document.querySelectorAll('.cart-popup.cart-popup--is-open .grid-product__image-mask');
      productImageWrappers.forEach(wrapper => {
        // only add if not already added
        if (!wrapper.querySelector('.cart-popup-discount-label')) {
          wrapper.appendChild(discountLabel.cloneNode(true));
        }
      });
    }

    // make the body not scrollable while popup is open
    document.body.classList.add('non_scrollable');

    addToCartBtns.forEach(button => {
      
      // Set initial text
      button.textContent = translations.yesThankYou;
      button.setAttribute('data-translated', 'true');
      
      // Remove existing listener if any
      button.removeEventListener('click', handleAddToCart);
      // Add new listener
      button.addEventListener('click', handleAddToCart);
      // Mark as intercepted
      button.setAttribute('data-intercepted', 'true');
    });
    
    // Initialize close button listeners
    initCloseButtonListeners();
  }
  
  // initialize close button listeners
  function initCloseButtonListeners() {
    const closeButtons = document.querySelectorAll('.cart-popup-close, .js-cart-popup-close');
    
    closeButtons.forEach(closeBtn => {
      // Remove existing listener to avoid duplicates
      closeBtn.removeEventListener('click', handlePopupClose);
      // Add new listener
      closeBtn.addEventListener('click', handlePopupClose);
    });
  }
  
  // handle popup close and reset all selections
  function handlePopupClose(e) {
    // Reset all "JA TAK" buttons to their original state
    resetAllSelections();
    
    // Remove the total popup completely
    hideTotalPopup();
    
    // make the body scrollable again
    document.body.classList.remove('non_scrollable');
  }
  
  // reset all "JA TAK" selections
  function resetAllSelections() {
    const selectedButtons = document.querySelectorAll('.cart-popup .add-to-cart.cart-popup-ja-tak');
    
    selectedButtons.forEach(button => {
      // Reset button text
      button.textContent = translations.yesThankYou;
      
      // Remove styling classes
      button.classList.remove('cart-popup-ja-tak');
      
      // Re-enable the button
      button.disabled = false;
      
      // Remove cancel button if it exists
      const cancelBtn = button.querySelector('.cart-popup-cancel-selection');
      if (cancelBtn) {
        cancelBtn.remove();
      }
      
      // Show variant wrapper again if it was hidden
      const form = button.closest('form');
      if (form) {
        const variantInfo = form.querySelector('.variant-wrapper');
        if (variantInfo) {
          variantInfo.style.display = 'block';
        }
      }
    });
  }
  
function handleAddToCart(e) {
  // prevent form submission
  e.preventDefault();
  e.stopPropagation();

  // get button from event to style
  const button = e.currentTarget;
  button.classList.add('cart-popup-ja-tak');

  // Get the selected variant info and price to use in the cart total popup
  const form = this.closest('form');
  const variantSelect = form.querySelector('select[name="id"], input[name="id"]:checked');
  let variantText = '';
  let variantId = '';
  let variantPrice = '';
  
  if (variantSelect) {
    variantId = variantSelect.value;
    
    if (variantSelect.tagName === 'SELECT') {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      variantText = selectedOption.text || selectedOption.value;
    } else {
      // For radio buttons, get the associated label
      const label = form.querySelector(`label[for="${variantSelect.id}"]`);
      variantText = label ? label.textContent.trim() : variantSelect.value;
    }
  }
  
  // Get price from the product - handle all market structures
  const gridContent = form.closest('.grid-product__content');
  let priceElement = null;
  
  // Try specific selectors first for current price - EXCLUDE original prices
  priceElement = gridContent.querySelector('.grid-product__price .money:not(.grid-product__price--original .money)') ||  // Denmark format, exclude original
                 gridContent.querySelector('.price .money:not(.grid-product__price--original .money)') ||
                 gridContent.querySelector('.product-single__price .money') ||
                 gridContent.querySelector('[data-price]');
  
  if (priceElement) {
    // Found a specific price element
    variantPrice = priceElement.textContent.trim();
  } else {
    // Fallback to the general price container
    priceElement = gridContent.querySelector('.grid-product__price');
    if (priceElement) {
      // Check if this has compare-at pricing structure (multiple spans/complex content)
      const hasComplexStructure = priceElement.querySelector('.grid-product__price--original') || 
                                  priceElement.querySelectorAll('span').length > 1;
      
      if (hasComplexStructure) {
        // Use TreeWalker for complex structures (Germany with compare-at pricing)
        // console.log('Using TreeWalker for complex pricing structure...');
        const walker = document.createTreeWalker(
          priceElement,
          NodeFilter.SHOW_TEXT,
          {
            acceptNode: function(node) {
              const text = node.textContent.trim();
              // Accept text nodes that contain currency symbols and aren't in hidden elements
              if ((text.includes('€') || text.includes('kr') || text.includes('zł')) && 
                  !node.parentElement.classList.contains('visually-hidden') &&
                  !node.parentElement.classList.contains('grid-product__price--original')) {
                return NodeFilter.FILTER_ACCEPT;
              }
              return NodeFilter.FILTER_REJECT;
            }
          }
        );
        
        let textNode = walker.nextNode();
        if (textNode) {
          variantPrice = textNode.textContent.trim();
        } else {
          // Final fallback - get all text and try to extract the last price
          const allText = priceElement.textContent;
          const priceMatches = allText.match(/(€[\d,.\s]+|[\d,.\s]+\s*(kr|zł))/g);
          if (priceMatches && priceMatches.length > 0) {
            variantPrice = priceMatches[priceMatches.length - 1].trim();
          }
        }
      } else {
        // Simple structure - just get the text directly (Poland, simple Germany)
        variantPrice = priceElement.textContent.trim();
      }
    }
  }
    
  // Fallback to product title if no variant found
  if (!variantText) {
    const productTitle = form.closest('.grid-product__content').querySelector('.grid-product__title');
    variantText = productTitle ? productTitle.textContent.trim() : translations.product;
  }
  
  // Clean up variant text (remove extra whitespace, size info if needed)
  variantText = variantText.replace(/\s+/g, ' ').trim();
  
  // Change button text with wrapper for ellipsis
  this.innerHTML = `<span class="btn-text">${variantText} ${translations.added}</span>`;
  
  // Add a class for styling
  this.classList.add('cart-popup-ja-tak');

  // remove the variant info from the button and add an X to cancel the selection
  const variantInfo = form.querySelector('.variant-wrapper');
  if (variantInfo) {
    variantInfo.style.display = 'none';
  }

  // add an event listener that will cancel the selection, remove item from total popup
  const cancelBtn = document.createElement('span');
  cancelBtn.classList.add('cart-popup-cancel-selection');
  cancelBtn.innerHTML = '&times;';
  this.appendChild(cancelBtn);
  cancelBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    
    // Remove this item from the total popup
    removeItemFromTotal(variantId);
    
    // Reset button state
    this.innerHTML = translations.yesThankYou // Use innerHTML to clear the wrapper
    this.classList.remove('cart-popup-ja-tak');
    this.disabled = false;
    
    // Re-add variant select to the button
    if (variantInfo) {
      variantInfo.style.display = 'block';
    }
    
    // Remove the cancel button (it's already removed when we set innerHTML)
  });
  
  // Show the total popup with selected item info
  showTotalPopup(variantText, variantPrice, variantId, form);
  
  // Disable button to prevent multiple clicks
  this.disabled = true;
}

  // show total popup below default upsell popup
  function showTotalPopup(variantText, variantPrice, variantId, form) {
    // Check if a total popup already exists
    let existingTotalPopup = document.querySelector('.cart-popup-total');
    
    if (existingTotalPopup) {
      // Update existing popup with new item
      updateExistingTotalPopup(existingTotalPopup, variantText, variantPrice, variantId);
      return;
    }

    // Create new total popup if none exists
    const totalPopup = document.createElement('div')
    totalPopup.classList.add('cart-popup-total');
    const totalAmountRow = document.createElement('div')
    totalAmountRow.classList.add('cart-popup-total-amount-row');
    const totalAmountText = document.createElement('span')
    totalAmountText.classList.add('cart-popup-total-text');
    totalAmountText.textContent = translations.total;
    const totalAmountValue = document.createElement('span')
    totalAmountValue.classList.add('cart-popup-total-amount-value');
    const addToCartBtn = document.createElement('button')
    addToCartBtn.classList.add('js-cart-popup-checkout');
    addToCartBtn.classList.add('cart-popup-total-button');
    addToCartBtn.textContent = translations.addOfferToCart;

    // append elements to the right containers
    totalAmountRow.appendChild(totalAmountText);
    totalAmountRow.appendChild(totalAmountValue);
    totalPopup.appendChild(totalAmountRow);
    totalPopup.appendChild(addToCartBtn);

    // get parent to append this new container
    const popupParent = document.querySelector('.cart-popup')

    if (!popupParent) {
      console.error('No upsell popup parent found');
      return;
    }
    
    // Initialize with first item
    const numericPrice = parsePrice(variantPrice);

    // total price with discount applied
    const discountedTotal = applyDiscountToTotal(numericPrice);
    totalAmountValue.textContent = formatPrice(discountedTotal);    

    // Store the variant info on the button for the final add to cart
    // Use arrays to store multiple items
    addToCartBtn.setAttribute('data-variant-ids', JSON.stringify([variantId]));
    addToCartBtn.setAttribute('data-variant-texts', JSON.stringify([variantText]));
    addToCartBtn.setAttribute('data-total-amount', numericPrice.toString());
    
    // Remove existing listener and add new one
    addToCartBtn.removeEventListener('click', handleFinalAddToCart);
    addToCartBtn.addEventListener('click', handleFinalAddToCart);
    
    // Show the total popup
    totalPopup.style.display = 'block';
    totalPopup.classList.add('cart-popup-total--visible');

    popupParent.appendChild(totalPopup);
  }
  
  // Helper function to update existing total popup with new item
  function updateExistingTotalPopup(totalPopup, variantText, variantPrice, variantId) {
    const addToCartBtn = totalPopup.querySelector('.cart-popup-total-button');
    const totalAmountValue = totalPopup.querySelector('.cart-popup-total-amount-value');
    
    if (!addToCartBtn || !totalAmountValue) {
      console.error('Could not find total popup elements to update');
      return;
    }
    
    // Get existing data
    const existingVariantIds = JSON.parse(addToCartBtn.getAttribute('data-variant-ids') || '[]');
    const existingVariantTexts = JSON.parse(addToCartBtn.getAttribute('data-variant-texts') || '[]');
    const existingTotalAmount = parseFloat(addToCartBtn.getAttribute('data-total-amount') || '0');
    
    // Check if this variant is already added
    if (existingVariantIds.includes(variantId)) {
      // console.log('Item already added to cart popup');
      return;
    }
    
    // Add new item
    const newNumericPrice = parsePrice(variantPrice);
    const newTotalAmount = existingTotalAmount + newNumericPrice;
    
    existingVariantIds.push(variantId);
    existingVariantTexts.push(variantText);
    
    // Update stored data
    addToCartBtn.setAttribute('data-variant-ids', JSON.stringify(existingVariantIds));
    addToCartBtn.setAttribute('data-variant-texts', JSON.stringify(existingVariantTexts));
    addToCartBtn.setAttribute('data-total-amount', newTotalAmount.toString());
    
    // Update display
    const discountedTotal = applyDiscountToTotal(newTotalAmount);
    totalAmountValue.textContent = formatPrice(discountedTotal);  
}
  
  // Helper function to remove an item from the total popup
  function removeItemFromTotal(variantIdToRemove) {
    
    const totalPopup = document.querySelector('.cart-popup-total');
    if (!totalPopup) return;
    
    const addToCartBtn = totalPopup.querySelector('.cart-popup-total-button');
    const totalAmountValue = totalPopup.querySelector('.cart-popup-total-amount-value');
    
    if (!addToCartBtn || !totalAmountValue) return;
    
    // Get existing data
    const existingVariantIds = JSON.parse(addToCartBtn.getAttribute('data-variant-ids') || '[]');
    const existingVariantTexts = JSON.parse(addToCartBtn.getAttribute('data-variant-texts') || '[]');
    const existingTotalAmount = parseFloat(addToCartBtn.getAttribute('data-total-amount') || '0');
        
    // Find the index of the item to remove
    const indexToRemove = existingVariantIds.indexOf(variantIdToRemove);
    
    if (indexToRemove === -1) {
      return;
    }
    
    // Get the price of the item being removed
    const itemPrice = getPriceForVariant(variantIdToRemove);
    
    if (itemPrice === null) {
      console.error('Could not get price for variant, cannot remove from total');
      return;
    }
    
    // Remove item from arrays
    existingVariantIds.splice(indexToRemove, 1);
    existingVariantTexts.splice(indexToRemove, 1);
    
    // Calculate new total
    const newTotalAmount = existingTotalAmount - itemPrice;
    
    // Check if any items left
    if (existingVariantIds.length === 0) {
      // No items left, hide the total popup
      hideTotalPopup();
      return;
    }
    
    // Update stored data
    addToCartBtn.setAttribute('data-variant-ids', JSON.stringify(existingVariantIds));
    addToCartBtn.setAttribute('data-variant-texts', JSON.stringify(existingVariantTexts));
    addToCartBtn.setAttribute('data-total-amount', newTotalAmount.toString());
    
    // Update display
    const discountedTotal = applyDiscountToTotal(newTotalAmount);
    totalAmountValue.textContent = formatPrice(discountedTotal);
  }
  
  // Helper function to get price for a specific variant (fallback method)
  function getPriceForVariant(variantId) {
    
    // Find the product form that contains this variant ID
    const forms = document.querySelectorAll('.cart-popup .product-single__form');
    
    for (let form of forms) {
      const variantSelect = form.querySelector(`select[name="id"] option[value="${variantId}"], input[name="id"][value="${variantId}"]`);
      if (variantSelect) {
        
        // Found the form, now get the price - handle all market structures
        const gridContent = form.closest('.grid-product__content');
        let priceElement = null;
        let priceText = '';
        
        // Try specific selectors first for current price - EXCLUDE original prices
        priceElement = gridContent.querySelector('.grid-product__price .money:not(.grid-product__price--original .money)') ||  // Denmark format, exclude original
                       gridContent.querySelector('.price .money:not(.grid-product__price--original .money)') ||
                       gridContent.querySelector('.product-single__price .money') ||
                       gridContent.querySelector('[data-price]');
        
        if (priceElement) {
          // Found a specific price element
          priceText = priceElement.textContent.trim();
        } else {
          // Fallback to the general price container
          priceElement = gridContent.querySelector('.grid-product__price');
          if (priceElement) {
            // Check if this has compare-at pricing structure (multiple spans/complex content)
            const hasComplexStructure = priceElement.querySelector('.grid-product__price--original') || 
                                        priceElement.querySelectorAll('span').length > 1;
            
            if (hasComplexStructure) {
              // Use TreeWalker for complex structures (Germany with compare-at pricing)
              const walker = document.createTreeWalker(
                priceElement,
                NodeFilter.SHOW_TEXT,
                {
                  acceptNode: function(node) {
                    const text = node.textContent.trim();
                    // Accept text nodes that contain currency symbols and aren't in hidden elements
                    if ((text.includes('€') || text.includes('kr') || text.includes('zł')) && 
                        !node.parentElement.classList.contains('visually-hidden') &&
                        !node.parentElement.classList.contains('grid-product__price--original')) {
                      return NodeFilter.FILTER_ACCEPT;
                    }
                    return NodeFilter.FILTER_REJECT;
                  }
                }
              );
              
              let textNode = walker.nextNode();
              if (textNode) {
                priceText = textNode.textContent.trim();
              } else {
                // Final fallback - get all text and try to extract the last price
                const allText = priceElement.textContent;
                const priceMatches = allText.match(/(€[\d,.\s]+|[\d,.\s]+\s*(kr|zł))/g);
                if (priceMatches && priceMatches.length > 0) {
                  priceText = priceMatches[priceMatches.length - 1].trim();
                }
              }
            } else {
              // Simple structure - just get the text directly (Poland, simple Germany)
              priceText = priceElement.textContent.trim();
            }
          }
        }
        
        if (priceText) {
          const parsedPrice = parsePrice(priceText);
          return parsedPrice;
        } else {
          console.warn('No price text found for variant:', variantId);
        }
      }
    }
    
    // Return null if price not found
    console.warn('Could not find price for variant:', variantId);
    return null;
  }
  
  // Helper function to parse price from text (handles "399,00 kr" format)
  function parsePrice(priceText) {
    if (!priceText) {
      return 0;
    }
        
    // Remove currency symbols and extract numbers
    let numericString = priceText.replace(/[^\d,.-]/g, '').replace(/zł/g, '');
    
    // Determine if comma is decimal separator or thousands separator
    if (numericString.includes(',') && numericString.includes('.')) {
      // Both present - assume comma is thousands separator, period is decimal
      numericString = numericString.replace(/,/g, '');
    } else if (numericString.includes(',')) {
      // Only comma - check if it's likely decimal separator
      const parts = numericString.split(',');
      if (parts.length === 2 && parts[1].length <= 2) {
        // Likely decimal separator (e.g., "123,45")
        numericString = numericString.replace(',', '.');
      } else {
        // Likely thousands separator (e.g., "1,234")
        numericString = numericString.replace(/,/g, '');
      }
    }
    
    const result = parseFloat(numericString) || 0;
    
    return result;
  }
  
  // Helper function to format price back to display format
  function formatPrice(amount) {
    // Try multiple ways to detect currency, prioritizing actual price elements
    let currency = null;
    
    // Look at existing price elements in the popup to detect format
    const existingPriceElement = document.querySelector('.cart-popup .grid-product__price, .cart-popup .money, .cart-popup [data-price]');
    if (existingPriceElement) {
      const priceText = existingPriceElement.textContent.trim();
      
      if (priceText.includes('€')) currency = 'EUR';
      else if (priceText.includes('zł')) currency = 'PLN';
      else if (priceText.includes('kr')) {
        // Could be DKK, SEK, or NOK - check shop domain or other indicators
        if (window.location.href.includes('-dk') || window.Shopify?.shop?.includes('-dk')) {
          currency = 'DKK';
        } else if (window.location.href.includes('-se')) {
          currency = 'SEK';
        } else if (window.location.href.includes('-no')) {
          currency = 'NOK';
        } else {
          currency = 'DKK'; // Default to DKK for kr
        }
      }
      else if (priceText.includes('$')) currency = 'USD';
      else if (priceText.includes('£')) currency = 'GBP';
    }
    
    // Shopify object as fallback
    if (!currency && window.Shopify?.currency?.active) {
      currency = window.Shopify.currency.active;
    }
    
    // Check URL or domain for market indicators
    if (!currency) {
      const url = window.location.href.toLowerCase();
      if (url.includes('eur') || url.includes('euro')) currency = 'EUR';
      else if (url.includes('pln') || url.includes('poland')) currency = 'PLN';
      else if (url.includes('usd') || url.includes('dollar')) currency = 'USD';
    }
    
    // Fallback
    currency = currency || 'EUR';
        
    // Currency-specific formatting
    const formatters = {
      'DKK': () => amount.toFixed(2).replace('.', ',') + ' kr',
      'EUR': () => '€' + amount.toFixed(2).replace('.', ','),
      'PLN': () => amount.toFixed(2).replace('.', ',') + ' zł',
      'USD': () => '$' + amount.toFixed(2),
      'GBP': () => '£' + amount.toFixed(2),
      'SEK': () => amount.toFixed(2).replace('.', ',') + ' kr',
      'NOK': () => amount.toFixed(2).replace('.', ',') + ' kr'
    };
    
    const result = formatters[currency] ? formatters[currency]() : amount.toFixed(2) + ' ' + currency;
    
    return result;
  }
  
  function handleFinalAddToCart(e) {
    e.preventDefault();
    
    // Get multiple variant IDs and texts from arrays
    const variantIds = JSON.parse(this.getAttribute('data-variant-ids') || '[]');
    const variantTexts = JSON.parse(this.getAttribute('data-variant-texts') || '[]');
    
    if (variantIds.length === 0) {
      console.error('No variant IDs found');
      return;
    }
    
    // Show loading state
    const originalText = this.textContent;
    this.textContent = translations.adding;
    this.disabled = true;
    
    // Add all items to cart sequentially
    addMultipleItemsToCart(variantIds)
      .then(() => {
        // Success - hide the total popup and show success message
        this.textContent = translations.productAdded;
        
        // Hide total popup after short delay
        setTimeout(() => {
          // Close popup
          document.querySelector('.cart-popup').classList.remove('cart-popup--is-open');
          document.documentElement.classList.remove('js-drawer-open', 'lock-scroll');
          handlePopupClose();
        }, 1000);
      })
      .catch(error => {
        console.error('Error adding items to cart:', error);
        // Reset button state
        this.textContent = originalText;
        this.disabled = false;
      });
  }
  
  // Helper function to add multiple items to cart sequentially
  async function addMultipleItemsToCart(variantIds) {
    const results = [];

    // Get the discount value from the cart popup
    const popupParent = document.querySelector('.cart-popup');
    const upsellDiscount = parseFloat(popupParent.getAttribute('data-discount') || '0');

    const upsellId = popupParent.getAttribute('data-upsell-id');
    
    // Add items one by one to avoid API conflicts
    for (let i = 0; i < variantIds.length; i++) {
      const variantId = variantIds[i];
      
      try {

        // Prepare the cart item data
        const cartItemData = {
          id: variantId,
          quantity: 1
        };

        const properties = {};

        // Add discount property if there's a discount
        if (upsellDiscount && upsellDiscount > 0) {
          properties._discount = upsellDiscount.toString();
        }
        
        properties._upsell = 'true';
        properties._offer_type = 'popup_upsell';
        
        if (upsellId) {
          properties._source = upsellId;
        }

        // Momentum's line marks for this size's product, so the sale counts for the popup's upsell carousel. The product
        // id is on the card form the size was picked in; without Momentum's script (or consent) there are none
        if (window.momentum) {
          const $size = popupParent.querySelector('option[value="' + variantId + '"], input[name="id"][value="' + variantId + '"]');
          const $sizeForm = $size && $size.closest('form[data-momentum-product-id]');
          const momentumProductId = $sizeForm && $sizeForm.getAttribute('data-momentum-product-id');
          if (momentumProductId) Object.assign(properties, window.momentum.lineProperties(momentumProductId));
        }

        // Only add properties object if we have properties to add
        if (Object.keys(properties).length > 0) {
          cartItemData.properties = properties;
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(cartItemData)
        });
        
        if (!response.ok) {
          throw new Error(`Failed to add variant ${variantId}: ${response.status} ${response.statusText}`);
        }
        
        const data = await response.json();
        results.push(data);
        
        // Optional: Small delay between requests to be extra safe
        if (i < variantIds.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        cartData.items.forEach((item, index) => {
          // console.log(`Item ${index + 1}:`, {
          //   id: item.id,
          //   variant_id: item.variant_id,
          //   product_title: item.product_title,
          //   properties: item.properties,
          //   price: item.price,
          //   source: item.properties ? item.properties._source : null
          // });
        });
        
      } catch (error) {
        console.error(`Error adding variant ${variantId}:`, error);
        throw error;
      }
    }
    
    return results;
  }
  
  function hideTotalPopup() {
    // Remove any total popup instances
    const totalPopups = document.querySelectorAll('.cart-popup-total');
    totalPopups.forEach(popup => popup.remove());
  }
  
  // Keep checking for new popup instances
  setInterval(initAddToCartButtons, 2000);
});

// get extra option translations from theme.liquid
const extra_options_translations = {
  add_extra_option: document.querySelector('.translation_add_extra_option').innerText.trim().toUpperCase(),
  adding_extra_option: document.querySelector('.translation_adding_extra_option').innerText.trim().toUpperCase(),
  added_extra_option: document.querySelector('.translation_added_extra_option').innerText.trim().toUpperCase(),
  removing_extra_option: document.querySelector('.translation_removing_extra_option').innerText.trim().toUpperCase(),
};

// ExtraOption Class - handles individual extra options
class ExtraOption {
  constructor(config) {
    this.id = config.id;
    this.collections = config.collections || [];
    this.exclusionCollections = config.exclusionCollections || [];
    this.exclusionProperty = config.exclusionProperty || null;
    this.inclusionProperty = config.inclusionProperty || null; // for split order
    this.isExpressOrder = config.isExpressOrder || false;
    this.isSplitOrder = config.isSplitOrder || false; // flag for split order logic
    this.variantId = config.variantId;
    this.containerSelector = config.containerSelector;
    this.checkboxId = config.checkboxId;
    this.cartDrawerOnly = config.cartDrawerOnly;
    this.product = config.product;
    this.inFlight = false;
  }

  setButtonDisabled(disabled) {
    const container = document.querySelector(this.containerSelector);
    const button = container?.querySelector(`.btn-add-extra-option[data-option-number="${this.id}"]`);
    if (button) button.disabled = !!disabled;
  }

  // inside class ExtraOption
  updateButtonState(isSelected) {
    const container = document.querySelector(this.containerSelector);
    if (!container) return;

    const button = container.querySelector(`.btn-add-extra-option[data-option-number="${this.id}"]`);
    const hiddenInput = container.querySelector(`#extended-return-input${this.id > 1 ? '-' + this.id : ''}`);

    if (button) {
      const selected = !!isSelected;
      button.innerHTML = selected ? `${extra_options_translations.added_extra_option}<span class="cart__drawer__x__in__button">X</span>` : `${extra_options_translations.add_extra_option}`;
      button.classList.toggle('added', selected);
      button.classList.toggle('is-selected', selected); // legacy support
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.classList.toggle('active', selected);
    }

    if (hiddenInput) {
      hiddenInput.checked = !!isSelected;
    }
  }

  // check Express Order using /cart.js instead of DOM scraping
  async checkExpressOrderWithCartFacts() {
    if (this.inFlight) return;

    try {
      const cart = await CartData.fetchCart();
      const facts = CartData.computeFacts(cart);

      const variantIdStr = String(this.variantId);
      let extraOptionInCart = null;
      let hasExcludedProduct = false;

      for (const item of cart.items) {
        if (String(item.variant_id) === variantIdStr) {
          extraOptionInCart = item;
          continue;
        }

        const props = item.properties || {};
        // we now check for more than 1 exclusion properties
        if (this.exclusionProperty) {
          const exclusionProperties = this.exclusionProperty.split(',').map(p => p.trim());
          const hasAnyExcludedProperty = exclusionProperties.some(prop => 
            Object.prototype.hasOwnProperty.call(props, prop)
          );
          if (hasAnyExcludedProperty) {
            hasExcludedProduct = true;
          }
        }
      }

      if (!hasExcludedProduct) {
        // Show container & keep button in sync with /cart.js
        this.ensureCheckboxContainerExists(!!extraOptionInCart);
      } else {
        // Hide + auto-remove if necessary
        this.hideCheckboxContainer();
        if (extraOptionInCart) {
          this.removeFromCart(true);
        }
      }
    } catch (e) {
      console.error('checkExpressOrderWithCartFacts failed', e);
    }
  }


  // Check if any qualifying products are in cart
  checkQualifyingProducts(attempt = 0, maxAttempts = 5) {

    if (this.inFlight) return;

    // Prefer cart.js-based logic for Express Order when CartData is available
    if (this.isExpressOrder &&
      window.CartData &&
      typeof CartData.fetchCart === 'function' &&
      typeof CartData.computeFacts === 'function') {
        this.checkExpressOrderWithCartFacts();
        return;
    }
    
    const cartItems = document.querySelectorAll('.cart__item');
    if (cartItems.length === 0 && attempt < maxAttempts) {
      setTimeout(() => this.checkQualifyingProducts(attempt + 1, maxAttempts), 200 * (attempt + 1));
      return;
    }
    
    // DEBUG: Log what type of option this is
    if (this.isSplitOrder) {
    //  console.log('Running Split Order checks for option', this.id);
    }
    if (this.isExpressOrder) {
    //  console.log('Running Express Order checks for option', this.id);
    }
    
    let hasQualifyingProduct = false;
    let extraOptionInCart = false;
    let hasExcludedProduct = false;
    let hasPreorderProduct = false; // for split order
    let hasNonPreorderProduct = false; // for split order
    
    cartItems.forEach(item => {
      const itemCollections = item.getAttribute('data-collections');
      const itemVariantId = item.getAttribute('data-variant-id');
      
      // Check if this is our extra option product - mark it but don't skip other checks yet
      if (String(itemVariantId) === String(this.variantId)) {
        extraOptionInCart = true;
        return; // Skip processing this item further
      }
      
      // SPLIT ORDER LOGIC - Check for both preorder and non-preorder items
      if (this.isSplitOrder && this.inclusionProperty) {
        const itemPropertiesData = item.getAttribute('data-properties');
        
      //  console.log('Split Order Debug for item:', {
      //    variantId: itemVariantId,
      //    inclusionProperty: this.inclusionProperty,
      //    rawPropertiesData: itemPropertiesData
      //  });
        
        if (itemPropertiesData) {
          try {
            const properties = JSON.parse(itemPropertiesData);
           // console.log('Parsed properties:', properties);
            
            const hasProperty = properties.some(prop => {
              const isMatch = Array.isArray(prop) && prop[0] === this.inclusionProperty;
            //  console.log(`   Checking property pair:`, prop, `Match: ${isMatch}`);
              return isMatch;
            });
            
            if (hasProperty) {
            //  console.log(`Split Order: Found preorder property "${this.inclusionProperty}"`);
              hasPreorderProduct = true;
            } else {
            //  console.log(`Split Order: Item without preorder property (regular product)`);
              hasNonPreorderProduct = true;
            }
          } catch (e) {
            console.error('Error parsing properties for split order:', e);
            hasNonPreorderProduct = true; // Assume non-preorder if parsing fails
          }
        } else {
        //  console.log('No data-properties - counting as non-preorder product');
          hasNonPreorderProduct = true;
        }
      }
      
      // EXPRESS ORDER LOGIC - Check for exclusion properties in data-properties
      if (this.isExpressOrder && this.exclusionProperty) {
        const itemPropertiesData = item.getAttribute('data-properties');
        
        if (itemPropertiesData) {
          try {
            const properties = JSON.parse(itemPropertiesData);
            const exclusionProperties = this.exclusionProperty.split(',').map(p => p.trim());
            
            const hasProperty = properties.some(prop => {
              return Array.isArray(prop) && exclusionProperties.includes(prop[0]);
            });
            
            if (hasProperty) {
              hasExcludedProduct = true;
            }
          } catch (e) {
            console.error('Error parsing cart item properties:', e);
          }
        }
      }
      
      // FALLBACK: OLD EXPRESS ORDER LOGIC - Check for excluded collections (backwards compatibility)
      if (this.isExpressOrder && this.exclusionCollections.length > 0 && itemCollections) {
        const collections = itemCollections.split(',').map(c => c.trim());
        if (collections.some(col => this.exclusionCollections.includes(col))) {
          hasExcludedProduct = true;
        }
      }
      
      // NORMAL LOGIC: Check if this item is from a qualifying collection
      if (!this.isExpressOrder && !this.isSplitOrder && itemCollections) {
        const collections = itemCollections.split(',').map(c => c.trim());
        if (collections.some(col => this.collections.includes(col))) {
          hasQualifyingProduct = true;
        }
      }
    });
    
    // SPLIT ORDER - Show only if BOTH preorder AND non-preorder products exist
    if (this.isSplitOrder) {
     // console.log(`Split Order Summary: Preorder=${hasPreorderProduct}, Non-preorder=${hasNonPreorderProduct}`);
      
      if (hasPreorderProduct && hasNonPreorderProduct) {
       // console.log('Split Order: Showing option (cart has both types)');
        this.ensureCheckboxContainerExists(extraOptionInCart);
      } else {
      //  console.log('Split Order: Hiding option (need both preorder and non-preorder items)');
        this.hideCheckboxContainer();
        if (extraOptionInCart) {
          this.removeFromCart(true);
        }
      }
    }
    // EXPRESS ORDER - Show only if NO excluded products AND not in blocked time window
    else if (this.isExpressOrder) {
      
      if (!hasExcludedProduct) {
        this.ensureCheckboxContainerExists(extraOptionInCart);
      } else {
        this.hideCheckboxContainer();
        // Auto-remove if excluded product added or time window active
        if (extraOptionInCart) {
          this.removeFromCart(true);
        }
      }
    } 
    // NORMAL OPTIONS - Show/hide based on qualifying products
    else {
      if (hasQualifyingProduct) {
        this.ensureCheckboxContainerExists(extraOptionInCart);
      } else {
        this.hideCheckboxContainer();
      }
      
      // Auto-remove logic
      if (!hasQualifyingProduct && extraOptionInCart) {
        this.removeFromCart(true);
      }
    }
  }

  // Ensure checkbox container exists and is visible
  ensureCheckboxContainerExists(isChecked, attempts = 0, maxAttempts = 15) {
    const checkboxContainer = document.querySelector(this.containerSelector);
    const dropdown_extra_options_container = document.querySelector('.extra-options-section');
  
    if (!checkboxContainer && attempts < maxAttempts) {
      setTimeout(() => this.ensureCheckboxContainerExists(isChecked, attempts + 1, maxAttempts), 200);
      return;
    }
  
    if (checkboxContainer) {
      checkboxContainer.style.display = 'block';
      if (dropdown_extra_options_container) {
        dropdown_extra_options_container.style.display = 'block';
      }
    
      // ensures the button has a live event listener after drawer rebuild
      this.setupEventListener();
    
      this.syncButtonFromCart(); // truth from /cart.js
    }
    
  }

  // Hide checkbox container
  hideCheckboxContainer() {
    const checkboxContainer = document.querySelector(this.containerSelector);
    const dropdown_extra_options_container = document.querySelector('.extra-options-section');
    
    if (checkboxContainer) {
      checkboxContainer.style.display = 'none';
      // If no other extra options are visible, hide the whole section
      if (dropdown_extra_options_container) {
        const anyVisible = Array.from(dropdown_extra_options_container.querySelectorAll('div')).some(div => div.style.display === 'block');
        if (!anyVisible) {
          dropdown_extra_options_container.style.display = 'none';
        }
      }
    } else {
      // console.log(`Option ${this.id} - Container ${this.containerSelector} not found to hide`);
    }
  }

  // Add option to cart
  async addToCart() {
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: this.variantId, 
          quantity: 1,
          properties: {
            '_addOn': true
          }
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Invalidate cache after mutation
      if (window.CartData && typeof CartData.invalidate === 'function') {
        CartData.invalidate();
      }
      
      this.updateButtonState(true);
      this.refreshCart();
      setTimeout(() => this.syncButtonFromCart(), 350);
      return data;
    } catch (error) {
      console.error(`Option ${this.id} - Error adding to cart:`, error);
      throw error;
    }
  }

  
async findLineItemKeyForVariant() {
  // Use shared CartData instead of individual fetch
  const cart = await CartData.getCart();

  // Prefer the line with our _addOn flag
  const match =
    cart.items.find(i =>
      String(i.variant_id) === String(this.variantId) &&
      (i.properties?._addOn === true || i.properties?._addOn === 'true')
    ) ||
    cart.items.find(i => String(i.variant_id) === String(this.variantId));

  return match?.key || null;
}

async syncButtonFromCart(maxRetries = 2, delay = 400) {
  try {
    // ALWAYS use shared CartData - no fallback to individual fetch
    // This prevents duplicate /cart.js requests
    if (!window.CartData || typeof CartData.getCart !== 'function') {
      console.warn('[ExtraOption] CartData not available for option', this.id);
      return;
    }

    // Use cached cart data (don't force refresh)
    const cart = await CartData.getCart();
    const items = Array.isArray(cart.items) ? cart.items : [];

    // Find the matching line for this extra option
    const match =
      items.find(i =>
        String(i.variant_id) === String(this.variantId) &&
        (i.properties?._addOn === true || i.properties?._addOn === 'true')
      ) ||
      items.find(i => String(i.variant_id) === String(this.variantId));

    // Update button state based on cart contents
    this.updateButtonState(!!match);
    this.syncPriceFromCart(match || null);
  } catch (e) {
    console.error(
      '[ExtraOption] syncButtonFromCart failed for option %o (variant %o)',
      this.id,
      this.variantId,
      e
    );
  }
}

// Keep the card's displayed price in sync with the live cart line.
// ABConvert price tests (cart transform) change the charged price of the
// add-on line item; the card otherwise shows the frozen settings price.
syncPriceFromCart(match) {
  const container = document.querySelector(this.containerSelector);
  const priceEl = container?.querySelector('.extra-option-price');
  if (!priceEl) return; // old cart-page markup has no .extra-option-price

  if (priceEl.dataset.originalPrice === undefined) {
    priceEl.dataset.originalPrice = priceEl.innerHTML;
  }

  if (match) {
    const cents = (typeof match.final_price === 'number') ? match.final_price : match.price;
    if (typeof cents !== 'number') return;
    try {
      priceEl.innerHTML = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } catch (e) {
      // formatting helper unavailable - leave server-rendered price untouched
    }
  } else {
    // Not in cart yet: show the visitor's ABConvert test price if one applies,
    // so the card matches what the cart transform will charge after adding.
    const testCents = this.getAbconvertPriceCents();
    if (typeof testCents === 'number') {
      try {
        priceEl.innerHTML = theme.Currency.formatMoney(testCents, theme.settings.moneyFormat);
      } catch (e) {
        priceEl.innerHTML = priceEl.dataset.originalPrice;
      }
    } else {
      priceEl.innerHTML = priceEl.dataset.originalPrice;
      // A test exists but ABConvert hasn't assigned this visitor yet - retry shortly
      if (testCents === undefined) this.scheduleAbconvertPriceRetry();
    }
  }
}

// Resolve the visitor's ABConvert cart-transform test price for this option's
// variant. ABConvert exposes the test config on every page as
// window.abconvertPriceCartTransformTestDict (product id -> variantToGroupIndexToPrice)
// and persists the visitor's group assignment in localStorage under
// "abconvert.experiment.<experimentId>.group" (sessionStorage holds preview overrides).
// Returns: price in cents when resolved, null when the variant is not in any
// active test (or the visitor is excluded), undefined when a test exists but
// the group assignment has not been written yet.
getAbconvertPriceCents() {
  try {
    const dict = window.abconvertPriceCartTransformTestDict;
    if (!dict) return null;
    const nonProductKeys = ['experiments', 'allOptionsMap', 'cssSettings', 'previewKey', 'fetchCountryCode', 'setUrlParams', '_excludedExperiments'];
    for (const key in dict) {
      if (nonProductKeys.includes(key)) continue;
      const entry = dict[key];
      const groupMap = entry?.variantToGroupIndexToPrice?.[String(this.variantId)];
      if (!groupMap || !entry.experimentId) continue;
      // ABConvert charges the base price when the visitor is outside the
      // test's served countries - mirror that and fall back to settings price
      const country = (window.Shopify?.country || sessionStorage.getItem('abconvert-country') || '').toUpperCase();
      if (Array.isArray(entry.servedCountries) &&
          (entry.servedCountries.length === 0 || (country && !entry.servedCountries.includes(country)))) {
        return null;
      }
      const storageKey = 'abconvert.experiment.' + entry.experimentId + '.group';
      let group = parseInt(sessionStorage.getItem(storageKey), 10);
      if (isNaN(group)) {
        const stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
        group = (stored && typeof stored.groupIndex === 'number') ? stored.groupIndex : NaN;
      }
      if (isNaN(group)) return undefined;
      if (group < 0) return null;
      const major = parseFloat(groupMap[group]?.price);
      if (!isFinite(major)) return null;
      return Math.round(major * 100);
    }
  } catch (e) {
    // storage blocked or malformed data - fall back to the server-rendered price
  }
  return null;
}

scheduleAbconvertPriceRetry() {
  this._abcRetryCount = this._abcRetryCount || 0;
  if (this._abcRetryTimer || this._abcRetryCount >= 8) return;
  this._abcRetryTimer = setTimeout(() => {
    this._abcRetryTimer = null;
    this._abcRetryCount++;
    this.syncButtonFromCart();
  }, 1000);
}

async removeFromCart(isAutoRemove = false) {
  try {
    const key = await this.findLineItemKeyForVariant();
    if (!key) {
      // already gone — just sync UI and refresh
      this.updateButtonState(false);
      this.refreshCart(isAutoRemove);
      return;
    }

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }) 
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    await response.json();
    
    // Invalidate cache after mutation
    if (window.CartData && typeof CartData.invalidate === 'function') {
      CartData.invalidate();
    }
    
    this.updateButtonState(false);
    this.refreshCart(isAutoRemove);
    setTimeout(() => this.syncButtonFromCart(), 350);
  } catch (error) {
    console.error(`Option ${this.id} - Error removing from cart:`, error);
    throw error;
  }
}

  // Refresh cart after changes
  refreshCart(isAutoRemove = false) {
    const cartDrawerIsOpen = document.getElementById('CartDrawer') && 
      document.getElementById('CartDrawer').classList.contains('drawer--is-open');
    
    if (cartDrawerIsOpen && typeof refreshCartDrawer === 'function') {
      refreshCartDrawer(isAutoRemove);
    } else {
     // alert('Please refresh the page to see updated cart contents.');
     // window.location.reload();
    }
  }

  // Setup event listener for this option's checkbox
    // Setup event listener for this option's button
    setupEventListener() {
      const container = document.querySelector(this.containerSelector);
      if (!container) return;
  
      const button = container.querySelector(
        `.btn-add-extra-option[data-option-number="${this.id}"]`
      );
      if (!button) return;
  
      // Prevent double-binding for this option
      if (this._listenerBound) return;
      this._listenerBound = true;
  
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.inFlight) return;
        this.inFlight = true;
  
        const isSelected =
          button.classList.contains('added') ||
          button.getAttribute('aria-pressed') === 'true';
  
        try {
          if (isSelected) {
            // Remove
            button.textContent = extra_options_translations.removing_extra_option;
            await this.removeFromCart(false);
          } else {
            // Add
            button.textContent = extra_options_translations.adding_extra_option;
            await this.addToCart();
          }
  
          // After the add/remove, /cart.js + syncButtonFromCart()
          // will bring the button text back to the correct state.
  
        } catch (err) {
          console.error(`Option ${this.id} click error:`, err);
          // fallback UI
          this.updateButtonState(false);
        } finally {
          this.inFlight = false;
        }
      });
    }
  

  // Setup cart monitoring for this option
  setupCartMonitoring() {
    const cartContainer = document.querySelector('[data-products]');
    
    if (cartContainer) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            setTimeout(() => this.checkQualifyingProducts(), 100);
          }
        });
      });
      
      observer.observe(cartContainer, {
        childList: true,
        subtree: true
      });
      // console.log(`Option ${this.id} - Cart monitoring set up`);
    }
  }

  // Initialize this extra option
  init() {
    this.setupEventListener();
    this.setupCartMonitoring();
    this.checkQualifyingProducts();
    this.syncButtonFromCart();
  }
}

// ExtraOptionsManager - manages all extra options
const ExtraOptionsManager = {
  options: [],
  giftWrap: null,

  // Initialize all configured options
  init() {

    // Initialize gift wrapping
    // this.giftWrap = new GiftWrapOption();
    
    if (!window.extraOptionsConfig || !Array.isArray(window.extraOptionsConfig)) {
      // console.log('No extra options configuration found');
      return;
    }
    
    window.extraOptionsConfig.forEach(config => {
      // Check for either collections OR exclusionCollections OR exclusionProperty OR inclusionProperty
      const hasValidConfig = (config.collections && config.collections.length) || 
                             (config.exclusionCollections && config.exclusionCollections.length) ||
                             (config.exclusionProperty) ||
                             (config.inclusionProperty);
      
      if (hasValidConfig && config.variantId) {
        const option = new ExtraOption(config);
        this.options.push(option);
        option.init();
      } else {
        // console.log(`Option ${config.id} not configured properly, skipping...`);
      }
    });

    // Make check functions globally available for refreshCartDrawer compatibility
    window.globalCheckQualifyingProducts = () => this.checkAllOptions();
    window.globalCheckQualifyingProducts2 = () => this.checkAllOptions(); // Legacy compatibility
  },

  // Check all options
  checkAllOptions() {

    // Skip all normal option logic while in luxury mode
    if (window.__luxuryModeActive) {
      // console.log('[ExtraOptions] Skipping option checks – luxury mode active');
      return;
    }

    this.options.forEach(option => {
      option.checkQualifyingProducts();
    });

    // Also check gift wrap state
    // if (this.giftWrap) {
    //   this.giftWrap.checkCurrentState();
    // }
  },

  // Get option by ID
  getOption(id) {
    return this.options.find(option => option.id === id);
  }
};

if (!window.__extraOptionsInitialized) {
  window.__extraOptionsInitialized = true;
  
  document.addEventListener('DOMContentLoaded', async function() {
    // Wait for cart initialization to complete before initializing options
    // This prevents each option from making individual /cart.js requests
    if (!window.__cartInitialized) {
      await new Promise(resolve => {
        document.addEventListener('cart:initialized', resolve, { once: true });
      });
    }
    
    ExtraOptionsManager.init();
  });
}

// Listen for cart updates from theme
document.addEventListener('cart:updated', function() {
  setTimeout(() => {
    if (typeof ExtraOptionsManager !== 'undefined') {
      ExtraOptionsManager.checkAllOptions();
    }
  }, 200);
});

document.addEventListener('cart:build', function() {
  setTimeout(() => {
    if (typeof ExtraOptionsManager !== 'undefined') {
      ExtraOptionsManager.checkAllOptions();
    }
  }, 200);
});

// Listen for Ajax cart events
document.addEventListener('ajaxCart:updated', function() {
  setTimeout(() => {
    if (typeof ExtraOptionsManager !== 'undefined') {
      ExtraOptionsManager.checkAllOptions();
    }
  }, 200);
});

async function fetchCartDrawerMarkup() {
  // Try common section ids used by Impulse variants
  const candidates = [
    '/?section_id=cart-drawer',
    '/?sections=cart-drawer',
    '/?section_id=ajaxcart',
    '/?sections=ajaxcart',
    '/cart?view=drawer' // theme alternate template fallback
  ];

  for (const url of candidates) {
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (res.ok) {
        const text = await res.text();
        // Some endpoints return JSON { "cart-drawer": "<html...>" }
        try {
          const maybeJson = JSON.parse(text);
          const firstKey = Object.keys(maybeJson)[0];
          if (firstKey && typeof maybeJson[firstKey] === 'string') {
            return maybeJson[firstKey];
          }
        } catch (_) {
          /* plain HTML; use as-is */
        }
        return text;
      }
    } catch (_) {}
  }

  // Last resort: fetch current page
  const resp = await fetch(window.location.href, { credentials: 'same-origin' });
  return await resp.text();
}

function safeRunOptionChecks() {
  try {
    if (typeof window.globalCheckQualifyingProducts === 'function') {
      window.globalCheckQualifyingProducts();
    }
    if (typeof window.globalCheckQualifyingProducts2 === 'function') {
      window.globalCheckQualifyingProducts2();
    }
  } catch (e) {
    console.error('safeRunOptionChecks failed', e);
  }
}

// Refresh function for impulse cart drawer
// Tries multiple methods to ensure compatibility with different Impulse versions
// isAutoRemove: true if triggered by auto-remove logic, false if manual user action

let isRebuildingDrawer = false;
let rebuildQueued = false;
let autoRemoveDebounceTimer = null;

function refreshCartDrawer(isAutoRemove = false) {
  // Manual path: prefer the classic Impulse trigger (only for non-auto removes)
  try {
    if (!isAutoRemove && typeof $ !== 'undefined' && $("form.ajaxcart .js-qty__num").length > 0) {
      $("form.ajaxcart .js-qty__num").first().trigger("change");

      // Wait for Impulse to rebuild, then re-check option widgets
      setTimeout(() => {
        waitForCheckboxContainers();
        if (window.updateShippingInsurance) window.updateShippingInsurance();
        if (window.updatePricematchInsurance) window.updatePricematchInsurance();
        rebindExtraOptionButtons();
      }, 800);
      return;
    }
  } catch (error) {
    // console.log('Classic Impulse method failed:', error);
  }

  // Manual removes: do a minimal refresh and bail
  if (!isAutoRemove) {
    setTimeout(() => {
      waitForCheckboxContainers();
      if (window.updateShippingInsurance) window.updateShippingInsurance();
      if (window.updatePricematchInsurance) window.updatePricematchInsurance();
      rebindExtraOptionButtons();
    }, 400);

    updateCartCountsOnly();
    return;
  }

  // Auto-removes (batch): debounce and run exactly one rebuild for the burst
  if (autoRemoveDebounceTimer) clearTimeout(autoRemoveDebounceTimer);
  autoRemoveDebounceTimer = setTimeout(() => {
    queueDrawerRebuild();
  }, 200);
}

function queueDrawerRebuild() {
  if (isRebuildingDrawer) {
    rebuildQueued = true; // coalesce multiple requests
    return;
  }

  isRebuildingDrawer = true;

  fetchAndRebuildCartDrawer()
    .catch((e) => {
      console.error('fetchAndRebuildCartDrawer failed', e);
    })
    .finally(() => {
      isRebuildingDrawer = false;
      if (rebuildQueued) {
        rebuildQueued = false;
        // let DOM settle, then process the queued rebuild request
        setTimeout(queueDrawerRebuild, 100);
      }
    });
}

// ============================================
// Extra Options: Express (6) & Split (7) logic
// ============================================
(function () {
  if (!window.extraOptionsConfig) return;

  const expressConfig = window.extraOptionsConfig.find(o => o.isExpressOrder);
  const splitConfig   = window.extraOptionsConfig.find(o => o.isSplitOrder);

  if (!expressConfig && !splitConfig) return;

  // Small helper to fetch cart + derive "base items" (no add-ons / deferred)
  async function getFacts() {
    // Use shared CartData
    if (window.CartData && typeof CartData.getCart === 'function') {
      const cart = await CartData.getCart(); // Use cached data

      const items = cart.items || [];
      const baseItems = items.filter(item => {
        const props = item.properties || {};
        const isAddOn   = props._addOn === true || props._addOn === 'true';
        const isDeferred = !!props._deferredPayment;
        return !isAddOn && !isDeferred;
      });

      return { cart, baseItems };
    }

    // Fallback - should not happen if cart initialized properly
    console.warn('[Express/Split] CartData not available');
    return { cart: { items: [] }, baseItems: [] };
  }

  function setOptionVisibility(config, show) {
    if (!config || !config.containerSelector) return;
    const el = document.querySelector(config.containerSelector);
    if (!el) return;
    el.style.display = show ? 'block' : 'none';
  }

  async function removeVariantIfPresent(config, cart) {
    if (!config || !config.variantId || !cart || !Array.isArray(cart.items)) return;

    const variantId = String(config.variantId);
    const line = cart.items.find(item => String(item.variant_id) === variantId);

    if (!line) return;

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });

      if (typeof refreshCartDrawer === 'function') {
        refreshCartDrawer(true);
      }
    } catch (err) {
      console.error('[ExtraOptions] Failed to auto-remove add-on', err);
    }
  }

  async function updateExpressAndSplitOptions() {
    const { cart, baseItems } = await getFacts();

    // ---------- EXPRESS ORDER (Option 6) ----------
    if (expressConfig) {
      const exclusionProp = (expressConfig.exclusionProperty || '').trim();

      let shouldShowExpress = false;

      if (baseItems.length > 0) {
        if (exclusionProp) {
          // Split exclusion properties by comma and trim
          const exclusionProperties = exclusionProp.split(',').map(p => p.trim());
          
          const hasExclusion = baseItems.some(item => {
            const props = item.properties || {};
            // Check if any of the exclusion properties exist in this item
            return exclusionProperties.some(prop => 
              props[prop] !== undefined && props[prop] !== null && props[prop] !== ''
            );
          });
          
          shouldShowExpress = !hasExclusion;
        } else {
          // No configured exclusion property → show whenever we have base items
          shouldShowExpress = true;
        }
      }

      if (shouldShowExpress) {
        setOptionVisibility(expressConfig, true);
      } else {
        setOptionVisibility(expressConfig, false);
        await removeVariantIfPresent(expressConfig, cart);
      }
    }

    // ---------- SPLIT ORDER (Option 7) ----------
    if (splitConfig) {
      const inclusionProp = (splitConfig.inclusionProperty || '').trim();
      let shouldShowSplit = false;

      if (inclusionProp && baseItems.length > 1) {
        const withFlag = baseItems.filter(item => {
          const props = item.properties || {};
          return props[inclusionProp] !== undefined && props[inclusionProp] !== null && props[inclusionProp] !== '';
        });

        const withoutFlag = baseItems.filter(item => {
          const props = item.properties || {};
          return !props[inclusionProp];
        });

        // show only if:
        // - at least one item has the property
        // - at least one other item does NOT have it
        shouldShowSplit = withFlag.length > 0 && withoutFlag.length > 0;
      }

      if (shouldShowSplit) {
        setOptionVisibility(splitConfig, true);
      } else {
        setOptionVisibility(splitConfig, false);
        await removeVariantIfPresent(splitConfig, cart);
      }
    }
  }

  // Run on initial build + whenever cart updates
  document.addEventListener('DOMContentLoaded', async function () {
    // Wait for cart initialization
    if (!window.__cartInitialized) {
      await new Promise(resolve => {
        document.addEventListener('cart:initialized', resolve, { once: true });
      });
    }
    setTimeout(updateExpressAndSplitOptions, 100);
  });

  document.addEventListener('cart:updated', function () {
    setTimeout(updateExpressAndSplitOptions, 50);
  });

  document.addEventListener('cart:build', function () {
    setTimeout(updateExpressAndSplitOptions, 50);
  });
})();


// Minimal cart count update function
async function updateCartCountsOnly() {
  try {
    
    // Fetch current cart data
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    // Update cart count in title
    const cartTitleCount = document.querySelector('.cart-title-count, .cart-count, [data-cart-count]');
    if (cartTitleCount) {
      cartTitleCount.textContent = `(${cart.item_count})`;
    }
    
    // Update header cart count
    const headerCartCount = document.querySelector('.site-header__cart-count, .cart-link__bubble-num, [data-header-cart-count]');
    if (headerCartCount) {
      headerCartCount.textContent = cart.item_count;
      headerCartCount.style.display = cart.item_count > 0 ? 'block' : 'none';
    }
    
    // Update subtotal with correct currency symbol
    const subtotalElement = document.querySelector('[data-subtotal], .cart__subtotal-price, .ajaxcart__subtotal-price');
    if (subtotalElement) {
      // Use Shopify's money format if available
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        const formattedPrice = Shopify.formatMoney(cart.total_price, theme.moneyFormat);
        // Remove HTML tags if present
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = formattedPrice;
        subtotalElement.textContent = tempDiv.textContent || tempDiv.innerText || formattedPrice;
      } else {
        // Fallback: manual formatting with currency symbol at the end
        const currencySymbols = {
          'DKK': 'kr',
          'SEK': 'kr',
          'NOK': 'kr',
          'PLN': 'zł',
          'EUR': '€',
        };
        
        const symbol = currencySymbols[cart.currency] || cart.currency;
        const amount = (cart.total_price / 100).toFixed(2).replace('.', ',');
        const formattedPrice = `${amount} ${symbol}`;
        subtotalElement.textContent = formattedPrice;
      }
    }
    
  } catch (error) {
    console.error('Error updating cart counts:', error);
  }
}

// Wait for checkbox containers to exist before running checks
function waitForCheckboxContainers(attempts = 0, maxAttempts = 10) {
  // Check if cart items exist (indicating cart HTML is loaded)
  const cartItems = document.querySelectorAll('.cart__item');
  
  if (cartItems.length === 0 && attempts < maxAttempts) {
    setTimeout(() => waitForCheckboxContainers(attempts + 1, maxAttempts), 200);
    return;
  }
  
  // run the qualifying product checks  
  safeRunOptionChecks();
  
  // Wait a bit more and run checks again to ensure containers are visible
  setTimeout(() => {
    // console.log('Running secondary qualifying product checks...');
    safeRunOptionChecks();
  }, 300);
}

function rebindExtraOptionButtons() {
  try {
    if (window.ExtraOptionsManager && Array.isArray(ExtraOptionsManager.options)) {
      ExtraOptionsManager.options.forEach(opt => opt && opt.setupEventListener && opt.setupEventListener());
    }
  } catch (e) {
    console.error('rebindExtraOptionButtons failed', e);
  }
}

// Enhanced manual cart drawer update function for Impulse
async function fetchAndRebuildCartDrawer() {
  try {
    // Fetch current cart data
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Update free gift state passing the cart object
    // so we make one less call to /cart.js
   // if (window.updateFreeGift) {
   //   window.updateFreeGift(cart);
   // }
    
    // Update cart count in title immediately
    const cartTitleCount = document.querySelector('.cart-title-count, .cart-count, [data-cart-count]');
    if (cartTitleCount) {
      cartTitleCount.textContent = `(${cart.item_count})`;
    }
    
    // Update header cart count
    const headerCartCount = document.querySelector('.site-header__cart-count, .cart-link__bubble-num, [data-header-cart-count]');
    if (headerCartCount) {
      headerCartCount.textContent = cart.item_count;
      headerCartCount.style.display = cart.item_count > 0 ? 'block' : 'none';
    }
    
    // Update subtotal with correct currency symbol
    const subtotalElement = document.querySelector('[data-subtotal], .cart__subtotal-price, .ajaxcart__subtotal-price');
    if (subtotalElement) {
      // Use Shopify's money format if available
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        const formattedPrice = Shopify.formatMoney(cart.total_price, theme.moneyFormat);
        // Remove HTML tags if present
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = formattedPrice;
        subtotalElement.textContent = tempDiv.textContent || tempDiv.innerText || formattedPrice;
      } else {
        // Fallback: manual formatting with currency symbol
        const currencySymbols = {
          'DKK': 'kr',
          'SEK': 'kr',
          'NOK': 'kr',
          'PLN': 'zł',
          'EUR': '€',
          'USD': '$',
          'GBP': '£'
        };
        
        const symbol = currencySymbols[cart.currency] || cart.currency;
        const amount = (cart.total_price / 100).toFixed(2).replace('.', ',');
        const formattedPrice = `${amount} ${symbol}`;
        subtotalElement.textContent = formattedPrice;
      }
    }
    
    // try to rebuild the cart items via theme methods first
    if (typeof theme !== 'undefined' && theme.ajaxCart && typeof theme.ajaxCart.load === 'function') {
      theme.ajaxCart.load();
      
      setTimeout(() => {
        safeRunOptionChecks();
        // also ensures the check waits for items to exist:
        waitForCheckboxContainers();
        rebindExtraOptionButtons();
      }, 300);
      return;
    }
    
    // Fallback to HTML rebuild
    await rebuildCartDrawerHTML(cart);
    
  } catch (error) {
    console.error('Error in fetchAndRebuildCartDrawer:', error);
    
    // Final fallback: trigger the qualifying checks
    setTimeout(() => {
      safeRunOptionChecks();
      rebindExtraOptionButtons();
    }, 500);
  }
}

async function rebuildCartDrawerHTML(cart) {
  try {
    // Fetch the current page HTML
    const html = await fetchCartDrawerMarkup();
    
    // Parse the HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Find cart drawer sections to update
    const sections = [
      { current: '#CartDrawer', new: '#CartDrawer' },
      { current: '.ajaxcart', new: '.ajaxcart' },
      { current: '[data-cart-drawer]', new: '[data-cart-drawer]' }
    ];
    
    for (const section of sections) {
      const currentSection = document.querySelector(section.current);
      const newSection = doc.querySelector(section.new);
      
      if (currentSection && newSection) {
        // Preserve open state
        const wasOpen = currentSection.classList.contains('drawer--is-open') || 
                        currentSection.classList.contains('is-open');
        
        // Update content
        currentSection.innerHTML = newSection.innerHTML;
        
        // Restore open state
        if (wasOpen) {
          currentSection.classList.add('drawer--is-open', 'is-open');
        }
        
        // console.log(`Updated ${section.current}`);
        break; // Only update the first matching section
      }
    }

    // Explicitly sync the items list in case the wrapper copy missed it
   const curProducts = document.querySelector('[data-products]');
   const newProducts = doc.querySelector('[data-products]');
   if (curProducts && newProducts) {
     curProducts.innerHTML = newProducts.innerHTML;
   }

   // Dispatch events with cart in detail so other listeners can use it
   const detail = cart ? { cart } : undefined;
    
    // Dispatch Impulse-specific events
    document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
    document.dispatchEvent(new CustomEvent('cart:build', { detail }));
    
    // Run qualifying product checks
    setTimeout(() => {
      safeRunOptionChecks();
      waitForCheckboxContainers();
      rebindExtraOptionButtons();
    }, 100);
    
  } catch (error) {
    console.error('Error rebuilding cart drawer HTML:', error);
  }
}

/* new cart drawer functionality */
/* new cart drawer functionality */
/* new cart drawer functionality */

document.addEventListener('DOMContentLoaded', function() {

  // get cart translations from theme.liquid
  const cart_drawer_translations = {
    adding_product_variants: document.querySelector('.translation_adding_product_variants').innerText.trim(),
    choose_size: document.querySelector('.translation_choose_size').innerText.trim(),
    choose_a_size: document.querySelector('.translation_choose_a_size').innerText.trim(),
    cart_adding: document.querySelector('.translation_cart_adding').innerText.trim(),
    sold_out: document.querySelector('.translation_sold_out').innerText.trim(),
    error_adding_to_cart: document.querySelector('.translation_error_adding_to_cart').innerText.trim(),
    add_to_cart: document.querySelector('.translation_add_to_cart').innerText.trim(),
  };
  
  // ===========================
  // CONFIGURATION & STATE
  // ===========================
  
  const CONFIG = {
    selectors: {
      cartDrawer: '#CartDrawer',
      cartTitle: '.drawer__title',
      cartItems: '[data-products] .cart__item',
      carousel: '.carousel-track',
      carouselItems: '.grid__item',
      carouselLeftArrow: '.carousel-arrow--left',
      carouselRightArrow: '.carousel-arrow--right'
    },
    carousel: {
      gap: 16,
      transitionDuration: '0.3s'
    },
    delays: {
      cartRefresh: 400,
      carouselInit: 300,
      opacityFix: [100, 500, 1000, 1500],
      titleUpdate: [150, 500]
    }
  };
  
  let carouselState = {
    currentPosition: 0,
    maxPosition: 0,
    itemWidth: 0,
    gap: CONFIG.carousel.gap,
    initialized: false
  };
  
  // ===========================
  // UTILITY FUNCTIONS
  // ===========================
  
  const Utils = {
    formatPrice(variant) {
      // Use Shopify's money format if available
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof theme !== 'undefined' && theme.moneyFormat) {
        const price = Shopify.formatMoney(variant.price, theme.moneyFormat);
        
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const comparePrice = Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat);
          return `<span class="price__sale">${price}</span><span class="price__compare">${comparePrice}</span>`;
        }
        
        return `<span class="price__regular">${price}</span>`;
      }
      
      // Fallback: manual formatting with currency symbols
      const currencySymbols = {
        'DKK': 'kr',
        'SEK': 'kr',
        'NOK': 'kr',
        'PLN': 'zł',
        'EUR': '€',
      };
      
      // Get currency from Shopify.currency.active or window.Shopify.currency if available
      const currency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) 
        ? Shopify.currency.active 
        : 'DKK'; // fallback to DKK
      
      const symbol = currencySymbols[currency] || currency;
      
      const formatAmount = (cents) => {
        const amount = (cents / 100).toFixed(2).replace('.', ',');
        return `${amount} ${symbol}`;
      };
      
      const price = formatAmount(variant.price);
      
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const comparePrice = formatAmount(variant.compare_at_price);
        return `<span class="price__sale">${price}</span><span class="price__compare">${comparePrice}</span>`;
      }
      
      return `<span class="price__regular">${price}</span>`;
    },

    async fetchCart() {
      // Use CartData instead of direct fetch
      if (window.CartData && typeof CartData.getCart === 'function') {
        return await CartData.getCart(); // Use cache
      }
      
      // Fallback only if CartData unavailable
      try {
        const response = await fetch('/cart.js');
        return await response.json();
      } catch (error) {
        console.error('Failed to fetch cart:', error);
        throw error;
      }
    },

    async fetchProduct(handle) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) {
          throw new Error(`Failed to load product data. Status: ${response.status}`);
        }
        return await response.json();
      } catch (error) {
        console.error('Failed to fetch product:', error);
        throw error;
      }
    },

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    findProductData(button) {
      let productId = button.dataset.productId || button.dataset.product || button.getAttribute('data-product-id');
      let productHandle = button.dataset.productHandle || button.dataset.handle || button.getAttribute('data-product-handle');
      
      if (!productId || !productHandle) {
        const productContainer = button.closest('[data-product-id], [data-product-handle], .grid__item, .product-item');
        if (productContainer) {
          productId = productId || productContainer.dataset.productId || productContainer.getAttribute('data-product-id');
          productHandle = productHandle || productContainer.dataset.productHandle || productContainer.getAttribute('data-product-handle');
        }
      }
      
      return { productId, productHandle };
    }
  };

  // ===========================
  // CAROUSEL MANAGEMENT
  // ===========================
  
  const CarouselManager = {
    init() {
      this.initCarousel();
      this.fixImageOpacity();
      this.watchForOpacityAndStructureChanges();
    },

    initCarousel() {
      const carousel = document.querySelector(CONFIG.selectors.carousel);
      const leftArrow = document.querySelector(CONFIG.selectors.carouselLeftArrow);
      const rightArrow = document.querySelector(CONFIG.selectors.carouselRightArrow);
      
      if (!carousel || !leftArrow || !rightArrow) {
        setTimeout(() => this.initCarousel(), 200);
        return;
      }
      
      const items = carousel.querySelectorAll(CONFIG.selectors.carouselItems);
      
      if (items.length === 0) {
        setTimeout(() => this.initCarousel(), 200);
        return;
      }
      
      requestAnimationFrame(() => {
        this.calculateCarouselDimensions(carousel, items, leftArrow, rightArrow);
      });
    },

    calculateCarouselDimensions(carousel, items, leftArrow, rightArrow) {
      const containerWidth = carousel.offsetWidth;
      const firstItem = items[0];
      
      if (containerWidth === 0 || firstItem.offsetWidth === 0) {
        setTimeout(() => this.initCarousel(), 200);
        return;
      }
      
      // Reset carousel position
      carousel.style.transform = 'translateX(0px)';
      carousel.style.transition = `transform ${CONFIG.carousel.transitionDuration} ease`;
      
      // Calculate carousel parameters
      const itemWidth = firstItem.offsetWidth;
      const totalItemWidth = itemWidth + carouselState.gap;
      const visibleItems = Math.floor((containerWidth + carouselState.gap) / totalItemWidth);
      const totalItems = items.length;
      const maxPosition = Math.max(0, totalItems - visibleItems);
      
      // Update carousel state
      carouselState = {
        currentPosition: 0,
        maxPosition: maxPosition,
        itemWidth: itemWidth,
        gap: carouselState.gap,
        initialized: true
      };
      
      this.toggleArrowVisibility(maxPosition, leftArrow, rightArrow);
      this.fixItemsOpacity(items);
    },

    toggleArrowVisibility(maxPosition, leftArrow, rightArrow) {
      if (maxPosition <= 0) {
        leftArrow.style.display = 'none';
        rightArrow.style.display = 'none';
      } else {
        leftArrow.style.display = '';
        rightArrow.style.display = '';
        this.updateArrowStates();
      }
    },

    fixItemsOpacity(items) {
      items.forEach(item => {
        this.setElementOpacity(item);
        
        // Fix images
        const images = item.querySelectorAll('img, .image-element, .product-single__photo');
        images.forEach(img => this.setElementOpacity(img, true));
        
        // Fix product containers
        const productItem = item.querySelector('.product-item, .grid-product, .product-card');
        if (productItem) {
          this.setElementOpacity(productItem);
        }
      });
    },

    setElementOpacity(element, isImage = false) {
      element.style.setProperty('opacity', '1', 'important');
      element.style.setProperty('visibility', 'visible', 'important');
      
      if (isImage) {
        element.style.setProperty('display', 'block', 'important');
        element.classList.remove('lazyload', 'lazyloading', 'lazyloaded');
        element.classList.remove('aos-animate', 'aos-init');
        
        if (element.classList.contains('image-element')) {
          element.classList.add('opacity-fixed');
        }
      }
    },

    slide(direction) {
      if (!carouselState.initialized) return;
      
      const carousel = document.querySelector(CONFIG.selectors.carousel);
      if (!carousel) return;
      
      const oldPosition = carouselState.currentPosition;
      
      if (direction === 'left' && carouselState.currentPosition > 0) {
        carouselState.currentPosition--;
      } else if (direction === 'right' && carouselState.currentPosition < carouselState.maxPosition) {
        carouselState.currentPosition++;
      }
      
      if (carouselState.currentPosition !== oldPosition) {
        this.animateToPosition(carousel);
      }
      
      this.updateArrowStates();
    },

    animateToPosition(carousel) {
      const totalItemWidth = carouselState.itemWidth + carouselState.gap;
      const translateX = -(carouselState.currentPosition * totalItemWidth);
      carousel.style.transform = `translateX(${translateX}px)`;
    },

    updateArrowStates() {
      const leftArrow = document.querySelector(CONFIG.selectors.carouselLeftArrow);
      const rightArrow = document.querySelector(CONFIG.selectors.carouselRightArrow);
      
      if (!leftArrow || !rightArrow) return;
      
      leftArrow.disabled = carouselState.currentPosition <= 0;
      rightArrow.disabled = carouselState.currentPosition >= carouselState.maxPosition;
      
      leftArrow.classList.toggle('arrow_disabled', leftArrow.disabled);
      rightArrow.classList.toggle('arrow_disabled', rightArrow.disabled);
    },

    fixImageOpacity() {
      const carousel = document.querySelector(CONFIG.selectors.carousel);
      if (!carousel) return;
      
      const items = carousel.querySelectorAll(CONFIG.selectors.carouselItems);
      items.forEach(item => {
        this.setElementOpacity(item);
        
        const images = item.querySelectorAll('img, .image-element, .product-single__photo');
        images.forEach(img => this.setElementOpacity(img, true));
        
        const productContainers = item.querySelectorAll('.product-item, .grid-product, .product-card, .grid__item, [data-aos]');
        productContainers.forEach(container => {
          this.setElementOpacity(container);
          container.classList.remove('aos-animate', 'aos-init');
          container.removeAttribute('data-aos');
        });
      });
      
      const productRecommendations = document.querySelector('.product-recommendations');
      if (productRecommendations) {
        this.setElementOpacity(productRecommendations);
      }
    },

    watchForOpacityAndStructureChanges() {
      const carousel = document.querySelector(CONFIG.selectors.carousel);
      if (!carousel) return;
    
      // Track how many items we’ve seen so far
      let lastItemCount = carousel.querySelectorAll(CONFIG.selectors.carouselItems).length;
    
      const observer = new MutationObserver((mutations) => {
        let structureChanged = false;
    
        for (const mutation of mutations) {
          // 1) Existing behavior: fix opacity if theme flips classes/styles
          if (
            mutation.type === 'attributes' &&
            (mutation.attributeName === 'style' || mutation.attributeName === 'class')
          ) {
            const target = mutation.target;
            this.handleOpacityMutation(target);
          }
    
          // 2) New behavior: detect when items are added/removed
          if (mutation.type === 'childList') {
            structureChanged = true;
          }
        }
    
        if (!structureChanged) return;
    
        const items = carousel.querySelectorAll(CONFIG.selectors.carouselItems);
        const newCount = items.length;
    
        // Only bother recalculating if the number of cards actually changed
        if (newCount !== lastItemCount) {
          lastItemCount = newCount;
    
          // Let layout settle, then recalc dimensions
          requestAnimationFrame(() => {
            const leftArrow  = document.querySelector(CONFIG.selectors.carouselLeftArrow);
            const rightArrow = document.querySelector(CONFIG.selectors.carouselRightArrow);
            if (!leftArrow || !rightArrow || !newCount) return;
    
            this.calculateCarouselDimensions(carousel, items, leftArrow, rightArrow);
          });
        }
      });
    
      observer.observe(carousel, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true,
      });
    
      return observer;
    },

    handleOpacityMutation(target) {
      const computedOpacity = window.getComputedStyle(target).opacity;
      
      if (computedOpacity === '0' || computedOpacity < 1) {
        if (target.classList.contains('image-element') || 
            target.tagName === 'IMG' ||
            target.classList.contains('grid__item') || 
            target.classList.contains('product-item') ||
            target.classList.contains('grid-product')) {
          
          this.setElementOpacity(target, target.tagName === 'IMG');
        }
      }
    }
  };

  // ===========================
  // CART OPERATIONS
  // ===========================
  
  const CartOperations = {
    async removeItem(button) {
      const key = button.dataset.key;
      const cartItem = button.closest('.cart__item');
      
      if (!key) return;
      
      this.setLoadingState(button, cartItem, true);
      
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: key,
            quantity: 0
          })
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        await response.json();

        if (window.checkWarrantyOrphans) {
          setTimeout(() => {
            window.checkWarrantyOrphans(true);
          }, 300);
        }

        CartManager.refreshDisplay();
      } catch (error) {
        console.error('Error removing item:', error);
        this.setLoadingState(button, cartItem, false);
        console.error('Error removing item. Please try again.');
      }
    },

    setLoadingState(button, cartItem, isLoading) {
      button.disabled = isLoading;
      
      if (cartItem) {
        cartItem.classList.toggle('removing', isLoading);
        cartItem.style.opacity = isLoading ? '0.5' : '1';
        cartItem.style.transition = 'opacity 0.3s ease';
      }
    },    
  };

  // ===========================
  // MODAL MANAGEMENT
  // ===========================
  
  const ModalManager = {
    async openQuickShop(button) {
      const { productId, productHandle } = Utils.findProductData(button);
      
      if (!productId || !productHandle) {
        console.error('Could not find product ID or handle for quick shop');
        return;
      }
      
      const { modal, holder } = this.findModalElements(productId, productHandle);
      
      if (modal && holder) {
        await this.loadModalContent(modal, holder, productHandle);
      } else {
        console.error('Could not find modal elements for product:', { productId, productHandle });
        this.triggerFallbackQuickShop(productId, productHandle, button);
      }
    },

    findModalElements(productId, productHandle) {
      let modal = document.getElementById(`QuickShopModalCart-${productId}-${productHandle}`);
      let holder = document.getElementById(`QuickShopHolderCart-${productId}-${productHandle}`);
      
      if (!modal) {
        modal = document.getElementById(`QuickShopModal-${productId}`) ||
                document.getElementById(`QuickShopModalCart-${productId}`) ||
                document.querySelector(`[data-product-modal="${productId}"]`);
      }
      
      if (!holder) {
        holder = document.getElementById(`QuickShopHolder-${productId}`) ||
                 document.getElementById(`QuickShopHolderCart-${productId}`) ||
                 modal?.querySelector('.quick-shop-holder, .modal-content');
      }
      
      return { modal, holder };
    },

    async loadModalContent(modal, holder, productHandle) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      
      holder.innerHTML = `<div class="cart-modal-loading">${cart_drawer_translations.adding_product_variants}</div>`;
      
      modal.classList.add('modal--is-active');
      document.body.classList.add('modal-open');
      
      try {
        const product = await Utils.fetchProduct(productHandle);
        this.createModalContent(holder, product);
      } catch (error) {
        this.showModalError(holder, error);
      }
    },

    createModalContent(holder, product) {
      const currentVariant = product.variants[0];
      
      const modalHTML = `
        <div class="quick-shop-cart-product">
          <div class="modal-header"></div>
          <div class="quick-shop-image-and-info">
            <div class="quick-shop-cart-product__media">
              ${this.renderProductImage(product)}
            </div>
            <div class="quick-shop-cart-product__info">
              <h2 class="quick-shop-cart-product__title">${product.title}</h2>
              <div class="quick-shop-cart-product__price">
                <div class="price" id="quick-shop-price-${product.id}">
                  ${Utils.formatPrice(currentVariant)}
                </div>
              </div>
            </div>
          </div>
          <div class="quick-shop-cart-product__details">
            <form class="quick-shop-cart-product__form" data-product-id="${product.id}">
              ${this.createVariantSelectors(product)}
              <input type="hidden" name="id" id="quick-shop-variant-${product.id}" value="${currentVariant.id}">
              <div class="quick-shop-cart-product__actions">
                <div class="quick-shop-variant-price" id="quick-shop-total-price-${product.id}">
                  <p>Total</p>
                  <span>${Utils.formatPrice(currentVariant)}</span>
                </div>
                <button 
                  type="submit" 
                  class="btn btn--full quick-shop-cart-product__add-button"
                  ${!currentVariant.available ? 'disabled' : ''}>
                  <span class="quick-shop-cart-product__add-text">
                    ${currentVariant.available ? `${cart_drawer_translations.add_to_cart}` : `${cart_drawer_translations.sold_out}`}
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      `;
      
      holder.innerHTML = modalHTML;
      this.initializeModalForm(holder, product);
    },

    renderProductImage(product) {
      return product.featured_image ? `
        <div class="quick-shop-cart-product__image">
          <img src="${product.featured_image}&width=550" alt="${product.title}" loading="lazy">
        </div>
      ` : '';
    },

    createVariantSelectors(product) {
      if (product.options.length <= 1 && product.options[0] === 'Title') {
        return ''; 
      }
      
      let selectorsHTML = '<div class="quick-shop-cart-product__variants">';
      
      product.options.forEach((option, index) => {
        if (option === 'Title') return;
        
        const values = [...new Set(product.variants.map(v => v.options[index]))];

        const isInStock = (value) => {
          return product.variants.find(v => v.options[index] === value && v.available);
        }
        
        selectorsHTML += `
          <div class="quick-shop-cart-product__option">
            <label class="quick-shop-cart-product__option-label">Valg størrelse</label>
            <ul class="quick-shop-cart-product__option-list" data-option-index="${index}">
              ${values.map(value => `
                <li class="quick-shop-cart-product__option-item ${isInStock(value) ? '' : 'disabled'}" 
                    data-value="${value}" 
                    data-option-index="${index}">
                  ${value}
                </li>
              `).join('')}
            </ul>
          </div>
        `;
      });
      
      selectorsHTML += '</div>';
      return selectorsHTML;
    },

    initializeModalForm(holder, product) {
      const elements = {
        form: holder.querySelector('.quick-shop-cart-product__form'),
        variantInput: holder.querySelector(`#quick-shop-variant-${product.id}`),
        priceContainer: holder.querySelector(`#quick-shop-price-${product.id}`),
        totalPriceContainer: holder.querySelector(`#quick-shop-total-price-${product.id} span`),
        addButton: holder.querySelector('.quick-shop-cart-product__add-button'),
        addButtonText: holder.querySelector('.quick-shop-cart-product__add-text'),
        quickShopVariantPrice: holder.querySelector('.quick-shop-variant-price')
      };
      
      this.setupVariantSelection(holder, product, elements);
      this.setupFormSubmission(elements);
    },

    setupVariantSelection(holder, product, elements) {
      const hasSelectableOptions = product.options.length > 1 || 
                                   (product.options.length === 1 && product.options[0] !== 'Title');
      
      if (hasSelectableOptions) {
        elements.addButton.disabled = true;
        elements.addButtonText.textContent = `${cart_drawer_translations.choose_size}`;
      }
      
      const updateVariant = () => {
        const selectedOptions = Array.from(holder.querySelectorAll('.quick-shop-cart-product__option-item.selected'))
                                     .map(item => item.dataset.value);
        
        const totalOptions = product.options.filter(option => option !== 'Title').length;
        const allOptionsSelected = selectedOptions.length === totalOptions;
        
        if (!allOptionsSelected) {
          elements.addButton.disabled = true;
          elements.addButtonText.textContent = `${cart_drawer_translations.choose_size}`;
          if (elements.quickShopVariantPrice) {
            elements.quickShopVariantPrice.style.display = "none";
          }
          return;
        }
        
        const matchingVariant = product.variants.find(variant => {
          return variant.options.every((option, index) => option === selectedOptions[index]);
        });
        
        if (matchingVariant) {
          this.updateVariantDisplay(matchingVariant, elements);
        }
      };
      
      // Add event listeners to option items
      const optionItems = holder.querySelectorAll('.quick-shop-cart-product__option-item');
      optionItems.forEach(item => {
        item.addEventListener('click', function() {
          const siblings = this.parentElement.querySelectorAll('.quick-shop-cart-product__option-item');
          siblings.forEach(sibling => sibling.classList.remove('selected'));
          this.classList.add('selected');
          updateVariant();
        });
      });
    },

    updateVariantDisplay(variant, elements) {
      elements.variantInput.value = variant.id;
      
      if (elements.priceContainer) {
        elements.priceContainer.innerHTML = Utils.formatPrice(variant);
      }
      
      if (elements.totalPriceContainer) {
        elements.totalPriceContainer.innerHTML = Utils.formatPrice(variant);
      }
      
      if (variant.available) {
        elements.addButton.disabled = false;
        elements.addButtonText.textContent = `${cart_drawer_translations.add_to_cart}`;
      } else {
        elements.addButton.disabled = true;
        elements.addButtonText.textContent = `${cart_drawer_translations.sold_out}`;
      }
      
      if (elements.quickShopVariantPrice) {
        elements.quickShopVariantPrice.style.display = "flex";
      }
    },

    setupFormSubmission(elements) {
      if (!elements.form) return;
      
      elements.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        if (!elements.variantInput.value) {
          alert(cart_drawer_translations.choose_a_size);
          return;
        }
        
        const formData = new FormData();
        formData.append('id', elements.variantInput.value);
        formData.append('quantity', '1');

        // Momentum's line marks, so the sale counts for the cart upsell carousel (the modal carries the product id);
        // without Momentum's script (or consent) there are none
        const $momentumProduct = elements.form.closest('[data-product-id]');
        const momentumMarks = window.momentum && $momentumProduct ? window.momentum.lineProperties($momentumProduct.getAttribute('data-product-id')) : {};
        Object.keys(momentumMarks).forEach((key) => formData.append('properties[' + key + ']', momentumMarks[key]));

        elements.addButton.disabled = true;
        const originalText = elements.addButtonText.textContent;
        elements.addButtonText.textContent = cart_drawer_translations.cart_adding;
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          const data = await response.json();
          
          if (data.status && data.status === 422) {
            throw new Error(data.description || 'Fejl ved tilføjelse til kurv');
          }
          
          const modal = elements.form.closest('.modal--cart');
          this.close(modal);
          
          // Update cart title
          CartManager.updateTitle();
          
          // Refresh cart drawer - dispatch events that theme.js listens to
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data }
          }));
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: data }
          }));
          document.dispatchEvent(new Event('cart:build'));
          
          // Also call refresh display to ensure everything updates
          CartManager.refreshDisplay();
          
        } catch (error) {
          alert(error.message || 'Fejl ved tilføjelse til kurv');
          elements.addButton.disabled = false;
          elements.addButtonText.textContent = originalText;
        }
      });
    },

    close(modal) {
      if (!modal) return;
      
      modal.classList.remove('modal--is-active');
      document.body.classList.remove('modal-open');
      
      const holder = modal.querySelector('[id^="QuickShopHolderCart-"]');
      if (holder) {
        holder.innerHTML = '';
      }
      
      modal.style.transform = '';
      modal.style.width = '';
      modal.style.height = '';
    },

    showModalError(holder, error) {
      holder.innerHTML = `
        <div class="cart-modal-error">
          <h3>Fejl ved indlæsning af produkt</h3>
          <p>Fejl: ${error.message}</p>
          <button onclick="this.closest('.modal--cart').classList.remove('modal--is-active'); document.body.classList.remove('modal-open');" 
                  class="btn">Luk</button>
        </div>
      `;
    },

    triggerFallbackQuickShop(productId, productHandle, button) {
      const originalEvent = new CustomEvent('quickshop:open', {
        detail: { productId, productHandle, button }
      });
      document.dispatchEvent(originalEvent);
    }
  };

  // ===========================
  // CART TITLE MANAGEMENT
  // ===========================
  
  const CartTitleManager = {
    init() {
      this.setupTitleWatcher();
    },

    async update() {
      const cart = await Utils.fetchCart();
      this.updateCount(cart.item_count);
    },

    updateCount(count) {
      const countElement = document.querySelector('.cart-title-count');
      if (countElement && countElement.textContent === `(${count})`) {
        return;
      }
      
      if (countElement) {
        countElement.textContent = `(${count})`;
      }
      
      // Backup attempts for theme rebuilds
      CONFIG.delays.titleUpdate.forEach(delay => {
        setTimeout(() => {
          const laterCountElement = document.querySelector('.cart-title-count');
          if (laterCountElement && laterCountElement.textContent !== `(${count})`) {
            laterCountElement.textContent = `(${count})`;
          }
        }, delay);
      });
    },

    setupTitleWatcher() {
      if (window.titleWatcherInitialized) return;
      
      const titleElement = document.querySelector(CONFIG.selectors.cartTitle);
      if (!titleElement) return;
      
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            setTimeout(() => {
              const countElement = document.querySelector('.cart-title-count');
              if (!countElement || !countElement.textContent.includes('(')) {
                this.update();
              }
            }, 50);
          }
        });
      });
      
      observer.observe(titleElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      window.titleWatcherInitialized = true;
    }
  };

  // ===========================
  // EVENT HANDLERS
  // ===========================
  
  const EventHandlers = {
    handleCartNotesToggle(checkbox) {
      const wrapper = document.getElementById('cartNotesWrapper');
      if (!wrapper) return;
      
      if (checkbox.checked) {
        wrapper.style.display = 'block';
        wrapper.offsetHeight; // Force reflow
        wrapper.style.opacity = '1';
        wrapper.style.transform = 'translateY(0)';
      } else {
        wrapper.style.opacity = '0';
        wrapper.style.transform = 'translateY(-10px)';
        setTimeout(() => {
          wrapper.style.display = 'none';
        }, 300);
      }
    },
  
    // check existing cart state
    async initializePaymentState() {
      try {
        const cart = await Utils.fetchCart();
        const paymentCheckboxes = document.querySelectorAll('input[name="deferred_payment"]');
        const moneyValue = document.querySelector('.chosen_payment');
        
        let hasCheckedPayment = false;
        let activePrice = '';
        
        // Check each checkbox against cart items
        paymentCheckboxes.forEach(checkbox => {
          const variantId = checkbox.getAttribute('data-variant-id');
          const price = checkbox.getAttribute('value');
          
          // Find if this payment product is in the cart
          const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
          
          if (cartItem) {
            // Payment product found in cart - check the box
            if (!checkbox.checked) {
              checkbox.checked = true;
            }
            hasCheckedPayment = true;
            activePrice = `${price},00 kr`;
          } else {
            // Payment product NOT found in cart - uncheck the box
            if (checkbox.checked) {
              checkbox.checked = false;
            }
          }
        });
        
        // Update money display based on actual cart state
        if (moneyValue) {
          moneyValue.textContent = hasCheckedPayment ? activePrice : '';
        }
        
      } catch (error) {
        console.error('Error checking payment state:', error);
      }
    },
  
    async handlePaymentChange(checkbox) {
      const paymentCheckboxes = document.querySelectorAll('input[name="deferred_payment"]');
      const moneyValue = document.querySelector('.chosen_payment');
      
      // Disable all checkboxes during processing to prevent race conditions
      paymentCheckboxes.forEach(cb => cb.disabled = true);
      
      try {
        if (checkbox.checked) {
          // First, remove all other payment products from cart
          const uncheckedPromises = [];
          
          paymentCheckboxes.forEach(otherCheckbox => {
            if (otherCheckbox !== checkbox && otherCheckbox.checked) {
              const oldVariantId = otherCheckbox.getAttribute('data-variant-id');
              if (oldVariantId) {
                uncheckedPromises.push(this.removePaymentFromCart(oldVariantId));
              }
              otherCheckbox.checked = false;
            }
          });
          
          // Wait for all removals to complete
          if (uncheckedPromises.length > 0) {
            await Promise.all(uncheckedPromises);
            // Add small delay to ensure cart state is updated
            await new Promise(resolve => setTimeout(resolve, 200));
          }
          
          // Then add the selected payment product
          const variantId = checkbox.getAttribute('data-variant-id');
          const price = checkbox.getAttribute('value');
          
          if (variantId) {
            await this.addPaymentToCart(variantId);
          }
          
          if (moneyValue) {
            moneyValue.textContent = `${price},00 kr`;
          }
          
        } else {
          // Remove the payment product from cart when unchecked
          const variantId = checkbox.getAttribute('data-variant-id');
          if (variantId) {
            await this.removePaymentFromCart(variantId);
          }
          
          if (moneyValue) {
            moneyValue.textContent = "";
          }
        }
      } catch (error) {
        console.error('Error handling payment change:', error);
        // Revert checkbox state on error
        checkbox.checked = !checkbox.checked;
      } finally {
        // Re-enable all checkboxes
        paymentCheckboxes.forEach(cb => cb.disabled = false);
      }
    },
    
    async addPaymentToCart(variantId) {
      try {
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ 
            id: variantId, 
            quantity: 1 
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || `HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Refresh cart drawer
        const cartDrawerIsOpen = document.getElementById('CartDrawer') && 
          document.getElementById('CartDrawer').classList.contains('drawer--is-open');
        
        if (cartDrawerIsOpen && typeof refreshCartDrawer === 'function') {
          refreshCartDrawer(false); // Manual action
        }
        
        return data;
      } catch (error) {
        console.error('Error adding payment product:', error);
        throw error; // Re-throw to handle in calling function
      }
    },
    
    async removePaymentFromCart(variantId) {
      try {
        
        const response = await fetch('/cart/change.js', {
          method: 'POST', 
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ 
            id: variantId, 
            quantity: 0 
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || `HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Refresh cart drawer
        const cartDrawerIsOpen = document.getElementById('CartDrawer') && 
          document.getElementById('CartDrawer').classList.contains('drawer--is-open');
        
        if (cartDrawerIsOpen && typeof refreshCartDrawer === 'function') {
          refreshCartDrawer(false); // Manual action
        }
        
        return data;
      } catch (error) {
        console.error('Error removing payment product:', error);
        throw error; // Re-throw to handle in calling function
      }
    },
  
    handleDropdownToggle(header) {
      const section = header.closest('.deferred-payments-section, .extra-options-section, .new-extra-options-section');
      if (!section) return;
      
      const content = section.querySelector('.dropdown-content');
      if (!content) return;
      
      section.classList.toggle('open');
      content.classList.toggle('open');
    }
  };

  // ===========================
  // MAIN CART MANAGER
  // ===========================
  
  const CartManager = {
    init() {
      this.setupEventDelegation();
      this.setupGlobalEventListeners();
      this.setupMutationObservers();
      this.reinitializeFeatures();
    },

    setupEventDelegation() {
      const cartDrawer = document.getElementById('CartDrawer');
      if (!cartDrawer) return;
      
      // Click events
      cartDrawer.addEventListener('click', (e) => {
        this.handleClick(e);
      });
      
      // Change events
      cartDrawer.addEventListener('change', (e) => {
        this.handleChange(e);
      });
    },

    handleClick(e) {
      // Handle remove buttons
      if (e.target.matches('.cart-remove-btn') || e.target.closest('.cart-remove-btn')) {
        e.preventDefault();
        e.stopPropagation();
        const button = e.target.matches('.cart-remove-btn') ? e.target : e.target.closest('.cart-remove-btn');
        CartOperations.removeItem(button);
        return;
      }
      
      // Handle quick add buttons
      if (e.target.matches('.cart-quick-shop-btn, .quick-shop-btn, .btn--quick-shop, [data-quick-shop]') || 
          e.target.closest('.cart-quick-shop-btn, .quick-shop-btn, .btn--quick-shop, [data-quick-shop]')) {
        e.preventDefault();
        e.stopPropagation();
        const button = e.target.matches('.cart-quick-shop-btn, .quick-shop-btn, .btn--quick-shop, [data-quick-shop]') ? 
                       e.target : e.target.closest('.cart-quick-shop-btn, .quick-shop-btn, .btn--quick-shop, [data-quick-shop]');
        ModalManager.openQuickShop(button);
        return;
      }
      
      // Handle deferred payment dropdown
      if (e.target.matches('.dropdown-header') || e.target.closest('.dropdown-header')) {
        const header = e.target.matches('.dropdown-header') ? e.target : e.target.closest('.dropdown-header');
        EventHandlers.handleDropdownToggle(header);
        return;
      }
      
      // Handle carousel arrows
      if (e.target.matches('.carousel-arrow--left') || e.target.closest('.carousel-arrow--left')) {
        e.preventDefault();
        e.stopPropagation();
        CarouselManager.slide('left');
        return;
      }
      
      if (e.target.matches('.carousel-arrow--right') || e.target.closest('.carousel-arrow--right')) {
        e.preventDefault();
        e.stopPropagation();
        CarouselManager.slide('right');
        return;
      }
      
      // Handle modal close buttons
      if (e.target.matches('.js-modal-close-cart, .drawer__close-button') || 
          e.target.closest('.js-modal-close-cart, .drawer__close-button')) {
        const modal = e.target.closest('.modal--cart');
        if (modal) {
          ModalManager.close(modal);
        }
        return;
      }
    },

    handleChange(e) {
      // Handle cart note toggle
      if (e.target.matches('#enableCartNotes')) {
        EventHandlers.handleCartNotesToggle(e.target);
        return;
      }
      
      // Handle deferred payment checkboxes
      if (e.target.matches('input[name="deferred_payment"]')) {
        EventHandlers.handlePaymentChange(e.target);
        return;
      }
    },

    setupGlobalEventListeners() {
      // Global modal close handler
      document.addEventListener('click', (e) => {
        if (e.target.matches('.js-modal-close-cart, .drawer__close-button') || 
            e.target.closest('.js-modal-close-cart, .drawer__close-button')) {
          
          const modal = e.target.closest('.modal--cart');
          if (modal) {
            e.preventDefault();
            e.stopPropagation();
            ModalManager.close(modal);
          }
        }
      });
      
      // Theme event listeners
      document.addEventListener('cart:updated', () => {
        this.reinitializeFeatures();
      });
      
      document.addEventListener('cart:build', () => {
        this.reinitializeFeatures();
      });
    },

    setupMutationObservers() {
      const cartDrawer = document.getElementById('CartDrawer');
      if (!cartDrawer) return;
      
      // Watch for drawer opening
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.id === 'CartDrawer' && target.classList.contains('drawer--is-open')) {
              setTimeout(() => {
                this.reinitializeFeatures();
              }, 100);
            }
          }
        });
      });
      
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    },

    reinitializeFeatures() {
      // Fix opacity issues immediately
      CarouselManager.fixImageOpacity();
      
      // Reinitialize carousel after DOM settles
      setTimeout(() => {
        CarouselManager.init();
      }, CONFIG.delays.carouselInit);
      
      // Additional opacity fixes at intervals
      CONFIG.delays.opacityFix.forEach(delay => {
        setTimeout(() => CarouselManager.fixImageOpacity(), delay);
      });
      
      // Update cart title
      this.updateTitle();
      
      // Initialize title watcher
      CartTitleManager.init();

      // extended shipping warranty
      if (window.updateShippingInsurance){
        window.updateShippingInsurance();
      }
      
      // pricematch insurance
      if (window.updatePricematchInsurance){
        window.updatePricematchInsurance();
      }

      // Initialize payment state - check existing cart items
      setTimeout(() => {
        EventHandlers.initializePaymentState();
      }, 100);
    },

    updateTitle() {
      CartTitleManager.update();
    },

    refreshDisplay() {
      // In cart drawer, use the new refresh function
      const cartDrawer = document.getElementById('CartDrawer');
      const cartDrawerIsOpen = cartDrawer && cartDrawer.classList.contains('drawer--is-open');
      
      if (cartDrawerIsOpen) {
        refreshCartDrawer();
        setTimeout(() => {
             safeRunOptionChecks();
             rebindExtraOptionButtons();
        }, 300);
      } else {
        setTimeout(() => {
          document.dispatchEvent(new Event('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }, CONFIG.delays.cartRefresh);
      }
    }
  };

  // ===========================
  // INITIALIZATION
  // ===========================
  
  // Initialize the cart manager - WAIT for cart data first
  (async function initCartManager() {
    // Wait for cart initialization
    if (!window.__cartInitialized) {
      await new Promise(resolve => {
        document.addEventListener('cart:initialized', resolve, { once: true });
      });
    }
    
    CartManager.init();
    
    // Set up initial features after a delay
    setTimeout(() => {
      CartManager.reinitializeFeatures();
    }, 500);
  })();
  
  // Add global functions to prevent errors
  window.toggleDropdown = function(element) {
    // console.log('Legacy toggleDropdown called, but handled by event delegation');
  };
 });


/**
 * LUXURY MODE
 * LUXURY MODE
 * LUXURY MODE
 * If cart contains any product with tag "preloved":
 *  - Hide all extra options UI
 *  - Auto-remove all ExtraOptions add-ons from the cart
 */

(function () {

  // ----------------------------------------------------------
  // Fetch cart (preferring CartData)
  // ----------------------------------------------------------
  async function fetchLuxuryCart() {
    // console.log('%c[LUXURY] Fetching cart…', 'color: #0099ff');

    // Use CartData without forcing refresh
    if (window.CartData && typeof CartData.getCart === 'function') {
      const cart = await CartData.getCart(); // Don't force, use cache
      // console.log('%c[LUXURY] Got cart from CartData:', 'color: #00ccff', cart);
      return cart;
    }

    // Fallback: fetch /cart.js only if CartData unavailable
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });

    const json = await res.json();
    // console.log('%c[LUXURY] Got cart from /cart.js:', 'color: #00ccff', json);
    return json;
  }

  // ----------------------------------------------------------
  // Identify luxury products in cart
  // ----------------------------------------------------------
  function cartHasLuxuryItem(cart) {
    // console.log('%c[LUXURY] Checking whether cart has luxury items…', 'color: #ffaa00');

    if (!cart || !Array.isArray(cart.items)) return false;

    const hasLuxury = cart.items.some(item => {
      const props = item.properties || {};

      const isLuxury =
        props._is_luxury === true ||
        props._is_luxury === 'true';

      if (isLuxury) {
        // console.log('%c[LUXURY] Found luxury item:', 'color: #ff8800', {
        //   title: item.title,
        //   vendor: item.vendor,
        //   properties: item.properties,
        // });
      }

      return isLuxury;
    });

    if (!hasLuxury) {
      // console.log('%c[LUXURY] No luxury items in cart.', 'color: #55aa55');
    }

    return hasLuxury;
  }

  // ----------------------------------------------------------
  // UI helpers: hide/show all extra options UIs
  // ----------------------------------------------------------
  function hideExtraOptionsUI() {
    // console.log('[LUXURY] Hiding extra options UI containers');

    // 1) Hide the new extra options wrapper + deferred payments section
    const wrappers = document.querySelectorAll(
      '.new-extra-options-section, .deferred-payments-section, .cart-gift-wrap-container, .viabill-pricetag'
    );
    wrappers.forEach(el => {
      el.dataset.__luxuryPrevDisplay = el.style.display || ''; // remember previous
      el.style.display = 'none';
      if (el.classList.contains('viabill-pricetag')) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('position', 'absolute', 'important');
        el.style.setProperty('width', '0', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      }
    });

    // 2) Hide each individual ExtraOption container (from extraOptionsConfig)
    if (window.extraOptionsConfig && Array.isArray(window.extraOptionsConfig)) {
      window.extraOptionsConfig.forEach(cfg => {
        if (!cfg.containerSelector) return;
        const el = document.querySelector(cfg.containerSelector);
        if (!el) return;

        // Only stash display once (so we don’t overwrite some theme change)
        if (!el.dataset.__luxuryPrevDisplay) {
          el.dataset.__luxuryPrevDisplay = el.style.display || '';
        }
        el.style.display = 'none';
      });
    }
  }

  function showExtraOptionsUI() {
    // console.log('[LUXURY] Showing extra options UI containers');

    // 1) Show the wrapper + deferred payments again
    const wrappers = document.querySelectorAll(
      '.new-extra-options-section, .deferred-payments-section, .cart-gift-wrap-container, .viabill-pricetag'
    );
    wrappers.forEach(el => {
      if (!el) return;
  
      if (el.classList.contains('new-extra-options-section')) {
        // Extra options accordion section should be block
        el.style.display = 'block';
      }
  
      if (el.classList.contains('deferred-payments-section')) {
        // Deferred payments should be block
        el.style.display = 'block';
      }

      if (el.classList.contains('cart-gift-wrap-container')) {
        // gift wrapping should be block
        el.style.display = 'block';
      }

      if (el.classList.contains('viabill-pricetag')) {
        // Remove all the aggressive hiding styles we needed for this container
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('position');
        el.style.removeProperty('width');
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('opacity');
        el.style.removeProperty('pointer-events');
        
        // Then set it back
        el.style.display = 'block';
        el.style.opacity = '1';
        el.style.height = '25px';
        el.style.pointerEvents = 'auto';
        // console.log('[LUXURY] → Showing .viabill-pricetag (block)');
      }
    });

    // 2) Show each individual ExtraOption container again
    if (window.extraOptionsConfig && Array.isArray(window.extraOptionsConfig)) {
      window.extraOptionsConfig.forEach(cfg => {
        if (!cfg.containerSelector) return;
        const el = document.querySelector(cfg.containerSelector);
        if (!el) return;

        const prev = el.dataset.__luxuryPrevDisplay;
        el.style.display = prev !== undefined ? prev : '';
      });
    }
  }

  // ----------------------------------------------------------
  // Detect which gift wrap system is active
  // ----------------------------------------------------------
  function isUsingNewGiftWrapSystem() {
    const container = document.querySelector('.cart-gift-wrap-container');
    if (!container) return false;
    
    // New system has both data-basic-variant-id and data-message-variant-id
    const hasBasic = container.hasAttribute('data-basic-variant-id');
    const hasMessage = container.hasAttribute('data-message-variant-id');
    
    return hasBasic && hasMessage;
  }

  // ----------------------------------------------------------
  // Remove all extra options from cart
  // ----------------------------------------------------------
  async function removeAllExtraOptions(cartFromCaller) {
    // console.log('[LUXURY] Removing all extra options…');
    let cart = cartFromCaller;

    // Ensure we have a cart object
    if (!cart) {
      try {
        if (window.CartData && typeof CartData.getCart === 'function') {
          // console.log('[LUXURY] Fetching cart via CartData.getCart(true)…');
          cart = await CartData.getCart(true);
        } else {
          // console.log('[LUXURY] Fetching cart directly via /cart.js…');
          const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          cart = await res.json();
        }
      } catch (e) {
        console.error('[LUXURY] Failed to fetch cart in removeAllExtraOptions', e);
        return;
      }
    }

    if (!cart || !Array.isArray(cart.items)) {
      console.warn('[LUXURY] removeAllExtraOptions: cart has no items');
      return;
    }

    // Build list of gift wrap variant IDs based on which system is active
    const giftWrapVariantIds = [];
    const container = document.querySelector('.cart-gift-wrap-container');
    
    if (container) {
      const usingNewSystem = isUsingNewGiftWrapSystem();
      
      if (usingNewSystem) {
        // NEW SYSTEM: Get both consolidated variant IDs
        const basic = container.getAttribute('data-basic-variant-id');
        const message = container.getAttribute('data-message-variant-id');
        if (basic) giftWrapVariantIds.push(basic);
        if (message) giftWrapVariantIds.push(message);
        // console.log('[LUXURY] Using NEW gift wrap system - variants:', giftWrapVariantIds);
      } else {
        // OLD SYSTEM: Get the single variant ID
        const variantId = container.getAttribute('data-variant-id');
        if (variantId) giftWrapVariantIds.push(variantId);
        // console.log('[LUXURY] Using OLD gift wrap system - variant:', variantId);
      }
    }

    // Decide what counts as an extra option line
    const extraLineItems = cart.items.filter(item => {
      const p = item.properties || {};
      const isAddOn = p._addOn === true || p._addOn === 'true';
      const isDeferred = p._deferredPayment === true || p._deferredPayment === 'true';
      const hasGiftwrapFlag = p._is_giftwrap === 'true' || p._is_giftwrap === true;
      const variantId = String(item.id || item.variant_id);
      const isGiftWrapVariant = giftWrapVariantIds.includes(variantId);

      // Do not auto-remove consolidated gift wrap lines
      // when they are explicitly marked as giftwrap
      if (hasGiftwrapFlag) {
        return false;
      }

      return isAddOn || isDeferred || isGiftWrapVariant;
    });

    // console.log(
    //   '[LUXURY] Extra line items to remove:',
    //   extraLineItems.map(i => ({
    //     title: i.title,
    //     key: i.key,
    //     properties: i.properties
    //   }))
    // );

    if (!extraLineItems.length) {
      // console.log('[LUXURY] No extra options to remove');
      return;
    }

    // Build a single /cart/update.js payload
    const updates = {};
    extraLineItems.forEach(item => {
      updates[item.key] = 0; // quantity 0
    });

    try {
      // console.log('[LUXURY] Sending single /cart/update.js for all extra options…', updates);

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!res.ok) {
        console.error('[LUXURY] /cart/update.js failed with status', res.status);
        //const errData = await res.json().catch(() => null);
        // console.log('[LUXURY] Error payload:', errData);
        return;
      }

      const data = await res.json().catch(() => null);
      // console.log('[LUXURY] /cart/update.js response:', data);

    } catch (e) {
      console.error('[LUXURY] Error while updating extra options with /cart/update.js', e);
      return;
    }

    // 4) Refresh drawer + counts ONCE
    // console.log('[LUXURY] Finished removing extra options, refreshing drawer/counts…');
    if (typeof refreshCartDrawer === 'function') {
      // console.log('[LUXURY] Calling refreshCartDrawer(true)');
      refreshCartDrawer(true);
    } else if (typeof updateCartCountsOnly === 'function') {
      // console.log('[LUXURY] Calling updateCartCountsOnly() (no drawer refresh available)');
      updateCartCountsOnly();
    }
  }

  // ----------------------------------------------------------
  // Global flags
  // ----------------------------------------------------------
  window.__luxuryModeActive = false;
  let luxuryCleanupInProgress = false;
  let lastLuxuryFlag = null;
  let luxuryCheckTimer = null;

  function scheduleLuxuryCheck() {
    if (luxuryCheckTimer) {
      clearTimeout(luxuryCheckTimer);
    }

    luxuryCheckTimer = setTimeout(() => {
      luxuryCheckTimer = null;
      enforceLuxuryMode().catch(err => {
        console.error('[LUXURY] enforceLuxuryMode error', err);
      });
    }, 150);
  }

  // ----------------------------------------------------------
  // Sync deferred payment + gift wrap checkboxes with real cart
  // ----------------------------------------------------------
  async function syncLuxuryCheckboxesWithCart() {
    try {
      // console.log('[LUXURY] syncLuxuryCheckboxesWithCart → syncing from real cart');

      const cart = await fetchLuxuryCart();
      if (!cart || !Array.isArray(cart.items)) return;

      const attrs = cart.attributes || {};
      const attrCredit = attrs.credit ? String(attrs.credit) : null;

      // Find all deferred-payment lines currently in the cart
      const deferredLines = cart.items.filter((item) => {
        const props = item.properties || {};
        return props._deferredPayment === true || props._deferredPayment === 'true';
      });

      const hasAnyDeferredLine = deferredLines.length > 0;
      // console.log('[LUXURY] Deferred lines in cart:', deferredLines);

      // Target the actual deferred-payment checkboxes
      const paymentCheckboxes = document.querySelectorAll(
        '#CartDrawer input[name="attributes[credit]"], form[action*="/cart"] input[name="attributes[credit]"]'
      );

      paymentCheckboxes.forEach((checkbox) => {
        const variantId =
          checkbox.getAttribute('data-variant-id') || checkbox.dataset.variantId;

        if (!variantId) {
          checkbox.checked = false;
          return;
        }

        // If there are no deferred lines at all, force everything off
        if (!hasAnyDeferredLine) {
          // console.log('[LUXURY] No deferred lines – forcing checkbox OFF', {
          //   checkboxId: checkbox.id,
          //   variantId
          // });
          checkbox.checked = false;
          return;
        }

        // If there are deferred lines, we sync normally
        const hasDeferredLine = deferredLines.some(
          (item) => String(item.variant_id) === String(variantId)
        );

        const shouldBeChecked =
          hasDeferredLine ||
          (attrCredit && attrCredit === String(variantId));

        // console.log('[LUXURY] Deferred checkbox sync', {
        //   checkboxId: checkbox.id,
        //   variantId,
        //   hasDeferredLine,
        //   attrCredit,
        //   shouldBeChecked
        // });

        checkbox.checked = !!shouldBeChecked;
      });

      // Gift wrapping checkbox sync - ONLY FOR OLD SYSTEM
      // New system doesn't use a checkbox, so skip this
      if (!isUsingNewGiftWrapSystem()) {
        const giftWrapContainer =
          document.querySelector('#CartDrawer .cart-gift-wrap-container') ||
          document.querySelector('.cart-gift-wrap-container');

        const giftWrapCheckbox =
          giftWrapContainer?.querySelector('input[name="attributes[gift-wrapping]"]') ||
          document.querySelector('#gift-wrapping');

        if (giftWrapContainer && giftWrapCheckbox) {
          const attrs = cart.attributes || {};
          const attrVal = attrs['gift-wrapping'];

          // Variant id from DOM, same as Liquid:
          // value="{{ giftWrappingProduct.variants.first.id }}"
          const giftVariantId =
            giftWrapContainer.getAttribute('data-variant-id') ||
            giftWrapCheckbox.value ||
            null;

          // Does the cart have a line with that variant?
          const hasGiftLine = giftVariantId
            ? cart.items.some(item => {
                const variantId = String(item.id || item.variant_id);
                return variantId === String(giftVariantId);
              })
            : false;

          // Is the attribute truthy?
          const hasGiftAttr = !!attrVal;

          // Match the Liquid condition:
          // {% if gift_wrap and cart.attributes.gift-wrapping %} checked{% endif %}
          const shouldBeChecked = hasGiftLine && hasGiftAttr;

          // console.log('[LUXURY] Giftwrap sync (OLD system)', {
          //   giftVariantId,
          //   attrVal,
          //   hasGiftLine,
          //   hasGiftAttr,
          //   shouldBeChecked
          // });

          giftWrapCheckbox.checked = shouldBeChecked;
        }
      }

      // --- we make sure the old gift wrap container is hidden in luxury mode ----
      if (window.__luxuryModeActive && !isUsingNewGiftWrapSystem()) {
        const oldGiftWrapContainer = document.querySelector('.cart-gift-wrap-container.old__system');
        if (oldGiftWrapContainer) {
          oldGiftWrapContainer.style.display = 'none';
        }
      }
    } catch (err) {
      console.error('[LUXURY] Failed to sync checkboxes with cart', err);
    }
  }

  // ----------------------------------------------------------
  // Main enforcement logic
  // ----------------------------------------------------------
  async function enforceLuxuryMode() {
    // console.log('[LUXURY] Enforcing luxury mode…');

    let cart;
    try {
      // console.log('[LUXURY] Fetching cart…');
      // use the real helper name
      cart = await fetchLuxuryCart();
      // console.log('[LUXURY] Got cart in enforceLuxuryMode:', cart);
    } catch (e) {
      console.error('[LUXURY] Failed to fetch cart for luxury mode', e);
      return;
    }

    const hasLuxury = cartHasLuxuryItem(cart);
    // console.log('[LUXURY] hasLuxury?', hasLuxury);

    // if nothing changed since last time, we bail out early
    if (lastLuxuryFlag === hasLuxury) {
      // console.log('[LUXURY] hasLuxury unchanged since last run – skipping further work');
      window.__luxuryModeActive = hasLuxury; // keeps global in sync
      return;
    }

    lastLuxuryFlag = hasLuxury;

    window.__luxuryModeActive = hasLuxury;

    // CASE 1: NO LUXURY
    if (!hasLuxury) {
      // console.log('[LUXURY] No luxury items – turning OFF luxury mode');

      // 1) Show UI again
      if (typeof showExtraOptionsUI === 'function') {
        showExtraOptionsUI();
      }

      // 2) Let ExtraOptionsManager re-evaluate its logic
      if (typeof ExtraOptionsManager !== 'undefined') {
        setTimeout(() => {
          try {
            // console.log('[LUXURY] Triggering ExtraOptionsManager.checkAllOptions() after luxury OFF');
            ExtraOptionsManager.checkAllOptions();

            if (Array.isArray(ExtraOptionsManager.options)) {
              ExtraOptionsManager.options.forEach(opt => {
                if (typeof opt.syncButtonFromCart === 'function') {
                  // console.log('[LUXURY] Re-syncing button for option id:', opt.id);
                  opt.syncButtonFromCart();
                } else {
                  // console.log('[LUXURY] Option has no syncButtonFromCart:', opt.id);
                }
              });
            }
          } catch (err) {
            console.error('[LUXURY] Error calling ExtraOptionsManager.checkAllOptions()', err);
          }
        }, 50);
      }

      // After cart UI + payment state have finished doing their thing,
      // force the deferred + gift wrap checkboxes to match the real cart.
      setTimeout(() => {
        syncLuxuryCheckboxesWithCart();
      }, 250); 

      return;
    }

    // CASE 2: LUXURY PRESENT
    // console.log('[LUXURY] MODE ACTIVATED — hiding extra options');
    if (typeof hideExtraOptionsUI === 'function') {
      hideExtraOptionsUI();
    }

    if (luxuryCleanupInProgress) {
      // console.log('[LUXURY] Cleanup already in progress – not removing again');
      return;
    }

    luxuryCleanupInProgress = true;

    try {
      // console.log('[LUXURY] Removing all extra options…');
      await removeAllExtraOptions(cart);
      // console.log('[LUXURY] Finished removing extra options');

      // In case theme payment code reacts strangely, re-sync from cart
      setTimeout(() => {
        syncLuxuryCheckboxesWithCart();
      }, 150);

    } catch (e) {
      console.error('[LUXURY] Error during extra option cleanup', e);
    } finally {
      luxuryCleanupInProgress = false;
      // console.log('[LUXURY] Cleanup flag reset');
    }
  }

  // ----------------------------------------------------------
  // Hook into cart lifecycle
  // ----------------------------------------------------------
  document.addEventListener('DOMContentLoaded', async function () {
    // Wait for cart initialization
    if (!window.__cartInitialized) {
      await new Promise(resolve => {
        document.addEventListener('cart:initialized', resolve, { once: true });
      });
    }
    // console.log('[LUXURY] DOMContentLoaded → checking luxury mode', 'color: #9999ff');
    scheduleLuxuryCheck();
  });
  
  document.addEventListener('cart:updated', function () {
    // console.log('[LUXURY] cart:updated → checking luxury mode', 'color: #9999ff');
    scheduleLuxuryCheck();
  });

  // sync checkboxes (deferred payments) after cart updates, but only when NOT in luxury mode
  document.addEventListener('cart:updated', function () {
    if (!window.__luxuryModeActive) {
      // console.log('[LUXURY] cart:updated → syncing luxury-related checkboxes');
      setTimeout(() => {
        syncLuxuryCheckboxesWithCart();
      }, 80);
    }
  });
  
  // document.addEventListener('cart:build', function () {
  //   console.log('[LUXURY] cart:build → checking luxury mode', 'color: #9999ff');
  //   scheduleLuxuryCheck();
  // });
})();


/*
 * END OF LUXURY MODE
 * END OF LUXURY MODE
 * END OF LUXURY MODE
 */



/* monitors cart to see if any warranty products are orphaned and removes them */

 (function() {
  'use strict';
  
  let isCheckingWarranties = false;
  let warrantyCheckTimeout = null;
  let lastWarrantyCheckTime = 0;
  const MIN_WARRANTY_CHECK_INTERVAL = 500;
  let isRemovingWarranties = false;

  let recentlyAddedToCart = false;
  let addToCartTimeout = null;

  window.skipNextWarrantyCheck = function() {
    recentlyAddedToCart = true;
    
    if (addToCartTimeout) {
      clearTimeout(addToCartTimeout);
    }
    
    addToCartTimeout = setTimeout(() => {
      recentlyAddedToCart = false;
      // console.log('[Warranty] Add to cart cooldown expired');
    }, 2000);
  };
  
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  async function fetchCartForWarranty(retries = 2) {
    const now = Date.now();
    const timeSinceLastCheck = now - lastWarrantyCheckTime;
    if (timeSinceLastCheck < MIN_WARRANTY_CHECK_INTERVAL) {
      const waitTime = MIN_WARRANTY_CHECK_INTERVAL - timeSinceLastCheck;
      await new Promise(resolve => setTimeout(resolve, waitTime));
    }

    for (let i = 0; i < retries; i++) {
      try {
        lastWarrantyCheckTime = Date.now();
        
        const response = await fetch('/cart.js', {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin'
        });
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        
        const data = await response.json();
        // console.log('[Warranty] Cart fetched successfully');
        return data;
        
      } catch (error) {
        console.error(`[Warranty] Fetch attempt ${i + 1} failed:`, error);
        
        if (i === retries - 1) {
          throw error;
        }
        
        const waitTime = Math.pow(2, i) * 500;
        await new Promise(resolve => setTimeout(resolve, waitTime));
      }
    }
  }

  // --- Helper: remove a cart item node immediately from the DOM ---
function removeCartItemNodeByKey(key) {
  // Look for a cart line element with matching data-key
  let el = document.querySelector(`.cart__item[data-key="${key}"]`);
  
  // Fallback: if a nested element has data-key, find its closest cart__item
  if (!el) {
    const child = document.querySelector(`[data-key="${key}"]`);
    if (child) el = child.closest('.cart__item');
  }

  if (el) {
    el.remove(); // Instantly remove from drawer UI
  }
}
  
  window.checkWarrantyOrphans = async function(force = false) {
    if (recentlyAddedToCart && !force) {
      // console.log('[Warranty] Skipping check - items recently added to cart');
      return;
    }
    
    if (isCheckingWarranties || isRemovingWarranties) {
      // console.log('[Warranty] Check already in progress or removal in progress, skipping');
      return;
    }
  
    if (warrantyCheckTimeout) {
      clearTimeout(warrantyCheckTimeout);
      warrantyCheckTimeout = null;
    }
  
    isCheckingWarranties = true;
  
    try {
      let cart;
      try {
        cart = await fetchCartForWarranty(2);
      } catch (error) {
        console.error('[Warranty] All fetch attempts failed:', error);
        return;
      }
      
      // console.log('[Warranty] === FULL CART DEBUG ===');
      // console.log('[Warranty] Total items in cart:', cart.items.length);
      
      // Log ALL items
      cart.items.forEach((item, index) => {
        // console.log(`[Warranty] Item ${index + 1}:`, {
        // variant_id: item.variant_id,
        // title: item.product_title,
        // _warranty_key: item.properties?._warranty_key || 'none',
        // _parent_key: item.properties?._parent_key || 'none',
        // _is_warranty: item.properties?._is_warranty || 'none'
        // });
      });
      
      const validWarrantyKeys = new Set();
      cart.items.forEach(item => {
        if (item.properties && item.properties._warranty_key) {
          validWarrantyKeys.add(item.properties._warranty_key);
          // console.log('[Warranty] Found parent product with key:', item.properties._warranty_key);
        }
      });
      
      // console.log('[Warranty] Valid warranty keys:', Array.from(validWarrantyKeys));
      
      const orphanedWarranties = cart.items.filter(item => {
        const isWarranty = item.properties && item.properties._is_warranty === 'true';
        if (!isWarranty) return false;
        
        const parentKey = item.properties._parent_key;
        const hasValidParent = validWarrantyKeys.has(parentKey);
        
        // console.log('[Warranty] Checking warranty:', {
        //   variant_id: item.variant_id,
        //   parent_key: parentKey,
        //   has_valid_parent: hasValidParent,
        //   will_be_removed: !hasValidParent
        // });
        
        return !hasValidParent;
      });
      
      // console.log('[Warranty] Orphaned warranties found:', orphanedWarranties.length);
      
      if (orphanedWarranties.length > 0) {
        // console.log('[Warranty] === STARTING REMOVAL ===');
        isRemovingWarranties = true;
        
        try {
          for (const warranty of orphanedWarranties) {
            // console.log('[Warranty] Removing warranty variant:', warranty.key);
            
            try {
              const removeResponse = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: warranty.key,
                  quantity: 0
                })
              });
              
              const removeResult = await removeResponse.json();

              // Instantly reflect in UI
              removeCartItemNodeByKey(warranty.key);
              if (typeof updateCartCountsOnly === 'function') updateCartCountsOnly();

              // short pause before next
              await new Promise(resolve => setTimeout(resolve, 100));
              
            } catch (error) {
              console.error('[Warranty] Error removing warranty:', error);
            }
          }
          
          // console.log('[Warranty] === ALL REMOVALS COMPLETE ===');
          await new Promise(resolve => setTimeout(resolve, 300));
          
          if (typeof refreshCartDrawer === 'function') {
            // console.log('[Warranty] Refreshing cart drawer');
            refreshCartDrawer(true);
          }
          
        } finally {
          setTimeout(() => {
            isRemovingWarranties = false;
            // console.log('[Warranty] Removal flag cleared');
          }, 1000);
        }
      } else {
        // console.log('[Warranty] No orphaned warranties found');
      }
      
    } catch (error) {
      console.error('[Warranty] Error checking warranties:', error);
    } finally {
      isCheckingWarranties = false;
    }
  };
  
  const debouncedWarrantyCheck = debounce(checkWarrantyOrphans, 500);
  
  const cartDrawerObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('drawer--is-open')) {
          // console.log('[Warranty] Cart drawer opened, checking warranties');
          debouncedWarrantyCheck();
        }
      }
    });
  });

  setTimeout(() => {
    const cartDrawer = document.querySelector('#CartDrawer');
    
    if (cartDrawer) {
      cartDrawerObserver.observe(cartDrawer, { 
        attributes: true, 
        attributeFilter: ['class'] 
      });
      // console.log('[Warranty] Monitor initialized - watching #CartDrawer');
    } else {
      console.warn('[Warranty] #CartDrawer not found, relying on events only');
    }
  }, 1000);
  
  // console.log('[Warranty] Monitor initialized');
  
})();


/* prevent redirect to cart page when a cart item is removed using the remove a tag */
function preventRedirectOnCartItemRemoval(link) {
  const cartItem = link.closest('.cart__item');
  const quantityInput = cartItem.querySelector('.js-qty__num');
  if (quantityInput) {
    quantityInput.value = 0;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    // console.log('Prevent redirect to cart page when removing item from cart');
  }
  return false;
}


function promotionalBannerSlider(sliderContainer) {
  if (!sliderContainer) return;
  
  const wrapper = sliderContainer.closest('.promotional-banner__wrapper');
  if (!wrapper) return;
  
  const prevArrow = wrapper.querySelector('.promotional-banner__arrow--prev');
  const nextArrow = wrapper.querySelector('.promotional-banner__arrow--next');
  const slider = sliderContainer.querySelector('.promotional-banner__slider');
  
  if (!prevArrow || !nextArrow || !slider) return;
  
  if (sliderContainer.dataset.initialized === 'true') return;
  sliderContainer.dataset.initialized = 'true';
  
  function updateArrowVisibility() {
    const containerWidth = sliderContainer.offsetWidth;
    const scrollLeft = sliderContainer.scrollLeft;
    const scrollWidth = sliderContainer.scrollWidth;
    const maxScroll = scrollWidth - containerWidth;
    
    if (scrollLeft <= 1) {
      prevArrow.classList.add('promotional-banner__arrow--hidden');
    } else {
      prevArrow.classList.remove('promotional-banner__arrow--hidden');
    }
    
    if (scrollLeft >= maxScroll - 1) {
      nextArrow.classList.add('promotional-banner__arrow--hidden');
    } else {
      nextArrow.classList.remove('promotional-banner__arrow--hidden');
    }
  }
  
  function scrollSlider(direction) {
    const firstItem = slider.querySelector('.promotional-banner__item');
    if (!firstItem) return;
    
    const itemWidth = firstItem.offsetWidth;
    const computedStyle = window.getComputedStyle(slider);
    const gap = parseFloat(computedStyle.gap) || 0;
    const scrollAmount = itemWidth + gap;
    
    const currentScroll = sliderContainer.scrollLeft;
    let targetScroll;
    
    if (direction === 'next') {
      targetScroll = currentScroll + scrollAmount;
    } else {
      targetScroll = currentScroll - scrollAmount;
    }
    
    sliderContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }
  
  prevArrow.addEventListener('click', function(e) {
    e.preventDefault();
    scrollSlider('prev');
  });
  
  nextArrow.addEventListener('click', function(e) {
    e.preventDefault();
    scrollSlider('next');
  });
  
  sliderContainer.addEventListener('scroll', updateArrowVisibility);
  
  let resizeTimer;
  const resizeHandler = function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateArrowVisibility, 100);
  };
  window.addEventListener('resize', resizeHandler);
  
  sliderContainer._resizeHandler = resizeHandler;
  
  updateArrowVisibility();
  
  setTimeout(updateArrowVisibility, 100);
}

function promotionalBannerSliders() {
  const sliderContainers = document.querySelectorAll('.promotional-banner__container[data-slider]');
  sliderContainers.forEach(function(container) {
    promotionalBannerSlider(container);
  });
}
DOMready(function() {
  promotionalBannerSliders();
});

document.addEventListener('DOMContentLoaded', function() {
  promotionalBannerSliders();
});